import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import PrimaryButton from '../../jsx/components/button/primaryButton'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentPage } from '../../feature/userData/userData';
import InputField from '../../jsx/components/fields/inputField';
import TextArea from '../../jsx/components/fields/textArea';
import { Modal, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import { ImageCropper } from '../scan/ImageCropper';
import RecogObj from '../../service/api/recognition/captureAndRecognize';
import html2canvas from 'html2canvas';
import ImagePreviewer from '../../jsx/components/imagePreviewer/imagePreviewer';
import imageCompression from 'browser-image-compression';
import { createUpdateProjectApi } from '../../service/api/ticket/createUpdateProject';
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import { getAISuggestionsApi } from '../../service/api/object/getAISuggestions';
import { IoIosQrScanner } from 'react-icons/io';
import { MdChecklistRtl, MdDraw } from 'react-icons/md';
import { CgNotes } from 'react-icons/cg';
import { saveProjectSuggestionsApi } from '../../service/api/ticket/saveProjectSuggestions';
import { getSavedProjectSuggestionsApi } from '../../service/api/ticket/getSavedProjectSuggestions';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import deleteProjectSuggestionApi from '../../service/api/ticket/deleteProjectSuggestion';
import { urlPattern } from "../../validations/validation";
import emptyListImg from '../../media/images/servicesAssets/emptyListImg.png'
import { createPurchaseItem } from '../../service/api/ticket/createPurchaseItem';
import updatePurchaseItem from '../../service/api/ticket/updatePurchaseItem';
import deletePurchaseItem from '../../service/api/ticket/deletePurchaseItem';
import { getProjectsApi } from '../../service/api/ticket/getProjects';
import deleteProjectDetailApi from '../../service/api/ticket/deleteProjectDetail';
import { getProjectDetailApi } from '../../service/api/ticket/getProjectDetail';
import { callNote } from '../../service/api/callHistory/callNote';
import { deleteCallLogNoteById } from '../../service/api/callHistory/deleteCallLogNoteById';
import { TbRulerMeasure } from 'react-icons/tb';
import ocr from '../../service/api/recognition/ocr';
import DrawingDemo from '../moreTabs/drawingDemo';
import Scan from '../scan/scan';
import RangeInput from '../../jsx/components/fields/rangeInput';
import { callNoteDetails } from '../../service/api/callHistory/callNoteDetails';
import logo from "../../icons/photos/chillLogo.png";
import { bulkDeleteProjectStepsApi } from '../../service/api/ticket/bulkDeleteProjectSteps';
import DefineProjectImage from '../../media/images/DIYAssets/DefineProjectImage.jpeg';
import DocumentDIYProjectImage from '../../media/images/DIYAssets/DocumentDIYProjectImage.jpeg';
import EnhancePlanDIYProject from '../../media/images/DIYAssets/EnhancePlanDIYProject.jpeg';
import updateCallNoteApi from '../../service/api/callHistory/updateCallNote';
import skillSummaryImg from "../../media/images/DIYAssets/skillSummaryImg.png";
import costTimeImg from "../../media/images/DIYAssets/costTimeImg.png";
import toolsImg from "../../media/images/DIYAssets/toolsImg.png";
import captureBeforeImg from "../../media/images/DIYAssets/captureBeforeImg.jpeg";
import { IoSend } from "react-icons/io5";
import { getChatHistoryApi } from '../../service/api/ticket/getChatHistory';
import createUpdateChatHistoryApi from '../../service/api/ticket/createUpdateChatHistory';
import deleteProjectChatHistoryApi from '../../service/api/ticket/deleteProjectChatHistory';
import { RiCloseFill, } from "react-icons/ri";



const DIYproject = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [projectsArr, setProjectsArr] = useState([]);
    const [projectId, setProjectId] = useState(localStorage.getItem('projectId') ? localStorage.getItem('projectId') : "");

    const [getProjectsLoading, setGetProjectsLoading] = useState(false);
    const [deleteProjectLoading, setDeleteProjectLoading] = useState(false);
    const [getProjectDetailLoading, setGetProjectDetailLoading] = useState(false);

    const [createProjectStep, setCreateProjectStep] = useState(localStorage.getItem('DIYprojectStep') ? localStorage.getItem('DIYprojectStep') : 0.2);
    const [projectTitle, setProjectTitle] = useState(``);
    const [projectDescription, setProjectDescription] = useState(localStorage.getItem('DIYprojectDesc') ? localStorage.getItem('DIYprojectDesc') : ``);
    const [projectBudget, setProjectBudget] = useState(``);
    const [projectCompletionDate, setProjectCompletionDate] = useState(``);
    const [projectCompletionDateUnix, setProjectCompletionDateUnix] = useState(``);
    const [projectPriorityLevel, setProjectPriorityLevel] = useState(``);
    const [projectCreatedDate, setProjectCreatedDate] = useState(Math.floor(Date.now() / 1000));

    const [projectTitleErr, setProjectTitleErr] = useState(false);
    const [projectDescriptionErr, setProjectDescriptionErr] = useState(false);

    const [toggleForAddImage, setToggleForAddImage] = useState(false);
    const [createUpdateProjectLoading, setCreateUpdateProjectLoading] = useState(false);
    const [getAIsuggestionsLoading, setGetAIsuggestionsLoading] = useState(false);

    const [AIsuggestionsArr, setAIsuggestionsArr] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [editText, setEditText] = useState("");
    const [isAdding, setIsAdding] = useState(false);
    const [newSuggestion, setNewSuggestion] = useState("");

    const [saveSuggestionsLoading, setSaveSuggestionsLoading] = useState(false);
    const [savedProjectSuggestionsArr, setSavedProjectSuggestionsArr] = useState([]);
    const [savedProjectSuggestionsLoading, setSavedProjectSuggestionsLoading] = useState(false);

    const [summaryProjectSuggestionsArr, setSummaryProjectSuggestionsArr] = useState([]);
    const [planProjectSuggestionsArr, setPlanProjectSuggestionsArr] = useState([]);
    const [isSummaryExpanded, setIsSummaryExpanded] = useState(true);
    const [isPlanExpanded, setIsPlanExpanded] = useState(true);


    const [particularProjectSuggestionObj, setParticularProjectSuggestionObj] = useState({});
    const [deleteProjectSuggestionLoading, setDeleteProjectSuggestionLoading] = useState(false);
    const [modalTriggerSavedProjectSuggestions, setModalTriggerSavedProjectSuggestions] = useState(false);
    const [toggleForSavedProjectSuggestions, setToggleForSavedProjectSuggestions] = useState('');

    const [toggleForShoppingListDIY, setToggleForShoppingListDIY] = useState(1);
    const [toggleForNotesDIY, setToggleForNotesDIY] = useState(1);

    const [modalTriggerProjects, setModalTriggerProjects] = useState(false);
    const [modalTriggerAIterms, setModalTriggerAIterms] = useState(false);
    const [AITermsAndConditions, setAITermsAndConditions] = useState(localStorage.getItem('projectId') ? true : false);
    const [AITermsAndConditionsErr, setAITermsAndConditionsErr] = useState(false);


    const [responseMsg, setResponseMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);

    const hiddenFileInput = useRef(0);

    const [selectedFile, setSelectedFile] = useState([]);
    const [selectedFileLimit, setSelectedFileLimit] = useState("");
    const [deleteIconVisiblity, setDeleteIconVisiblity] = useState({
        visibility: "hidden",
    });
    const [discussionVal, setDiscussionVal] = useState("");
    const [noteObject, setNoteObject] = useState({});
    const [saveLoading, setSaveLoading] = useState(false);
    const [isNoteEdit, setIsNoteEdit] = useState(false);


    const [toggleForCameraActions, setToggleForCameraActions] = useState(false);

    const [imageForOCR, setImageForOCR] = useState(null);
    const [uploadImageForOcr, setUploadImageForOcr] = useState(null);
    const [ocrLoading, setOcrLoading] = useState(false);
    const [ocrText, setOcrText] = useState("");

    const checkHW = useRef(null);
    const [imgMaxHeight, setImgMaxHeight] = useState(0);
    const [imgMaxWidth, setImgMaxWidth] = useState(0);

    const [aiChatMessage, setAiChatMessage] = useState('');
    const [chatHistoryArr, setChatHistoryArr] = useState([]);
    const [chatHistoryLoading, setChatHistoryLoading] = useState(false);
    const [createUpdateChatLoading, setCreateUpdateChatLoading] = useState(false);
    const [projectChatHistoryId, setProjectChatHistoryId] = useState('');
    const [deleteAIChatHistoryLoading, setDeleteAIChatHistoryLoading] = useState(false);

    const [modalTriggerForDeleteAIChatHistory, setModalTriggerForDeleteAIChatHistory] = useState(false);
    const handleOpenModalDeleteAIChatHistory = () => setModalTriggerForDeleteAIChatHistory(true);
    const handleCloseModalDeleteAIChatHistory = () => setModalTriggerForDeleteAIChatHistory(false);

    const [modalTriggerForCallingAISuggestions, setModalTriggerForCallingAISuggestions] = useState(false);
    const handleOpenModalCallingAISuggestions = () => setModalTriggerForCallingAISuggestions(true);
    const handleCloseModalCallingAISuggestions = () => setModalTriggerForCallingAISuggestions(false);

    const [modalTriggerForAddPhoto, setModalTriggerForAddPhoto] = useState(false)
    const handleOpenModalAddPhoto = () => setModalTriggerForAddPhoto(true);
    const handleCloseModalAddPhoto = () => setModalTriggerForAddPhoto(false);


    const [modalTriggerForSaveImageToNotes, setModalTriggerForSaveImageToNotes] = useState(false);

    const [modalTriggerForMeasuringInstruction, setModalTriggerForMeasuringInstruction] = useState(false);
    const [difficultyRangeValue, setDifficultyRangeValue] = useState(1);
    const handleOpenModalMeasuringInstruction = () => setModalTriggerForMeasuringInstruction(true);
    const handleCloseModalMeasuringInstruction = () => setModalTriggerForMeasuringInstruction(false);

    const handleOpenModalForSaveImageToNotes = () => setModalTriggerForSaveImageToNotes(true);
    const handleCloseModalForSaveImageToNotes = () => {
        setModalTriggerForSaveImageToNotes(false);
        setImageForOCR(null);
        setUploadImageForOcr(null);
    }

    const instructionsArr = [
        // 'Define your project.',
        // 'Capture the "Before"',
        // 'Build your plan using Chillls tool box',
        'AI will provide plan suggestions.',
        'Add Photos and Notes.',
        'Screen drawing',
        'Shopping List',
        'Virtual Measuring',
        'Parts and Manuals sourcing',
    ];
    const priorityLevelArr = [1, 2, 3];
    function handleChangeDifficultyValue(e) {
        setDifficultyRangeValue(e.target.value)
    }
    useEffect(() => {
        dispatch(setCurrentPage("Create project"))
    }, [])

    useEffect(() => {
        const height = checkHW?.current?.getBoundingClientRect()?.height;
        const width = checkHW?.current?.getBoundingClientRect()?.width;
        setImgMaxWidth(width);
        setImgMaxHeight(height);

        return () => {
            localStorage.getItem('projectId') && localStorage.removeItem('projectId');
            localStorage.getItem('DIYprojectStep') && localStorage.removeItem('DIYprojectStep');
            localStorage.getItem('DIYprojectDesc') && localStorage.removeItem('DIYprojectDesc');
            localStorage.getItem('ticket_id') && localStorage.removeItem('ticket_id');
        }
    }, []);



    // useEffect(() => {
    //     console.log('AIsuggestionsArr', AIsuggestionsArr);
    // }, [AIsuggestionsArr])

    // useEffect(() => {
    //     console.log('selectedItems', selectedItems);
    // }, [selectedItems])

    // useEffect(() => {
    //     console.log('projectId', projectId);
    // }, [projectId])

    const handleOpenProjectSuggestionsModal = () => setModalTriggerSavedProjectSuggestions(true);
    const handleCloseProjectSuggestionsModal = () => {
        setModalTriggerSavedProjectSuggestions(false);


        const id = setTimeout(() => {
            setToggleForShoppingListDIY(1);
            setToggleForNotesDIY(1);
            // setParticularProjectSuggestionObj({});
            setIsShoppingItemEdit(false);
            handleClearNotesStates();
        }, 500)

        handleCloseCreatePurchaseItem();
    }

    const handleOpenProjectsModal = () => setModalTriggerProjects(true);
    const handleCloseProjectsModal = () => {
        setModalTriggerProjects(false);
        setProjectId('');
    }

    // Reference to scroll to bottom
    const bottomRef = useRef(null);

    // Scroll to bottom when "Add Suggestion" is triggered
    useEffect(() => {
        if (isAdding) {
            bottomRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [isAdding]);


    // Function to toggle selection
    const handleSelection = (element) => {
        setSelectedItems((prevSelected) =>
            prevSelected.includes(element)
                ? prevSelected.filter((item) => item !== element) // Deselect if already selected
                : [...prevSelected, element] // Select the item
        );
    };

    // Function to handle edit click
    const handleEditClick = (index) => {
        setEditIndex(index);
        setEditText(AIsuggestionsArr[index]); // Set text in the textarea
    };

    // Function to save edited text
    const handleSaveEdit = () => {
        if (editText.trim() === "") return;

        setAIsuggestionsArr((prevArr) =>
            prevArr.map((item, idx) => (idx === editIndex ? editText : item))
        );

        // If the item is in selectedItems, update it there as well
        setSelectedItems((prevSelected) =>
            prevSelected.map((item) => (item === AIsuggestionsArr[editIndex] ? editText : item))
        );

        setEditIndex(null);
    };

    // Function to add a new suggestion
    const handleAddSuggestion = () => {
        if (newSuggestion.trim() === "") return;

        setAIsuggestionsArr((prevArr) => [...prevArr, newSuggestion]); // Add to main array
        setSelectedItems((prevSelected) => [...prevSelected, newSuggestion]); // Also select the new item

        setNewSuggestion(""); // Clear input
        setIsAdding(false); // Hide input field
    };


    const handleChangeProjectTitle = (e) => {
        setProjectTitleErr(false);
        setProjectTitle(e?.target?.value);
    };

    const handleChangeProjectTitleBlurCheck = () => {
        if (projectTitle === ``) {
            setProjectTitleErr(true);
        }
    }

    const [confirmationForAIcall, setConfirmationForAIcall] = useState(false);

    useEffect(() => {
        if (projectId) {
            setConfirmationForAIcall(true);
        }
    }, [projectId])

    const hanldeChangeProjectDescription = (e) => {
        setProjectDescriptionErr(false);


        if (projectId && confirmationForAIcall) {
            handleOpenModalCallingAISuggestions();

        } else {
            setProjectDescription(e?.target?.value);
        }

    }

    const handleChangeProjectDescBlurCheck = () => {
        if (projectDescription === `` || projectDescription?.length < 10) {
            setProjectDescriptionErr(true);
        }
    }

    const handleChangeProjectBudget = (e) => {
        setProjectBudget(e.target.value.replace(/[^\d.]/g, '').replace(/(\.\d*)\./g, '$1'));
    }

    const handleChangeProjectCompletionDate = (e) => {

        const inputDate = e?.target?.value;

        if (!inputDate) return;
        const unixTimestamp = inputDate ? Math.floor(new Date(inputDate).getTime() / 1000) : '';

        // console.log(unixTimestamp);
        setProjectCompletionDate(inputDate);
        setProjectCompletionDateUnix(unixTimestamp);
    }

    const handleChangeProjectPriorityLevel = (val) => {
        setProjectPriorityLevel(val);
    }

    const handleCreateProjectStep = (value) => {
        setCreateProjectStep(value);
    };

    // Camera codes

    const videoRef = useRef(null);
    const streamRef = useRef(null); // Reference to store the media stream
    const [cameraInitializedLoading, setCameraInitializedLoading] = useState(false);
    const [isCameraAllowed, setIsCameraAllowed] = useState(true);
    const [screenShotLoading, setScreenShotLoading] = useState(false);

    // Attachment images for creating the DIY project
    const [uploadAttachedImage0, setUploadAttachedImage0] = useState(null);
    const [attachedImage0, setAttachedImage0] = useState(null);
    const [attachedImage0Id, setAttachedImage0Id] = useState('');

    const [uploadAttachedImage1, setUploadAttachedImage1] = useState(null);
    const [attachedImage1, setAttachedImage1] = useState(null);
    const [attachedImage1Id, setAttachedImage1Id] = useState('');

    const [uploadAttachedImage2, setUploadAttachedImage2] = useState(null);
    const [attachedImage2, setAttachedImage2] = useState(null);
    const [attachedImage2Id, setAttachedImage2Id] = useState('');

    const [uploadImageLimit, setUploadImageLimit] = useState(false);

    const [toggleForCreateDIYServiceRequest, setToggleForCreateDIYServiceRequest] = useState(false);
    const [notesCounter, setNotesCounter] = useState(0)
    const [listCounter, setListCounter] = useState(0)
    const uploadPicRef = useRef();
    const handleClickUploadPicture = () => {
        uploadPicRef.current.click();
    };

    useEffect(() => {
        const id = setTimeout(() => {
            setUploadImageLimit(false);
        }, 3000);
        return () => clearTimeout(id);
    }, [uploadImageLimit])

    // Attachment Upload 1
    const attachedImage1Ref = useRef();

    const handleClickAttachedImage0 = () => {
        attachedImage1Ref.current.click();
    }
    const handleAttachedImage0 = (e) => {
        if (e.target.files) {
            setUploadAttachedImage0(e.target.files[0]);
            setAttachedImage0(URL.createObjectURL(e.target.files[0]))
        }
    }

    const deleteAttachedImage0 = () => {
        setUploadAttachedImage0(null);
        setAttachedImage0(null)
    }

    const handleClickAttachedImage1 = () => {
        attachedImage1Ref.current.click();
    }
    const handleAttachedImage1 = (e) => {
        if (e.target.files) {
            setUploadAttachedImage1(e.target.files[0]);
            setAttachedImage1(URL.createObjectURL(e.target.files[0]))
        }
    }

    const deleteAttachedImage1 = () => {
        setUploadAttachedImage1(null);
        setAttachedImage1(null)
    }

    const deleteAttachedImage2 = () => {
        setUploadAttachedImage2(null);
        setAttachedImage2(null)
    }

    // Function to access the camera
    const getCameraStream = async () => {
        setCameraInitializedLoading(true);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: 'environment' }, // Default to the back camera
                audio: false,
            });
            setIsCameraAllowed(true);
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
            if (streamRef.current) {
                streamRef.current.getTracks().forEach((track) => track.stop());
            }
            streamRef.current = stream; // Store the stream in a reference
        } catch (error) {
            console.error('Error accessing the camera:', error);
            setIsCameraAllowed(false);
        } finally {
            setCameraInitializedLoading(false); // Set loading to false once the camera is initialized
        }
    };


    // Stop the camera stream
    const stopCameraStream = () => {
        if (streamRef.current) {
            const tracks = streamRef.current.getTracks();
            tracks.forEach((track) => track.stop());
            streamRef.current = null; // Clear the stream reference
            if (videoRef.current) {
                videoRef.current.srcObject = null;
            }
        }
    };

    useEffect(() => {
        return () => {
            stopCameraStream();
        };
    }, []);

    // Sending the cropped images
    const [imgSrc, setImgSrc] = useState(null);
    const canvasRef = useRef(null);
    const [crop, setCrop] = useState({ x: 100, y: 100, width: 200, height: 200 });


    const canvasVideoRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);
    const [capturedImage, setCapturedImage] = useState(null);

    const capture = async () => {
        // const imageSrc = videoRef.current.getScreenshot();
        // if (videoRef.current) {
        //     // videoRef.current.pause(); // Pause the video stream
        //     // setIsPaused(true);

        //     const canvas = canvasVideoRef.current;
        //     const context = canvas.getContext('2d');
        //     canvas.width = videoRef.current.videoWidth;
        //     canvas.height = videoRef.current.videoHeight;
        //     context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

        //     // Convert to data URL and store the image
        //     const imageDataUrl = canvas.toDataURL('image/png');

        //     setImgSrc(imageDataUrl);
        // }

        if (videoRef.current) {
            setScreenShotLoading(true)
            try {
                // Capture screenshot of video element using html2canvas
                const canvas = await html2canvas(videoRef.current, {
                    useCORS: true, // Ensure cross-origin resources are captured
                    scale: 1, // Control scaling for better quality
                });

                // Convert the canvas to an image URL
                const imageDataUrl = canvas.toDataURL('image/png');

                // Store the captured image
                setImgSrc(imageDataUrl);
            } catch (error) {
                console.error('Error capturing screenshot:', error);
            } finally {
                setScreenShotLoading(false)
            }
        }
    };

    const [objectCategoryName, setObjectCategoryName] = useState('');

    const handleContinue = (e) => {
        if (canvasRef.current) {
            //   setResponseBox(true)
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');

            // Create a new canvas for the cropped area
            const croppedCanvas = document.createElement('canvas');
            croppedCanvas.width = crop.width;
            croppedCanvas.height = crop.height;
            const croppedCtx = croppedCanvas.getContext('2d');

            // Draw the cropped area from the original canvas onto the new canvas
            croppedCtx.drawImage(
                canvas,
                crop.x, crop.y, crop.width, crop.height,
                0, 0, crop.width, crop.height
            );
            setCapturedImage(croppedCanvas.toDataURL('image/jpeg'))

            if (attachedImage0 === null) {
                setAttachedImage0(croppedCanvas.toDataURL('image/jpeg'))
            } else if (attachedImage1 === null) {
                setAttachedImage1(croppedCanvas.toDataURL('image/jpeg'))
            } else if (attachedImage2 === null) {
                setAttachedImage2(croppedCanvas.toDataURL('image/jpeg'))
            }


            // Get the cropped image data as a base64 string
            const croppedImageData = croppedCanvas.toDataURL('image/jpeg').replace("data:", "").replace(/^.+,/, "");

            // Convert the base64 string to a Blob
            const byteCharacters = atob(croppedImageData);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpeg' });

            if (uploadAttachedImage0 === null) {
                setUploadAttachedImage0(blob)
            } else if (uploadAttachedImage1 === null) {
                setUploadAttachedImage1(blob)
            } else if (uploadAttachedImage2 === null) {
                setUploadAttachedImage2(blob)
            }

            // Pass the blob back to the parent component or use it as needed
            //   setResponseBox(true)
            //   setScanImageCheck(false);

            //   setLoading(true);
            //   setImage(blob);

            let formData = new FormData();

            formData.append("image", blob);

            setToggleForAddImage(false);
            setImgSrc(null);
            stopCameraStream();

            if (createProjectStep == 3) {
                handleCreateDIYProject(e, blob);
            }

            // For recognizing the category for creating service
            // dispatch(
            //     RecogObj(
            //         formData,
            //         (res) => {

            //             console.log(res.data.data.predicted_object_category, "categroy")
            //             setObjectCategoryName(
            //                 res.data.data.predicted_object_category
            //             );
            //         },
            //         () => {
            //             // setLoading(false);
            //         }
            //     )
            // );
        }
    };

    const [imgUploadLoading, setImgUploadLoading] = useState(false)
    const handleUploadPicture = async (e) => {
        if (e.target.files) {
            // setImage(e.target.files[0]);


            let formData = new FormData();

            const file = e.target.files[0];

            if (file && file.size > 1024 * 1024) { // Check if the file size is greater than 1 MB
                try {
                    setImgUploadLoading(true);
                    const options = {
                        maxSizeMB: 0.350, // Maximum size in MB
                        maxWidthOrHeight: 1920, // Maximum width or height
                        useWebWorker: true, // Use web worker for faster compression
                    };
                    const compressedFile = await imageCompression(file, options);
                    // console.log('Original file size:', (file.size / 1024 / 1024).toFixed(2), 'MB');
                    // console.log('Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');

                    if (attachedImage0 === null) {
                        setUploadAttachedImage0(compressedFile);
                        setAttachedImage0(URL.createObjectURL(compressedFile))
                    } else if (attachedImage1 === null) {
                        setUploadAttachedImage1(compressedFile);
                        setAttachedImage1(URL.createObjectURL(compressedFile))
                    } else if (attachedImage2 === null) {
                        setUploadAttachedImage2(compressedFile);
                        setAttachedImage2(URL.createObjectURL(compressedFile))
                    }

                    formData.append("image", compressedFile, "scanned_image.png");

                    setToggleForAddImage(false);
                    setImgSrc(null);
                    stopCameraStream();

                    handleCloseModalAddPhoto();

                    if (createProjectStep == 3) {
                        handleCreateDIYProject(e, file);
                    }

                    // For recognizing the category for creating service
                    // dispatch(
                    //     RecogObj(
                    //         formData,
                    //         (res) => {
                    //             setObjectCategoryName(res.data.data.predicted_object_category);
                    //         },
                    //         () => {
                    //             // setLoading(false);
                    //         }
                    //     )
                    // );
                } catch (error) {
                    console.error('Error compressing the image:', error);
                    setImgUploadLoading(false);
                } finally {
                    setImgUploadLoading(false);
                }
            } else {
                // setUploadAttachedImage0(file);
                // setAttachedImage0(URL.createObjectURL(file));
                formData.append("image", file, "scanned_image.png");

                if (attachedImage0 === null) {
                    setUploadAttachedImage0(file);
                    setAttachedImage0(URL.createObjectURL(file))
                } else if (attachedImage1 === null) {
                    setUploadAttachedImage1(file);
                    setAttachedImage1(URL.createObjectURL(file))
                } else if (attachedImage2 === null) {
                    setUploadAttachedImage2(file);
                    setAttachedImage2(URL.createObjectURL(file))
                }

                setToggleForAddImage(false);
                setImgSrc(null);
                stopCameraStream();
                handleCloseModalAddPhoto();

                if (createProjectStep == 3) {
                    handleCreateDIYProject(e, file);
                }

                // For recognizing the category for creating service
                // dispatch(
                //     RecogObj(
                //         formData,
                //         (res) => {

                //             setObjectCategoryName(res.data.data.predicted_object_category);
                //         },
                //         () => {
                //             // setLoading(false);
                //         }
                //     )
                // );
            }
        }
    };

    const pauseAndCapture = () => {
        if (videoRef.current) {
            videoRef.current.pause(); // Pause the video stream
            setIsPaused(true);

            // Capture the current frame
            const canvas = canvasVideoRef.current;
            const context = canvas.getContext('2d');
            canvas.width = videoRef.current.videoWidth;
            canvas.height = videoRef.current.videoHeight;
            context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

            // Convert to data URL and store the image
            const imageDataUrl = canvas.toDataURL('image/png');
            setCapturedImage(imageDataUrl);
        }
    };

    const resumeVideo = () => {
        if (videoRef.current) {
            videoRef.current.play(); // Resume the video stream
            setIsPaused(false);
        }
    };


    const [openDoc, setOpenDoc] = React.useState(false);
    const [imageAttachURL, setImageAttachURL] = useState('');
    const [notesMessage, setNotesMessage] = useState("");

    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => {
        setOpenDoc(false);
        setNotesMessage('');
        setNoteObject({});
        setIsNoteEdit(false);
        setDiscussionVal('');
    }


    const handleCreateDIYProject = (e, file) => {
        e?.preventDefault();

        // if (projectTitle === '') {
        //     setProjectTitleErr(true);
        // }

        if (projectDescription === '' || projectDescription?.length < 10) {
            setProjectDescriptionErr(true);
        }

        if (!AITermsAndConditions) {
            setAITermsAndConditionsErr(true);
        }

        if (projectDescription !== '' && projectDescription?.length > 10 && AITermsAndConditions) {
            setCreateUpdateProjectLoading(true);
            let formData = new FormData();

            formData.append("user_id_ids", localStorage.getItem("user_id"));
            localStorage.getItem("ticket_id") && formData.append("ticket_id", localStorage.getItem("ticket_id"));
            formData.append("project_id_ids", projectId);
            formData.append("project_title_chr", projectTitle);
            formData.append("category_name_chr", objectCategoryName)
            formData.append("project_description_chr", projectDescription);
            projectBudget && formData.append("budget_in_cents_float", parseFloat(projectBudget * 100));
            projectPriorityLevel && formData.append("priority_int", projectPriorityLevel);
            // formData.append("difficulty_level_int", difficultyRangeValue);
            // formData.append("project_status_int", '');
            projectCompletionDateUnix && formData.append("completion_date_dtm", projectCompletionDateUnix);

            uploadAttachedImage0 != null && formData.append("attachment_id_ids0", attachedImage0Id || '');
            (uploadAttachedImage0 != null || file) && formData.append("attachment0", uploadAttachedImage0 || file);
            uploadAttachedImage1 != null && formData.append("attachment_id_ids1", attachedImage1Id || '');
            uploadAttachedImage1 != null && formData.append("attachment1", uploadAttachedImage1);
            uploadAttachedImage2 != null && formData.append("attachment_id_ids2", attachedImage2Id || '');
            uploadAttachedImage2 != null && formData.append("attachment2", uploadAttachedImage2);


            dispatch(createUpdateProjectApi(formData, (res) => {
                setCreateUpdateProjectLoading(false);
                // console.log(res.data.data, "Create update project data");

                if (createProjectStep === 1) {
                    handleCreateProjectStep(2);
                    callNoteData(res?.data?.data?.project_id_ids);
                }

                if (createProjectStep === 3 && !file) {
                    setProjectId('');
                    handleClearProjectStates();
                    navigate('/myDiyProject');
                }

                setUploadAttachedImage0(null);

                setProjectId(res?.data?.data?.project_id_ids);
                setProjectTitle(res?.data?.data?.project_title_chr);
                res?.data?.data?.created_date_dtm && setProjectCreatedDate(res?.data?.data?.created_date_dtm);


                !confirmationForAIcall && getAISuggestionsFn(res?.data?.data?.project_id_ids);

                setConfirmationForAIcall(true);

            }, (err) => {
                setCreateUpdateProjectLoading(false);

                setResponseMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }))
        }
    }

    const getAISuggestionsFn = (respProjectId) => {
        // setGetAIsuggestionsLoading(false);
        if (projectDescription !== '' && projectDescription?.length > 10) {
            setGetAIsuggestionsLoading(true);
            let formData = new FormData();

            formData.append("problem_statement_chr", projectDescription);

            dispatch(getAISuggestionsApi(formData, (res) => {
                setGetAIsuggestionsLoading(false);
                // console.log(res.data.data, "AI suggestions");
                setAIsuggestionsArr(res?.data?.data?.suggestions);

                setProjectTitle(res?.data?.data?.title)

                saveAllAIProjectSuggestionsFn(respProjectId, res?.data?.data?.suggestions);


            }, (err) => {
                setGetAIsuggestionsLoading(false);

                setResponseMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }))
        }
    }

    const saveAllAIProjectSuggestionsFn = (respProjectId, respAIsuggestionsArr) => {

        if (respAIsuggestionsArr.length > 0) {
            setSaveSuggestionsLoading(true);

            const selectedSuggestionsArrSend = respAIsuggestionsArr.map((suggestion) => ({
                project_suggestion_id_ids: "",
                suggestion_description_chr: suggestion,
                step_completion_status_int: 0,
            }));

            let details = {
                project_id_ids: projectId || respProjectId,
                project_suggestion_list: selectedSuggestionsArrSend,
            };
            dispatch(
                saveProjectSuggestionsApi(
                    details,
                    (res) => {
                        setSaveSuggestionsLoading(false);
                        // console.log(res.data.data, "Save project suggestions data");
                        // handleCreateProjectStep(4)
                        setSelectedItems([]);

                        getSavedProjectSuggestionsFn(respProjectId);
                    },
                    (err) => {
                        setSaveSuggestionsLoading(false);

                        setResponseMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        }
        // else {
        //     handleCreateProjectStep(4)
        //     getSavedProjectSuggestionsFn();
        // }
    }

    const saveProjectSuggestionsFn = (e) => {
        e?.preventDefault();

        if (selectedItems.length > 0) {
            setSaveSuggestionsLoading(true);

            const selectedSuggestionsArrSend = selectedItems.map((suggestion) => ({
                project_suggestion_id_ids: "",
                suggestion_description_chr: suggestion,
                step_completion_status_int: 0,
            }));

            let details = {
                project_id_ids: projectId,
                project_suggestion_list: selectedSuggestionsArrSend,
            };
            dispatch(
                saveProjectSuggestionsApi(
                    details,
                    (res) => {
                        setSaveSuggestionsLoading(false);
                        // console.log(res.data.data, "Save project suggestions data");
                        handleCreateProjectStep(4)
                        setSelectedItems([]);

                        getSavedProjectSuggestionsFn();
                    },
                    (err) => {
                        setSaveSuggestionsLoading(false);

                        setResponseMsg(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        } else {
            handleCreateProjectStep(4)
            getSavedProjectSuggestionsFn();
        }
    }

    const getSavedProjectSuggestionsFn = (respProjectId) => {

        // if (!projectId) return

        setSavedProjectSuggestionsLoading(true);
        let formData = new FormData();

        formData.append("project_id_ids", projectId || respProjectId);
        formData.append("pagination_flag", 0);
        // formData.append("page_index", 1);
        // formData.append("page_size", 1000)
        // formData.append("search_area", '');

        dispatch(getSavedProjectSuggestionsApi(formData, (res) => {
            setSavedProjectSuggestionsLoading(false);
            // console.log(res.data.data, "Get saved project suggestions data");
            setSavedProjectSuggestionsArr(res?.data?.data);
            setSummaryProjectSuggestionsArr(res?.data?.summary);
            setPlanProjectSuggestionsArr(res?.data?.plan);

            setNotesCounter(res.data.notes_count)
            setListCounter(res.data.purchase_list_count)
        }, (err) => {
            setSavedProjectSuggestionsLoading(false);

            setResponseMsg(err.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    const getSavedProjectSuggestionsAfterCheckboxFn = (respProjectId) => {

        // if (!projectId) return

        // setSavedProjectSuggestionsLoading(true);
        let formData = new FormData();

        formData.append("project_id_ids", projectId || respProjectId);
        formData.append("pagination_flag", 0);
        // formData.append("page_index", 1);
        // formData.append("page_size", 1000)
        // formData.append("search_area", '');

        dispatch(getSavedProjectSuggestionsApi(formData, (res) => {
            setSavedProjectSuggestionsLoading(false);
            // console.log(res.data.data, "Get saved project suggestions data");
            setSavedProjectSuggestionsArr(res?.data?.data);
            setSummaryProjectSuggestionsArr(res?.data?.summary);
            setPlanProjectSuggestionsArr(res?.data?.plan);

            setNotesCounter(res.data.notes_count)
            setListCounter(res.data.purchase_list_count)
        }, (err) => {
            setSavedProjectSuggestionsLoading(false);

            setResponseMsg(err.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    const handleDeleteProjectSuggestionFn = (element) => {
        if (!particularProjectSuggestionObj?.project_suggestion_id_ids) {
            return
        }

        setDeleteProjectSuggestionLoading(true)

        let details = {
            project_suggestion_id_ids: particularProjectSuggestionObj?.project_suggestion_id_ids,
        };

        dispatch(
            deleteProjectSuggestionApi(details, (res) => {
                setDeleteProjectSuggestionLoading(false)
                setResponseMsg(res.data.message);
                handleCloseProjectSuggestionsModal();

                getSavedProjectSuggestionsFn();

            }, (err) => {
                setDeleteProjectSuggestionLoading(false)
                setResponseMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }

    const USDollar = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    // Shopping list functions here 
    const [purchaseItemId, setPurchaseItemId] = useState();
    const [itemName, setItemName] = useState("");
    const [quantity, setQuantity] = useState("");
    const [totalEstimatedCost, setTotalEstimatedCost] = useState("");
    const [purchaseLink, setPurchaseLink] = useState("");
    const [itemDescription, setItemDescription] = useState("");

    const [itemNameErr, setItemNameErr] = useState(false);
    const [quantityErr, setQuantityErr] = useState(false);
    const [totalEstimatedCostErr, setTotalEstimatedCostErr] = useState(false);
    const [purchaseLinkErr, setPurchaseLinkErr] = useState(false);
    const [itemDescriptionErr, setItemDescriptionErr] = useState(false);

    const [purchaseLoading, setPurchaseLoading] = useState(false);
    const [totalCost, setTotalCost] = useState(0);
    const [shoppingItemId, setShoppingItemId] = useState('');
    const [isShoppingItemEdit, setIsShoppingItemEdit] = useState(false);

    const handleItemName = (e) => {
        setItemNameErr(false);
        setItemName(e.target.value);
    };

    const handleQuantity = (e) => {
        setQuantityErr(false);
        setQuantity(e.target.value.replace(/\D/g, ""));
    };

    const handleTotalEstimatedCost = (e) => {
        setTotalEstimatedCostErr(false);
        setTotalEstimatedCost(
            e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
        );
    };

    const handlePurchaseLink = (e) => {
        setPurchaseLinkErr(false);
        setPurchaseLink(e.target.value);
    };

    const handleDescription = (e) => {
        setItemDescriptionErr(false);
        setItemDescription(e.target.value);
    };

    const handleItemNameBlurCheck = () => {
        if (itemName === "") {
            setItemNameErr(true);
        }
    };

    const handleSubmitPurchase = (e) => {
        e?.preventDefault();

        if (itemName === "") {
            setItemNameErr(true);
        }

        if (itemName) {
            // console.log(itemName, quantity, totalEstimatedCost, purchaseLink, itemDescription)
            setPurchaseLoading(true);

            let data = new FormData();
            data.append("user_id_ids", localStorage.getItem("user_id") || "");
            // data.append("call_log_id_ids", localStorage.getItem("call_log_id") || "");
            // data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
            data.append("project_suggestion_id_ids", particularProjectSuggestionObj?.project_suggestion_id_ids || "");
            data.append("item_name_chr", itemName);
            data.append("quantity_int", quantity == "" ? 0 : quantity);
            data.append(
                "estimated_price_float",
                parseFloat(
                    (quantity == "" ? 0 : quantity * totalEstimatedCost).toFixed(2)
                )
            );
            data.append("description_chr", itemDescription);
            data.append("purchase_link_chr", purchaseLink);

            dispatch(
                createPurchaseItem(
                    data,
                    (res) => {
                        setPurchaseLoading(false);
                        setToasterType("success");
                        // setToggleForPurchase(1);
                        setToggleForShoppingListDIY(1);
                        handleCloseProjectSuggestionsModal();

                        handleCloseCreatePurchaseItem();


                        getSavedProjectSuggestionsFn();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //   setHandleToaster(false);
                        // }, 11000);
                    },
                    (err) => {
                        setPurchaseLoading(false);
                        setResponseMsg(err.data.message);
                        setToasterType("error");

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        }
    };

    const handleCloseCreatePurchaseItem = (e) => {
        e?.preventDefault();
        setItemNameErr(false);
        setQuantityErr(false);
        setTotalEstimatedCostErr(false);
        setPurchaseLinkErr(false);
        setItemDescriptionErr(false);

        setPurchaseItemId('');
        setItemName("");
        setQuantity("");
        setTotalEstimatedCost("");
        setPurchaseLink("");
        setItemDescription("");
    };

    const handleUpdatePurchaseList = (element, e) => {
        e.stopPropagation();

        // setPurchaseLoading(true)

        setPurchaseItemId(element?.item_id_ids);
        setItemName(element?.item_name_chr);
        setQuantity(element?.quantity_int);
        setTotalEstimatedCost(
            (element?.estimated_price_float / element?.quantity_int).toFixed(2)
        );
        setPurchaseLink(element?.purchase_link_chr);
        setItemDescription(element?.description_chr);
        setToggleForShoppingListDIY(2)
        // handleShowPurchaseList();
    };

    const handleUpdatePurchase = (e) => {
        e?.preventDefault();
        setPurchaseLoading(true);
        let data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id") || "");
        data.append("item_id_ids", purchaseItemId);
        // data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        // data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        data.append("item_name_chr", itemName);
        data.append("quantity_int", quantity == "" ? 0 : quantity);
        data.append(
            "estimated_price_float",
            parseFloat(
                (quantity == "" ? 0 : quantity * totalEstimatedCost).toFixed(2)
            )
        );
        data.append("description_chr", itemDescription);
        data.append("purchase_link_chr", purchaseLink);

        dispatch(
            updatePurchaseItem(
                data,
                (res) => {
                    setPurchaseLoading(false);
                    setResponseMsg(res.data.message);
                    setToasterType("success");
                    // setToggleForPurchase(1);

                    setToggleForShoppingListDIY(1);
                    handleCloseProjectSuggestionsModal();

                    handleCloseCreatePurchaseItem();


                    getSavedProjectSuggestionsFn();


                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //   setHandleToaster(false);
                    // }, 11000);
                },
                (err) => {
                    setPurchaseLoading(false);
                    setResponseMsg(err.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    const handleViewPurchaseItemDesktop = (element, val) => {
        setPurchaseItemId(element?.item_id_ids);
        setItemName(element?.item_name_chr);
        setQuantity(element?.quantity_int);
        setTotalEstimatedCost(element?.estimated_price_float);
        setPurchaseLink(element?.purchase_link_chr);
        setItemDescription(element?.description_chr);

        setToggleForShoppingListDIY(val);
    };

    const handleDeletePurchaseList = (element, e) => {
        e.stopPropagation();
        setPurchaseLoading(true);

        // setPurchaseItemId(element?.item_id_ids);

        let details = {
            user_id_ids: localStorage.getItem("user_id") || "",
            item_id_ids: purchaseItemId,
        };

        dispatch(
            deletePurchaseItem(
                details,
                (res) => {
                    setPurchaseLoading(false);
                    setResponseMsg(res.data.message);
                    setToasterType("success");

                    setToggleForShoppingListDIY(1);
                    handleCloseProjectSuggestionsModal();

                    handleCloseCreatePurchaseItem();


                    getSavedProjectSuggestionsFn();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //   setHandleToaster(false);
                    // }, 11000);
                },
                (err) => {
                    setPurchaseLoading(false);
                    setResponseMsg(err.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    const getProjectsFn = () => {

        setGetProjectsLoading(true);
        let formData = new FormData();
        formData.append("user_id_ids", localStorage.getItem("user_id"));
        formData.append("pagination_flag", 0);
        // formData.append("page_index", 1);
        // formData.append("page_size", 1000)
        // formData.append("search_area", '');


        dispatch(getProjectsApi(formData, (res) => {
            setGetProjectsLoading(false);
            // console.log(res?.data?.data, "My project data");
            setProjectsArr(res?.data?.data);

        }, (err) => {
            setGetProjectsLoading(false);

            setResponseMsg(err.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    // useEffect(() => {
    //     getProjectsFn();
    // }, [])

    const handleDeleteProjectDeatilFn = (element) => {
        if (!projectId) {
            return
        }

        setDeleteProjectLoading(true)

        let details = {
            project_id_ids: projectId,
        };

        dispatch(
            deleteProjectDetailApi(details, (res) => {
                setDeleteProjectLoading(false)
                setResponseMsg(res.data.message);
                handleCloseProjectsModal();

                // getProjectsFn();

                navigate('/myDiyProject')

            }, (err) => {
                setDeleteProjectLoading(false)
                setResponseMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }

    const getProjectDetailFn = (id) => {

        setGetProjectDetailLoading(true)

        let details = {
            project_id_ids: id || projectId,
        };

        dispatch(
            getProjectDetailApi(details, (res) => {
                setGetProjectDetailLoading(false)
                // console.log(res?.data, "Particular project data");
                // setResponseMsg(res.message);

                setProjectTitle(res?.data?.project_title_chr || '');
                setProjectCreatedDate(res?.data?.created_date_dtm || '');
                setProjectDescription(res?.data?.project_description_chr || '');
                setProjectBudget((res?.data?.budget_in_cents_float / 100) || '');
                if (res?.data?.completion_date_unix_datetime) {
                    setProjectCompletionDateUnix(res?.data?.completion_date_unix_datetime || '');

                    const date = new Date(res?.data?.completion_date_unix_datetime * 1000); // Convert to milliseconds

                    const formattedDate = date.toISOString().split('T')[0]; // "YYYY-MM-DD"
                    setProjectCompletionDate(formattedDate);
                }

                // setProjectPriorityLevel(res?.data?.priority_level_int || '');
                setProjectPriorityLevel(res?.data?.priority_int || '');
                setDifficultyRangeValue(res?.data?.difficulty_level_int || '');

                if (res?.data?.project_attachments?.length > 0) {
                    res?.data?.project_attachments[0]?.url && setAttachedImage0(res?.data?.project_attachments[0]?.url || '');
                    res?.data?.project_attachments[0]?.project_attachments_id_ids && setAttachedImage0Id(res?.data?.project_attachments[0]?.project_attachments_id_ids || '');

                    res?.data?.project_attachments[1]?.url && setAttachedImage1(res?.data?.project_attachments[1]?.url || '');
                    res?.data?.project_attachments[1]?.project_attachments_id_ids && setAttachedImage1Id(res?.data?.project_attachments[1]?.project_attachments_id_ids || '');

                    res?.data?.project_attachments[2]?.url && setAttachedImage2(res?.data?.project_attachments[2]?.url || '');
                    res?.data?.project_attachments[2]?.project_attachments_id_ids && setAttachedImage2Id(res?.data?.project_attachments[2]?.project_attachments_id_ids || '');
                }

                handleCreateProjectStep(3);

            }, (err) => {
                setGetProjectDetailLoading(false)
                setResponseMsg(err.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }

    useEffect(() => {
        if (localStorage.getItem('projectId')) {
            getProjectDetailFn(localStorage.getItem('projectId'))
            // handleCreateProjectStep(localStorage.getItem('DIYprojectStep'));
            getSavedProjectSuggestionsFn();
        }
    }, [localStorage.getItem('projectId')])

    useEffect(() => {
        if (localStorage.getItem('DIYprojectStep')) {
            setCreateProjectStep(parseInt(localStorage.getItem('DIYprojectStep')));
            // handleCreateProjectStep(localStorage.getItem('DIYprojectStep'));
        }
    }, [localStorage.getItem('DIYprojectStep')])

    const handleClearProjectStates = () => {
        setProjectTitle('');
        setProjectCreatedDate('');
        setProjectDescription('');
        setProjectBudget('');
        setProjectCompletionDate('');
        setProjectCompletionDateUnix('');
        setProjectPriorityLevel('');
        setProjectId('');

        deleteAttachedImage0();
        deleteAttachedImage1();
        deleteAttachedImage2();

        setSavedProjectSuggestionsArr([]);
        setSelectedItems([]);
    }

    // Notes functions starts here
    const handleAttach = () => {
        hiddenFileInput.current.click();
    };

    const inputFileTarget = (e) => {


        const selectedFileLength = [...selectedFile];
        if (selectedFileLength.length < 10) {
            setDeleteIconVisiblity({ visibility: "visible" });
            setSelectedFile([...selectedFile, e.target.files[0]]);

            return;
        }
        return setSelectedFileLimit("*You can't add more than 10 files.")
    };

    const discussionOnChange = (e) => {
        setDiscussionVal(e.target.value);
    };

    const handleSaveDiscussion = () => {

        setSaveLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("project_id_ids", projectId || '');
        data.append("call_note", discussionVal);
        selectedFile?.map((attachmentData, attachmentI) => {
            data.append(`attachment${attachmentI}`, attachmentData);
        })
        data.append("project_suggestion_id_ids", particularProjectSuggestionObj?.project_suggestion_id_ids || '');
        // toggleForAddPersonalNote && data.append("is_personal_note_ysn", 1);
        // console.log(data,"particular ")
        dispatch(callNote(data, () => {
            setSelectedFile([]);
            setDiscussionVal("");
            setSaveLoading(false);

            handleClearNotesStates();

            setToggleForNotesDIY(1);
            handleCloseProjectSuggestionsModal();

            getSavedProjectSuggestionsFn();

        }, (err) => {
            setSaveLoading(false);
        }))
    };

    const handleClearNotesStates = () => {
        setDiscussionVal('');
        setSelectedFile([]);
        setNoteObject({});
    }

    const deleteUpload = (fileIndex) => {
        const updatedFile = selectedFile.filter((delElem, delElemIndex) => {
            return fileIndex !== delElemIndex;
        })
        setSelectedFile([...updatedFile]);
        setSelectedFileLimit("");
    };

    const handleDeleteNote = (element, e) => {
        e?.preventDefault();

        setSaveLoading(true);

        let details = {
            user_id_ids: localStorage.getItem("user_id") || "",
            call_log_note_id_ids: element?.call_log_note_id_ids,
        };

        dispatch(
            deleteCallLogNoteById(
                details,
                (res) => {
                    setSaveLoading(false);
                    setResponseMsg(res.data.message);
                    setToasterType("success");

                    handleClearNotesStates();

                    setToggleForNotesDIY(1);
                    handleCloseProjectSuggestionsModal();

                    getSavedProjectSuggestionsFn();
                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (err) => {
                    setSaveLoading(false);
                    setResponseMsg(err.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    // Capture text functions comes here
    const handleCaptureOcrText = () => {
        if (canvasRef.current) {
            setOcrLoading(true)
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');

            // Create a new canvas for the cropped area
            const croppedCanvas = document.createElement('canvas');
            croppedCanvas.width = crop.width;
            croppedCanvas.height = crop.height;
            const croppedCtx = croppedCanvas.getContext('2d');

            // Draw the cropped area from the original canvas onto the new canvas
            croppedCtx.drawImage(
                canvas,
                crop.x, crop.y, crop.width, crop.height,
                0, 0, crop.width, crop.height
            );
            setCapturedImage(croppedCanvas.toDataURL('image/jpeg'))

            setImageForOCR(croppedCanvas.toDataURL('image/jpeg'))


            // Get the cropped image data as a base64 string
            const croppedImageData = croppedCanvas.toDataURL('image/jpeg').replace("data:", "").replace(/^.+,/, "");

            // Convert the base64 string to a Blob
            const byteCharacters = atob(croppedImageData);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpeg' });

            setUploadImageForOcr(blob);

            // Pass the blob back to the parent component or use it as needed
            //   setResponseBox(true)
            //   setScanImageCheck(false);

            //   setLoading(true);
            //   setImage(blob);

            let formData = new FormData();

            formData.append("image", blob);

            // setToggleForAddImage(false);
            // setImgSrc(null);
            // stopCameraStream();

            // For recognizing the category for creating service
            dispatch(
                ocr(
                    formData,
                    (res) => {
                        setOcrLoading(false);
                        console.log(res.data?.note_chr, "OCR text")
                        setOcrText(res.data?.note_chr);

                        setToggleForAddImage(false);
                        setImgSrc(null);
                        stopCameraStream();

                        handleOpenModalForSaveImageToNotes();
                    },
                    () => {
                        setOcrLoading(false);
                    }
                )
            );
        }
    };

    // Loading effect for the images
    const [isLoadingImg, setIsLoadingImg] = useState(true);

    const handleImageLoaded = () => {
        setIsLoadingImg(false);
    };

    const handleImageError = () => {
        console.error('Failed to load the image.');
        setIsLoadingImg(false);
    };

    const handleSaveOCRtextToNotes = () => {

        setOcrLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("call_note", ocrText);
        data.append("note_type_chr", 'Text Capture');
        data.append(`attachment0`, uploadImageForOcr);
        data.append("project_suggestion_id_ids", particularProjectSuggestionObj?.project_suggestion_id_ids);
        // toggleForAddPersonalNote && data.append("is_personal_note_ysn", 1);
        // console.log(data,"particular ")
        dispatch(callNote(data, () => {
            setSelectedFile([]);
            setDiscussionVal("");
            setOcrLoading(false);

            handleCloseModalForSaveImageToNotes();

            getSavedProjectSuggestionsFn();

        }, (err) => {
            setOcrLoading(false);
        }))
    };

    const [toggleForDrawing, setToggleForDrawing] = useState(false);
    const [captureImageFromDraw, setCaptureImageFromDraw] = useState(null);
    const [drawingImageSaveLoading, setDrawingImageSaveLoading] = useState(false);

    const handleSaveDrawingImgNotes = (image) => {

        setDrawingImageSaveLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        // data.append("call_note", ocrText);
        data.append("note_type_chr", 'Drawing notes');

        data.append(`attachment0`, image);
        data.append("project_suggestion_id_ids", particularProjectSuggestionObj?.project_suggestion_id_ids);
        // toggleForAddPersonalNote && data.append("is_personal_note_ysn", 1);
        // console.log(data,"particular ")
        dispatch(callNote(data, () => {
            setSelectedFile([]);
            setDiscussionVal("");
            setDrawingImageSaveLoading(false);

            setToggleForDrawing(false);

            getSavedProjectSuggestionsFn();
            setParticularProjectSuggestionObj({});

        }, (err) => {
            setDrawingImageSaveLoading(false);
        }))
    };

    // DIY project notes functions
    const [discussionLoading, setDiscussionLoading] = useState(false);
    const [callNoteDetailsArr, setCallNoteDetailsArr] = useState([]);
    const [toggleForProjectNotes, setToggleForPrjectNotes] = useState(1);

    const callNoteData = (id) => {
        setDiscussionLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        // data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        data.append("project_id_ids", id || projectId);
        data.append("pagination_flag", 0);
        // data.append("page_index", 1);
        // data.append("page_size", 25);
        data.append("sorting_order", "DESC");
        data.append("sorting_column_name", "");
        data.append("search_area", '');

        dispatch(
            callNoteDetails(data, (res) => {
                setCallNoteDetailsArr(res.data.data);
                setDiscussionLoading(false);
            })
        );
    };

    useEffect(() => {
        if (createProjectStep === 2) {
            callNoteData();
        }
    }, [createProjectStep])

    const [modalTriggerProjectNotes, setModaltriggerProjectNotes] = useState(false)
    const handleOpenProjectNotesModal = () => { setModaltriggerProjectNotes(true) }
    const handleCloseProjectNotesModal = () => {
        setModaltriggerProjectNotes(false)
        setNoteObject({});
        setToggleForPrjectNotes(1);
        setDiscussionVal('');
    }

    const handleSaveProjectNotes = (e) => {
        e?.preventDefault();
        setSaveLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("project_id_ids", projectId || '');
        data.append("call_note", discussionVal);
        selectedFile?.map((attachmentData, attachmentI) => {
            data.append(`attachment${attachmentI}`, attachmentData);
        })
        data.append("project_suggestion_id_ids", particularProjectSuggestionObj?.project_suggestion_id_ids || '');
        // toggleForAddPersonalNote && data.append("is_personal_note_ysn", 1);
        // console.log(data,"particular ")
        dispatch(callNote(data, () => {
            setSelectedFile([]);
            setDiscussionVal("");
            setSaveLoading(false);

            handleClearNotesStates();

            handleCloseProjectNotesModal();

            callNoteData();

        }, (err) => {
            setSaveLoading(false);
        }))
    };

    const handleUpdateProjectNotes = (e) => {
        e?.preventDefault();
        setSaveLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        // data.append("project_id_ids", projectId || '');
        data.append("call_log_note_id_ids", noteObject?.call_log_note_id_ids);
        data.append("call_note", discussionVal);
        selectedFile?.map((attachmentData, attachmentI) => {
            data.append(`attachment${attachmentI}`, attachmentData);
        })
        // toggleForAddPersonalNote && data.append("is_personal_note_ysn", 1);
        // console.log(data,"particular ")
        dispatch(updateCallNoteApi(data, () => {
            setSelectedFile([]);
            setDiscussionVal("");
            setSaveLoading(false);

            handleClearNotesStates();

            handleCloseProjectNotesModal();

            if (createProjectStep === 2) {
                callNoteData();
            } else if (createProjectStep === 3) {
                getSavedProjectSuggestionsFn();
            }

            handleCloseDoc();

        }, (err) => {
            setSaveLoading(false);
        }))
    };


    // function to add the individual suggetion
    const [individualSuggestionObj, setIndividualSuggestionObj] = useState({});
    const [isForEditSuggestion, setIsForEditSuggestion] = useState(false);

    const saveIndividualProjectSuggestionsFn = (e) => {
        e?.preventDefault();
        if (newSuggestion === '') return

        setSaveSuggestionsLoading(true);


        let details = {
            project_id_ids: projectId,
            project_suggestion_list: [{
                project_suggestion_id_ids: particularProjectSuggestionObj?.project_suggestion_id_ids || '',
                suggestion_description_chr: newSuggestion,
                step_completion_status_int: 0
            }],
        };

        dispatch(
            saveProjectSuggestionsApi(
                details,
                (res) => {
                    setSaveSuggestionsLoading(false);
                    // console.log(res.data.data, "Save project suggestions data");
                    // handleCreateProjectStep(3)
                    // setSelectedItems([]);

                    setParticularProjectSuggestionObj({});
                    setIsAdding(false);
                    setNewSuggestion('');
                    setIsForEditSuggestion(false);

                    getSavedProjectSuggestionsFn();
                },
                (err) => {
                    setSaveSuggestionsLoading(false);

                    setResponseMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    }

    const handleAddindividualSuggestion = () => {
        setIndividualSuggestionObj({
            project_suggestion_id_ids: "",
            suggestion_description_chr: newSuggestion,
            step_completion_status_int: 0
        })
        saveIndividualProjectSuggestionsFn();
    }

    const updateIndividualSuggestionsStatus = (data) => {

        // setSaveSuggestionsLoading(true);


        let details = {
            project_id_ids: projectId,
            project_suggestion_list: [{
                project_suggestion_id_ids: data?.project_suggestion_id_ids || '',
                suggestion_description_chr: data?.suggestion_description_chr,
                step_completion_status_int: data?.step_completion_status_int == 1 ? 0 : 1,
            }],
        };

        dispatch(
            saveProjectSuggestionsApi(
                details,
                (res) => {
                    // setSaveSuggestionsLoading(false);
                    // console.log(res.data.data, "Save project suggestions data");
                    // handleCreateProjectStep(3)
                    // setSelectedItems([]);

                    setParticularProjectSuggestionObj({});
                    setIsAdding(false);
                    setNewSuggestion('');
                    setIsForEditSuggestion(false);

                    getSavedProjectSuggestionsAfterCheckboxFn();
                },
                (err) => {
                    // setSaveSuggestionsLoading(false);

                    setResponseMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    }

    const [showPopover, setShowPopover] = useState(false);
    // More actions for both customer and pro
    const popoverProjectctions = (
        <Popover id="popover-basic"
            style={{ minWidth: "100px", border: 'none' }}>
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",
                }}>

                <div className="d-flex flex-column font-w500 fs-6"
                    style={{
                        // pointerEvents: "none", 
                        // opacity: "0.5"
                    }}
                >
                    <div
                        onClick={(e) => {
                            setShowPopover(false)
                            handleCreateProjectStep(1)
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>{"Edit the description"}</span>
                    </div>

                    <div
                        onClick={(e) => {
                            setShowPopover(false)
                            handleCreateProjectStep(2)
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>{"Edit the before"}</span>
                    </div>

                    <div
                        onClick={(e) => {
                            setShowPopover(false);
                            handleOpenProjectsModal();
                        }}
                        className=" cursor-pointer p-2 text-danger overlay-action-btn">
                        <span className="me-2">
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>{`Delete the project`}</span>
                    </div>

                </div>

            </Popover.Body>
        </Popover>
    );

    const popoverSuggestionStepActions = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}

            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}>
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div
                        onClick={(e) => {
                            // editExpertise(e, shoppingItemObject);
                            setActivePopoverShopping(null);
                            setIsForEditSuggestion(true);
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn text-hovered'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Edit</span>
                    </div>
                    <div
                        onClick={(e) => {
                            // handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
                            setActivePopoverShopping(null);
                            handleOpenProjectSuggestionsModal();
                            setToggleForSavedProjectSuggestions(1);
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const [activePopoverShopping, setActivePopoverShopping] = useState(null);


    const handleMenuClickSuggestionStep = (element, index) => {
        setParticularProjectSuggestionObj(element)
        setNewSuggestion(element?.suggestion_description_chr)
        setActivePopoverShopping(activePopoverShopping === index ? null : index)
    }

    // Bulk delete project steps
    const bulkDeleteProjectStepsFn = (data) => {

        // setSaveSuggestionsLoading(true);

        if (!projectId) return

        let details = {
            project_id_ids: projectId,
            action_type: "A",
            project_step_id_list: [],
        };

        dispatch(
            bulkDeleteProjectStepsApi(
                details,
                (res) => {
                    // setSaveSuggestionsLoading(false);
                    // console.log(res.data.data, "Save project suggestions data");
                    // handleCreateProjectStep(3)
                    // setSelectedItems([]);

                },
                (err) => {
                    // setSaveSuggestionsLoading(false);

                    setResponseMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    }

    const divAIsuggestionsRef = useRef(null);
    const [widthAIsuggestionsContainer, setWidthAIsuggestionsContainer] = useState(0);

    useLayoutEffect(() => {
        const getWidthAIsuggestionContainer = () => {
            if (divAIsuggestionsRef.current) {
                setWidthAIsuggestionsContainer(divAIsuggestionsRef.current.offsetWidth);
            }
        };

        const observer = new ResizeObserver(() => {
            getWidthAIsuggestionContainer();
        });

        if (divAIsuggestionsRef.current) {
            observer.observe(divAIsuggestionsRef.current);
        }

        setTimeout(() => {
            getWidthAIsuggestionContainer();
        }, 100);

        const handleResize = () => {
            getWidthAIsuggestionContainer();
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            observer.disconnect();
        };
    }, [createProjectStep]);

    // Chilll chat bot functions
    const getChatHistoryFn = (respProjectId) => {
        setChatHistoryLoading(true);

        let details = {
            project_id: projectId,
            chat_history_record_id: "",
            sorting_order: 'ASC',
        };

        dispatch(getChatHistoryApi(details, (res) => {
            setChatHistoryLoading(false);
            // console.log(res.data.data, "AI suggestions");
            setChatHistoryArr(res?.data);

            // console.log(res?.data, "Chat history arr");



        }, (err) => {
            setChatHistoryLoading(false);

            setResponseMsg(err.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    useEffect(() => {
        const scrollToBottom = () => {
            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth',
            });
        };

        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        };

        if (createProjectStep === 3) {
            scrollToTop();
        } else if (createProjectStep === 4 || chatHistoryArr.length > 0) {
            scrollToBottom();
        }


    }, [createProjectStep, chatHistoryArr]);

    useEffect(() => {
        if (!chatHistoryLoading) {
            const scrollToBottom = () => {
                window.scrollTo({
                    top: document.documentElement.scrollHeight,
                    behavior: 'smooth', // Smooth scroll to bottom
                });
            };

            scrollToBottom();
        }

    }, [chatHistoryLoading, chatHistoryArr]);


    const [isScrollVisible, setIsScrollVisible] = useState(false);

    useEffect(() => {
        const checkScrollAvailability = () => {
            if (createProjectStep === 4) {
                const isScrollable = document.documentElement.scrollHeight > document.documentElement.clientHeight;
                const isAtBottom = document.documentElement.scrollHeight === document.documentElement.scrollTop + window.innerHeight;

                setIsScrollVisible(isScrollable && !isAtBottom);
            }
        };

        checkScrollAvailability();
        window.addEventListener('resize', checkScrollAvailability);
        window.addEventListener('scroll', checkScrollAvailability);

        return () => {
            window.removeEventListener('resize', checkScrollAvailability);
            window.removeEventListener('scroll', checkScrollAvailability);
        };
    }, [createProjectStep]);


    const createUpdateChatHistoryFn = (e) => {
        e?.preventDefault();

        let isErrorObj = {};

        if (aiChatMessage) {
            setCreateUpdateChatLoading(true);

            const userMessage = {
                user_query_chr: aiChatMessage,
            }

            if (projectChatHistoryId) {
                setChatHistoryArr(prevHistory => {
                    const updatedHistory = [...prevHistory];
                    isErrorObj = updatedHistory.pop();  // Remove the last dummy message
                    // projectChatHistoryId && updatedHistory.pop();
                    updatedHistory.push(userMessage); // Add the AI response
                    return updatedHistory;
                });
            } else {
                setChatHistoryArr(prevHistory => [...prevHistory, userMessage]);
            }



            let data = new FormData();

            data.append("project_id", projectId);
            data.append("user_query", aiChatMessage);
            data.append("chat_history_record_id", projectChatHistoryId);



            dispatch(createUpdateChatHistoryApi(data, (res) => {
                setCreateUpdateChatLoading(false);
                setAiChatMessage('');

                // console.log(res?.data?.ai_response, 'ai response')

                // const aiResponse = {
                //     ai_response_chr: res?.data?.ai_response,
                // }

                // setChatHistoryArr(prevHistory => [...prevHistory, aiResponse]);
                // setChatHistoryArr(prevHistory => [...prevHistory, res?.data?.data]);

                setChatHistoryArr(prevHistory => {
                    const updatedHistory = [...prevHistory];
                    updatedHistory.pop();  // Remove the last dummy message
                    // projectChatHistoryId && updatedHistory.pop();
                    updatedHistory.push(res?.data?.data); // Add the AI response
                    return updatedHistory;
                });

                setProjectChatHistoryId('')
            }, (err) => {

                setCreateUpdateChatLoading(false);

                if (projectChatHistoryId) {
                    setChatHistoryArr(prevHistory => {
                        const updatedHistory = [...prevHistory];
                        updatedHistory.pop();  // Remove the last dummy message
                        // projectChatHistoryId && updatedHistory.pop();
                        updatedHistory.push(isErrorObj); // Add the AI response
                        return updatedHistory;
                    });
                }

                setResponseMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }))
        }
    }

    // Delete the AI chat history
    const handleDeleteAIChatHistoryFn = (element) => {
        if (!projectId) {
            return
        }

        setDeleteAIChatHistoryLoading(true)

        let details = {
            project_id: projectId,
        };

        dispatch(
            deleteProjectChatHistoryApi(details, (res) => {
                setDeleteAIChatHistoryLoading(false)
                setResponseMsg(res.data.message);
                handleCloseModalDeleteAIChatHistory();

                // getProjectsFn();
                getChatHistoryFn();

            }, (err) => {
                setDeleteAIChatHistoryLoading(false)
                setResponseMsg(err.data.message)
                setToasterType("error")

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        )
    }

    return (
        <>
            <div className='row mx-0'
                style={{
                    zoom: (!toggleForAddImage && !toggleForDrawing) ? '0.9' : '1'
                }}
            >
                <div className='col-12 px-0'>
                    {!toggleForCreateDIYServiceRequest ? <>
                        {!toggleForDrawing ? <>
                            {!toggleForAddImage ?
                                <>
                                    {createProjectStep >= 1 && createProjectStep != 4 && <div className="row mx-0">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center my-1" >

                                            <div
                                                className={`d-flex justify-content-center align-items-center fs-3 rounded-circle font-w600 me-3 ${createProjectStep === 1 && 'shadow'}`}
                                                style={{
                                                    height: '40px',
                                                    width: '40px',
                                                    backgroundColor: createProjectStep === 1 ? 'white' : 'rgba(235, 240, 250, 1)',
                                                    border: createProjectStep === 1 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                                    color: createProjectStep === 1 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                                }}
                                            // onClick={(e) => { handleCreateProjectStep(1) }}
                                            >
                                                <span>{1}</span>
                                            </div>

                                            <div
                                                className={`d-flex justify-content-center align-items-center fs-3 rounded-circle font-w600 me-3 ${createProjectStep === 2 && 'shadow'}`}
                                                style={{
                                                    height: '40px',
                                                    width: '40px',
                                                    backgroundColor: createProjectStep === 2 ? 'white' : 'rgba(235, 240, 250, 1)',
                                                    border: createProjectStep === 2 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                                    color: createProjectStep === 2 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                                }}
                                            // onClick={() => { handleCreateProjectStep(2); getAISuggestionsFn() }}
                                            >
                                                <span>{2}</span>
                                            </div>

                                            <div
                                                className={`d-flex justify-content-center align-items-center fs-3 rounded-circle font-w600 me-3  ${createProjectStep === 3 && 'shadow'}`}
                                                style={{
                                                    height: '40px',
                                                    width: '40px',
                                                    backgroundColor: createProjectStep === 3 ? 'white' : 'rgba(235, 240, 250, 1)',
                                                    border: createProjectStep === 3 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                                    color: createProjectStep === 3 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                                }}
                                            // onClick={(e) => { handleCreateProjectStep(3); getSavedProjectSuggestionsFn() }}
                                            >
                                                <span>{3}</span>
                                            </div>

                                            {/* <div
                                                className={`d-flex justify-content-center align-items-center fs-3 rounded-circle font-w600 me-3 ${createProjectStep === 4 && 'shadow'}`}
                                                style={{
                                                    height: '40px',
                                                    width: '40px',
                                                    backgroundColor: createProjectStep === 4 ? 'white' : 'rgba(235, 240, 250, 1)',
                                                    border: createProjectStep === 4 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                                    color: createProjectStep === 4 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                                }}
                                            // onClick={(e) => { handleCreateProjectStep(4) }}
                                            >
                                                <span>{4}</span>
                                            </div> */}

                                        </div>

                                    </div>}


                                    <div
                                        className='row mx-0'
                                        style={{ minHeight: '80dvh' }}
                                    >

                                        <div className='col-md-3'></div>

                                        {createProjectStep === 0.1 ?
                                            // Landing screen for DIY project
                                            <div className='col-md-6 d-flex justify-content-center align-items-center p-3'>
                                                <div className='row mx-0 w-100'>
                                                    <div className='col-12 d-flex justify-content-center align-items-center'>

                                                        <div className='w-100'>

                                                            <div className='d-flex justify-content-center mb-5'>
                                                                <span className='text-black font-w600 fs-3 text-center'>{`Create a Project for`}</span>
                                                            </div>

                                                            <div className='row mx-0 '>
                                                                <div className='col-12 px-0 my-4'>
                                                                    <PrimaryButton
                                                                        buttonName={`ME`}
                                                                        onClick={() => { handleCreateProjectStep(0.2) }}
                                                                        style={{
                                                                            width: '100%',
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            fontWeight: '600',
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className='row mx-0 '>
                                                                <div className='col-12 px-0 my-4'>
                                                                    <PrimaryButton
                                                                        buttonName={`CONNECT A WITH REMOTE PRO`}
                                                                        onClick={() => { navigate('/scan') }}
                                                                        style={{
                                                                            width: '100%',
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            fontWeight: '600',
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className='row mx-0 '>
                                                                <div className='col-12 px-0 my-4 d-flex justify-content-center align-items-center'>
                                                                    <span
                                                                        className='text-center font-w600 fs-5 text-decoration-underline cursor-pointer text-hovered'
                                                                        onClick={() => { handleCreateProjectStep(0.2) }}
                                                                    >
                                                                        {`Show me how`}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {/* <div className='d-flex justify-content-center mb-3'>
                                                                <span className='text-black font-w600 fs-3 text-center'>{`My projects`}</span>
                                                            </div> */}

                                                            {getProjectDetailLoading && <div className='d-flex justify-content-center align-items-center mb-2'>
                                                                <span className='me-2'>{`Please wait while we load your project...`}</span> <Spinner as="span" animation="border" size="sm" />
                                                            </div>}

                                                            {getProjectsLoading ? <div className='row mx-0'>
                                                                {[1, 2, 3].map((element, i) => {
                                                                    return (
                                                                        <div key={i} className='col-12 p-3 rounded-3 border border-success border-2 mb-2'>
                                                                            <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                            <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                            <SkeletonDivElement height={'20px'} width={'40%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div> :
                                                                <>
                                                                    {projectsArr.length > 0 ?
                                                                        <>
                                                                            <div className='row mx-0'>
                                                                                {projectsArr.map((element, i) => {
                                                                                    return (
                                                                                        <>
                                                                                            <div
                                                                                                key={i}
                                                                                                className='col-12 rounded-3 mb-1 p-3 border border-success border-2 fs-4 position-relative'
                                                                                                style={{ background: 'rgb(163 204 144 / 22%)' }}
                                                                                            >

                                                                                                {/* <span
                                                                                            className='position-absolute text-danger top-0 end-0 me-2 mt-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                handleOpenProjectSuggestionsModal();
                                                                                                setToggleForSavedProjectSuggestions(1);
                                                                                            }}
                                                                                        >
                                                                                            <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                        </span> */}

                                                                                                <div className='row mx-0'>
                                                                                                    <div className='col-12 d-flex justify-content-end align-items-center'>


                                                                                                        <span
                                                                                                            className='me-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                setProjectId(element?.project_id_ids);
                                                                                                                getProjectDetailFn(element?.project_id_ids)
                                                                                                            }}
                                                                                                        >
                                                                                                            <i className={`bi bi-pencil`} style={{ fontSize: '14px' }}></i>
                                                                                                        </span>

                                                                                                        <span
                                                                                                            className='text-danger bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                setProjectId(element?.project_id_ids);
                                                                                                                handleOpenProjectsModal();
                                                                                                            }}
                                                                                                        >
                                                                                                            <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className='row mx-0 mb-2'>
                                                                                                    <div className='col-12 px-0'>
                                                                                                        <span className='font-w600 text-black fs-4 text-decoration-underline'>{`${element?.project_title_chr}`}</span>
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className='row mx-0'>
                                                                                                    <div className='col-12 px-0'>
                                                                                                        <span className='fs-5'>{`${element?.project_description_chr}`}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                        </>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </> :
                                                                        <>
                                                                            <div className='row mx-0'>
                                                                                {/* <div className='col-12 px-2 my-3 d-flex justify-content-center align-items-center'>
                                                                                    <span className='font-w600 fs-5 text-center'>{`No projects found`}</span>
                                                                                </div> */}
                                                                            </div>
                                                                        </>}
                                                                </>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> :
                                            createProjectStep === 0.2 ?
                                                // Instructions screens
                                                <div className='col-md-6 d-flex justify-content-center align-items-center p-3'>
                                                    <div className='row mx-0 w-100'>
                                                        <div className='col-12 d-flex justify-content-center align-items-center'>

                                                            <div className='w-100'>
                                                                <div className='row mx-0'>
                                                                    <div className='col-12 px-2 mb-4 d-flex justify-content-center align-items-center'>
                                                                        <img
                                                                            src={logo}
                                                                            style={{ width: "115px", }}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className='d-flex justify-content-center mb-5'>
                                                                    <span className='text-black font-w600 fs-3 text-center'>{`We'll create a step-by-step plan for your DIY Project in three easy steps`}</span>
                                                                </div>

                                                                <div className='mb-4'>
                                                                    <div className='d-flex'>
                                                                        <div className='d-flex justify-content-center align-items-center mb-3 p-2 rounded-2' style={{ width: '130px', height: '80px', }}>
                                                                            <img src={DefineProjectImage} alt="" style={{ width: '80%' }} />
                                                                        </div>

                                                                        <div className='ms-3 d-flex flex-column text-black w-100'>
                                                                            <span className='fs-4 font-w600 mb-1'>{`Define Your Project`}</span>
                                                                            <span className=''>{`Add project details and we'll create an outline with key steps`}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className='d-flex'>
                                                                        <div className='d-flex justify-content-center align-items-center mb-3 p-2 rounded-2' style={{ width: '130px', height: '80px', }}>
                                                                            <img src={DocumentDIYProjectImage} alt="" style={{ width: '80%' }} />
                                                                        </div>

                                                                        <div className='ms-3 d-flex flex-column text-black w-100'>
                                                                            <span className='fs-4 font-w600 mb-1'>{`Note your starting point`}</span>
                                                                            <span className=''>{`Snap some 'before' pics to capture the transformation`}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className='d-flex'>
                                                                        <div className='d-flex justify-content-center align-items-center mb-3 p-2 rounded-2' style={{ width: '130px', height: '80px', }}>
                                                                            <img src={EnhancePlanDIYProject} alt="" style={{ width: '80%' }} />
                                                                        </div>

                                                                        <div className='ms-3 d-flex flex-column text-black w-100'>
                                                                            <span className='fs-4 font-w600 mb-1'>{`Add Chilll Tools to the Plan`}</span>
                                                                            <span className=''>{`Enhance each step with tools like virtual measuring, drawing, and shopping lists`}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* <div className='ms-4 mb-4'>
                                                                    {instructionsArr?.map((element, ind) => {
                                                                        return (
                                                                            <div className='row mx-0' key={ind}>
                                                                                <div className='col-12 px-0 my-2'>
                                                                                    <span className='fs-4 font-w600'>{`- ${element}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0 my-2'>
                                                                            <span className='fs-4 font-w600 text-black'>{`1. Define your project.`}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0 my-2'>
                                                                            <span className='fs-4 font-w600 text-black'>{`2. Capture the "Before"`}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0 my-2'>
                                                                            <span className='fs-4 font-w600 text-black'>{`3. Build Your Plan using Chilll's tool box`}</span>
                                                                        </div>

                                                                        <div className='col-12 ps-3 my-2'>
                                                                            <span className='fs-4'>{`- Add Photos and Notes`}</span>
                                                                        </div>
                                                                        <div className='col-12 ps-3 my-2'>
                                                                            <span className='fs-4'>{`- Screen drawing`}</span>
                                                                        </div>
                                                                        <div className='col-12 ps-3 my-2'>
                                                                            <span className='fs-4'>{`- Shopping List`}</span>
                                                                        </div>
                                                                        <div className='col-12 ps-3 my-2'>
                                                                            <span className='fs-4'>{`- Virtual Measuring`}</span>
                                                                        </div>
                                                                        <div className='col-12 ps-3 my-2'>
                                                                            <span className='fs-4'>{`- Text Capture`}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0 my-2'>
                                                                            <span className='fs-4 font-w600 text-black'>{`Now you're ready to go!`}</span>
                                                                        </div>
                                                                    </div>

                                                                </div> */}

                                                                <div className='row mx-0'>
                                                                    <div className='col-12 px-0 my-4'>
                                                                        <PrimaryButton
                                                                            buttonName={`LET'S GET STARTED`}
                                                                            onClick={() => { handleCreateProjectStep(1) }}
                                                                            style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className='row mx-0'>
                                                                    <div className='col-12 px-0 my-3 d-flex justify-content-center align-items-center'>
                                                                        <span
                                                                            className='text-center font-w600 fs-5 text-decoration-underline cursor-pointer text-hovered text-blue d-flex justify-content-center align-items-center'
                                                                            onClick={() => {
                                                                                // handleCreateProjectStep(0.1) 
                                                                                navigate('/dashboard')
                                                                            }}
                                                                        >
                                                                            {/* <i className='bi bi-arrow-left me-3'></i> */}
                                                                            {`Back`}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div> :
                                                createProjectStep === 1 ?
                                                    // Creating actual DIY project
                                                    <div className='col-md-6 d-flex justify-content-center align-items-center p-3'>
                                                        <div className='row mx-0 w-100'>
                                                            <div className='col-12 d-flex justify-content-center align-items-center flex-column'>
                                                                <div className='d-flex justify-content-between w-100 align-items-center mb-2'>
                                                                    <div
                                                                        className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center'
                                                                        onClick={() => {
                                                                            if (localStorage.getItem('projectId')) {
                                                                                navigate('/')
                                                                            } else {
                                                                                handleCreateProjectStep(0.2);
                                                                                setProjectTitleErr(false);
                                                                                setProjectDescriptionErr(false);
                                                                                handleClearProjectStates();
                                                                            }
                                                                        }}
                                                                    >
                                                                        <i class="bi bi-arrow-left-short pe-2"></i>
                                                                        <span>{"Back"}</span>
                                                                    </div>

                                                                    {/* <div onClick={() => { }} className='overlay-action-btn text-hovered py-1 px-2 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center text-decoration-underline'>
                                                                        <span>{"Chat with A.I."}</span>
                                                                    </div> */}
                                                                </div>

                                                                <div className='w-100'>

                                                                    <div className='d-flex justify-content-center mb-2'>
                                                                        <span className='text-black font-w600 fs-3 text-center'>{`Define your project`}</span>
                                                                    </div>

                                                                    <form onSubmit={handleCreateDIYProject}>
                                                                        <div className='row mx-0 mb-4'>
                                                                            <div className='col-12 p-1 d-flex justify-content-between align-items-center border rounded-2 '>
                                                                                <div className='ps-3'>
                                                                                    <span className='fs-6 font-w600 '>{`Start with a picture`}</span>
                                                                                </div>

                                                                                <div className='d-flex overflow-auto'>
                                                                                    {attachedImage0 == null &&
                                                                                        <div
                                                                                            className='rounded-2 d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                            style={{
                                                                                                border: '2px solid orange',
                                                                                                height: '65px',
                                                                                                width: '100px',
                                                                                                backgroundColor: "rgb(215 225 243)",
                                                                                                // opacity: attachedImage0 !== null || attachedImage1 !== null || attachedImage2 !== null ? '1' : '0.5'
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                if (attachedImage0 == null || attachedImage1 == null || attachedImage2 == null) {
                                                                                                    // getCameraStream();
                                                                                                    // setToggleForAddImage(true);
                                                                                                    // setToggleForCameraActions(1);

                                                                                                    handleOpenModalAddPhoto();
                                                                                                } else {
                                                                                                    setUploadImageLimit(true);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <span>
                                                                                                <i className="bi bi-plus-lg fs-4"></i>
                                                                                            </span>
                                                                                            <span className='font-w600 fs-7'>
                                                                                                {`Add photo`}
                                                                                            </span>
                                                                                        </div>
                                                                                    }

                                                                                    {attachedImage0 !== null && <div
                                                                                        className='rounded-2 overflow-hidden position-relative d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn shadow me-1'
                                                                                        style={{ border: '2px solid orange', height: '65px', width: '100px', backgroundColor: "rgb(215 225 243)", }}
                                                                                        onClick={() => {
                                                                                            handleOpenDoc();
                                                                                            setImageAttachURL(attachedImage0);
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className='position-absolute cursor-pointer rounded-circle text-danger d-flex justify-content-center align-items-center'
                                                                                            style={{ top: '3px', right: '3px', border: '1px solid red', width: '25px', height: '25px', zIndex: '2' }}
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                e?.stopPropagation();
                                                                                                deleteAttachedImage0()
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-x-lg"></i>
                                                                                        </span>
                                                                                        <img src={attachedImage0} className='rounded-2 documents-individual-box-img' alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                                    </div>}

                                                                                    {attachedImage1 !== null &&
                                                                                        <div
                                                                                            className='rounded-2 overflow-hidden position-relative d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn shadow me-1'
                                                                                            style={{ border: '2px solid orange', height: '65px', width: '100px', backgroundColor: "rgb(215 225 243)", }}
                                                                                            onClick={() => {
                                                                                                handleOpenDoc();
                                                                                                setImageAttachURL(attachedImage1);
                                                                                            }}
                                                                                        >
                                                                                            <span
                                                                                                className='position-absolute cursor-pointer rounded-circle text-danger d-flex justify-content-center align-items-center'
                                                                                                style={{ top: '3px', right: '3px', border: '1px solid red', width: '25px', height: '25px', zIndex: '2' }}
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    e?.stopPropagation();
                                                                                                    deleteAttachedImage1()
                                                                                                }}
                                                                                            >
                                                                                                <i className="bi bi-x-lg"></i>
                                                                                            </span>
                                                                                            <img src={attachedImage1} className='rounded-2 documents-individual-box-img' alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                                        </div>}

                                                                                    {attachedImage2 !== null && <div
                                                                                        className='rounded-2 overflow-hidden position-relative d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn shadow me-'
                                                                                        style={{ border: '2px solid orange', height: '65px', width: '100px', backgroundColor: "rgb(215 225 243)", }}
                                                                                        onClick={() => {
                                                                                            handleOpenDoc();
                                                                                            setImageAttachURL(attachedImage2);
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className='position-absolute cursor-pointer rounded-circle text-danger d-flex justify-content-center align-items-center'
                                                                                            style={{ top: '3px', right: '3px', border: '1px solid red', width: '25px', height: '25px', zIndex: '2' }}
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                e?.stopPropagation();
                                                                                                deleteAttachedImage2()
                                                                                            }}
                                                                                        >
                                                                                            <i className="bi bi-x-lg"></i>
                                                                                        </span>
                                                                                        <img src={attachedImage2} className='rounded-2 documents-individual-box-img' alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                                    </div>}
                                                                                </div>

                                                                            </div>

                                                                            {uploadImageLimit && <div className='mt-2'>
                                                                                <small className='text-danger font-w600'>{`*You cannot add more than 3 images`}</small>
                                                                            </div>}
                                                                        </div>


                                                                        {(localStorage.getItem('projectId') || projectId) && <div className='mx-0 row mb-2'>
                                                                            <div className='col-12 px-0'>
                                                                                <InputField
                                                                                    labelName={"Give your project a title"}
                                                                                    placeholder={"Project title"}
                                                                                    value={projectTitle}
                                                                                    onChange={handleChangeProjectTitle}
                                                                                    onBlur={handleChangeProjectTitleBlurCheck}
                                                                                    errorOccured={projectTitleErr}
                                                                                    errorMeesage={"Please enter project title"}
                                                                                    isRequired={true}
                                                                                />
                                                                            </div>
                                                                        </div>}

                                                                        <div className='mx-0 row mb-2'>
                                                                            <div className='col-12 px-0'>
                                                                                <TextArea
                                                                                    labelName={`Description (text or talk) *`}
                                                                                    placeholder={`Provide us detail to your project and we can automatically provide you a step by step plan.`}
                                                                                    value={projectDescription}
                                                                                    onChange={hanldeChangeProjectDescription}
                                                                                    onBlur={handleChangeProjectDescBlurCheck}
                                                                                    errorOccured={projectDescriptionErr}
                                                                                    errorMessage={"Project description must be greater than 10 characters"}
                                                                                    autoActivated={true}
                                                                                    isPlaceholder={true}
                                                                                    rows={'7'}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        {/* <div className='mx-0 row mb-2'>
                                                                            <div className='col-12 px-0'>
                                                                                <InputField
                                                                                    labelName={"Budget ($)"}
                                                                                    placeholder={"Budget"}
                                                                                    value={`${projectBudget}`}
                                                                                    onChange={handleChangeProjectBudget}
                                                                                    errorOccured={false}
                                                                                    errorMeesage={"Please enter project budget"}
                                                                                />
                                                                            </div>
                                                                        </div> */}

                                                                        {/* <div className='mx-0 row mb-2'>
                                                                            <div className='col-12 px-0'>
                                                                                <InputField
                                                                                    type='date'
                                                                                    labelName={"Completion date"}
                                                                                    placeholder={"Completion date"}
                                                                                    value={projectCompletionDate}
                                                                                    onChange={handleChangeProjectCompletionDate}
                                                                                    errorOccured={false}
                                                                                    errorMeesage={"Please enter project completion date"}
                                                                                    autoActivated={true}
                                                                                />
                                                                            </div>
                                                                        </div> */}
                                                                        {/* 
                                                                        <div className='row mt-2'>
                                                                            <div className='col-12 px-0'>
                                                                                <div className='mb-3'>
                                                                                    <span className='fs-6 font-w600 '>{`Level of Difficulty`}</span>
                                                                                </div>

                                                                                <div className='d-flex align-items-center my-2'>
                                                                                    <RangeInput rangeValue={difficultyRangeValue} handleChangeRangeValue={handleChangeDifficultyValue} />
                                                                                </div>
                                                                            </div>
                                                                        </div> */}

                                                                        {/* <div className='row mx-0'>
                                                                            <div className='col-12 px-0'>
                                                                                <div className='mb-3'>
                                                                                    <span className='fs-6 font-w600 '>{`Priority`}</span>
                                                                                </div>

                                                                                <div className='d-flex align-items-center my-2'>

                                                                                    <span
                                                                                        onClick={() => handleChangeProjectPriorityLevel(1)}
                                                                                        className={`me-3 align-items-center d-flex font-w600 fs-4 justify-content-center rounded-circle cursor-pointer border-hovered`}
                                                                                        style={{
                                                                                            height: '25px',
                                                                                            width: '25px',
                                                                                            border: '2px solid black',
                                                                                            // background: projectPriorityLevel === 1 ? ' #09c748' : '',
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className='rounded-circle'
                                                                                            style={{
                                                                                                height: '15px',
                                                                                                width: '15px',
                                                                                                background: projectPriorityLevel === 1 ? ' #09c748' : '',
                                                                                            }}
                                                                                        ></span>
                                                                                    </span>

                                                                                    <div className='me-3'>
                                                                                        <span className='fs-6 font-w600 text-black cursor-pointer text-hovered' onClick={() => handleChangeProjectPriorityLevel(1)}>{`Low`}</span>
                                                                                    </div>

                                                                                    <span
                                                                                        onClick={() => handleChangeProjectPriorityLevel(2)}
                                                                                        className={`me-3 align-items-center d-flex font-w600 fs-4 justify-content-center rounded-circle cursor-pointer border-hovered`}
                                                                                        style={{
                                                                                            height: '25px',
                                                                                            width: '25px',
                                                                                            border: '2px solid black',
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className='rounded-circle'
                                                                                            style={{
                                                                                                height: '15px',
                                                                                                width: '15px',
                                                                                                background: projectPriorityLevel === 2 ? '#ffd608' : '',
                                                                                            }}
                                                                                        ></span>
                                                                                    </span>

                                                                                    <div className='me-3'>
                                                                                        <span className='fs-6 font-w600 text-black cursor-pointer text-hovered' onClick={() => handleChangeProjectPriorityLevel(2)}>{`Medium`}</span>
                                                                                    </div>

                                                                                    <span
                                                                                        onClick={() => handleChangeProjectPriorityLevel(3)}
                                                                                        className={`me-3 align-items-center d-flex font-w600 fs-4 justify-content-center rounded-circle cursor-pointer border-hovered`}
                                                                                        style={{
                                                                                            height: '25px',
                                                                                            width: '25px',
                                                                                            border: '2px solid black',
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className='rounded-circle'
                                                                                            style={{
                                                                                                height: '15px',
                                                                                                width: '15px',
                                                                                                background: projectPriorityLevel === 3 ? '#f21c1c' : '',
                                                                                            }}
                                                                                        ></span>
                                                                                    </span>

                                                                                    <div className='me-3'>
                                                                                        <span className='fs-6 font-w600 text-black cursor-pointer text-hovered' onClick={() => handleChangeProjectPriorityLevel(3)}>{`High`}</span>
                                                                                    </div>



                                                                                </div>

                                                                                <div className='d-flex align-items-center my-2'>
                                                                                    <div>
                                                                                        <span className='fs-6 font-w600 text-black me-3'>{`Low`}</span>
                                                                                    </div>

                                                                                    {priorityLevelArr?.map((element, ind) => {
                                                                                        let bgColor = 'white';
                                                                                        let textColor = 'black';

                                                                                        if (element <= projectPriorityLevel) {
                                                                                            bgColor =
                                                                                                // projectPriorityLevel === 1 ? '#0a84ff' :
                                                                                                //     projectPriorityLevel === 2 ? '#09c748' :
                                                                                                //         projectPriorityLevel === 3 ? '#ffd608' :
                                                                                                //             projectPriorityLevel === 4 ? '#ff9a1e' :
                                                                                                //                 projectPriorityLevel === 5 ? '#f21c1c' : 'white';
                                                                                                projectPriorityLevel === 1 ? '#09c748' :
                                                                                                    projectPriorityLevel === 2 ? '#ffd608' :
                                                                                                        projectPriorityLevel === 3 ? '#f21c1c' : 'white';


                                                                                            textColor = 'white';
                                                                                        }

                                                                                        return (
                                                                                            <span
                                                                                                key={ind}
                                                                                                onClick={() => handleChangeProjectPriorityLevel(element)}
                                                                                                className={`me-3 align-items-center d-flex font-w600 fs-4 border justify-content-center rounded-circle cursor-pointer border-hovered`}
                                                                                                style={{
                                                                                                    height: '40px',
                                                                                                    width: '40px',
                                                                                                    border: projectPriorityLevel === element ? '2px solid black' : 'none',
                                                                                                    background: bgColor,
                                                                                                    color: textColor
                                                                                                }}
                                                                                            >
                                                                                                {element}
                                                                                            </span>
                                                                                        );
                                                                                    })}

                                                                                    <div>
                                                                                        <span className='fs-6 font-w600 text-black'>{`High`}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div> */}

                                                                        {!localStorage.getItem('projectId') && <div className='row mt-2'>
                                                                            <div className='col-12 px-0' >
                                                                                <div className="d-flex">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id="refund"
                                                                                        name="refund"
                                                                                        onChange={(e) => { setAITermsAndConditions(!AITermsAndConditions); setAITermsAndConditionsErr(false) }}
                                                                                        value={AITermsAndConditions}
                                                                                        checked={AITermsAndConditions}
                                                                                    />
                                                                                    <span
                                                                                        className='ps-3 pt-1 text-black fs-5'
                                                                                    >
                                                                                        {`I accept the`} <strong className='text-hovered cursor-pointer' onClick={() => { setModalTriggerAIterms(true) }}>{`Terms & Conditions`}</strong>
                                                                                    </span>
                                                                                </div>
                                                                                {AITermsAndConditionsErr &&
                                                                                    <div className='mt-2 text-danger fs-12'>
                                                                                        <span>{`Please accept the Terms & Conditions`}</span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </div>}




                                                                        <div className='row mx-0'>
                                                                            <div
                                                                                className='col-12 px-0 my-4'
                                                                                style={{
                                                                                    pointerEvents: AITermsAndConditions ? 'auto' : 'none',
                                                                                    opacity: AITermsAndConditions ? '1' : '0.5',
                                                                                }}
                                                                            >
                                                                                <PrimaryButton
                                                                                    buttonName={`NEXT`}
                                                                                    onClick={(e) => { handleCreateDIYProject(e) }}
                                                                                    isLoading={createUpdateProjectLoading}
                                                                                    loadingMessage={"LOADING..."}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                        fontWeight: '600',
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                    </form>

                                                                    {/* <div className='row mx-0'>
                                                                        <div className='col-12 px-0 my-3 d-flex justify-content-center align-items-center'>
                                                                            <span
                                                                                className='text-center font-w600 fs-5 text-decoration-underline cursor-pointer text-hovered text-blue d-flex justify-content-center align-items-center'
                                                                                onClick={() => {
                                                                                    if (localStorage.getItem('projectId')) {
                                                                                        navigate(-1)
                                                                                    } else {
                                                                                        handleCreateProjectStep(0.2);
                                                                                        setProjectTitleErr(false);
                                                                                        setProjectDescriptionErr(false);
                                                                                        handleClearProjectStates();
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {`Back`}
                                                                            </span>
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> :
                                                    createProjectStep === 2 ?
                                                        // Google AI suggestions for DIY project
                                                        <div className='col-md-6 d-flex justify-content-center align-items-center p-3 '>



                                                            <div className='row mx-0 w-100'>
                                                                <div className='col-12 d-flex justify-content-center align-items-center flex-column'>

                                                                    <div className='d-flex justify-content-between w-100 align-items-center mb-2'>
                                                                        <div
                                                                            className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center'
                                                                            onClick={() => {
                                                                                handleCreateProjectStep(1)
                                                                            }}
                                                                        >
                                                                            <i class="bi bi-arrow-left-short pe-2"></i>
                                                                            <span>{"Back"}</span>
                                                                        </div>

                                                                        {/* <div onClick={() => { }} className='overlay-action-btn text-hovered py-1 px-2 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center text-decoration-underline'>
                                                                    <span>{"Chat with A.I."}</span>
                                                                </div> */}
                                                                    </div>

                                                                    <div className='w-100'>

                                                                        <div className='d-flex justify-content-center mb-5'>
                                                                            <span className='text-black font-w600 fs-3 text-center'>{`Capture the Before`}</span>
                                                                        </div>

                                                                        <div className='d-flex justify-content-center mb-3'>
                                                                            <span className='font-w600 fs-5 text-center'>{`Archive the project before you make any changes.  Good to know what it looked like before you make it amazing!`}</span>
                                                                        </div>

                                                                        {discussionLoading ? <div className='row mx-0'>
                                                                            {[1, 2, 3].map((element, i) => {
                                                                                return (
                                                                                    <div key={i} className='col-12 p-3 rounded-3 border border-success border-2 mb-2'>
                                                                                        <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                        <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                        <SkeletonDivElement height={'20px'} width={'40%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </div> :
                                                                            <>
                                                                                {callNoteDetailsArr.length > 0 ?
                                                                                    <>
                                                                                        <div className='row mx-0'>
                                                                                            <div className='col-12 d-flex flex-wrap'>

                                                                                                {callNoteDetailsArr.map((element, i) => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <div
                                                                                                                key={i}
                                                                                                                className='rounded-2 d-flex justify-content-center align-items-center m-2 border-hovered'
                                                                                                                style={{ height: '90px', width: '90px', border: '2px solid orange' }}
                                                                                                            >
                                                                                                                {element?.image_url ?
                                                                                                                    <img
                                                                                                                        src={element?.image_url}
                                                                                                                        alt=""
                                                                                                                        className='w-100 h-100 cursor-pointer rounded-2'
                                                                                                                        style={{ objectFit: 'cover' }}
                                                                                                                        onClick={() => {
                                                                                                                            handleOpenDoc();
                                                                                                                            setImageAttachURL(element?.image_url);
                                                                                                                            setNotesMessage(element?.note_chr);
                                                                                                                            setNoteObject(element);

                                                                                                                            setIsNoteEdit(true);
                                                                                                                            setDiscussionVal(element?.note_chr);
                                                                                                                        }}
                                                                                                                    />
                                                                                                                    :
                                                                                                                    <span
                                                                                                                        style={{ fontSize: '60px' }}
                                                                                                                        className='cursor-pointer w-100 h-100 d-flex justify-content-center align-items-center'
                                                                                                                        onClick={() => {
                                                                                                                            setNoteObject(element);
                                                                                                                            // setToggleForPrjectNotes(2);
                                                                                                                            handleOpenProjectNotesModal();
                                                                                                                            setDiscussionVal(element?.note_chr);
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <i className='bi bi-list-ul' />
                                                                                                                    </span>
                                                                                                                }
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )
                                                                                                })}

                                                                                            </div>

                                                                                        </div>
                                                                                    </> :
                                                                                    <>
                                                                                        {
                                                                                            <div className='row mx-0'>
                                                                                                <div
                                                                                                    className='col-12 px-2 my-3 d-flex justify-content-center align-items-center'
                                                                                                    style={{ height: "320px" }}
                                                                                                >
                                                                                                    <img src={captureBeforeImg} alt="search" style={{ width: "100%", height: '100%' }} />
                                                                                                </div>
                                                                                            </div>}
                                                                                    </>}





                                                                                <div className='row mx-0 mt-5 mb-4'>
                                                                                    <div className='col-6 px-0 mt-2 pe-2'>
                                                                                        <PrimaryButton
                                                                                            buttonName={`ADD (Image / Note)`}
                                                                                            onClick={() => {
                                                                                                handleOpenProjectNotesModal();
                                                                                            }}
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                border: 'none',
                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                fontWeight: '600',
                                                                                            }}
                                                                                        />
                                                                                    </div>

                                                                                    <div className='col-6 px-0 mt-2 ps-2'>
                                                                                        <PrimaryButton
                                                                                            buttonName={`NEXT`}
                                                                                            onClick={(e) => {
                                                                                                saveProjectSuggestionsFn(e);
                                                                                                handleCreateProjectStep(3);
                                                                                            }}
                                                                                            isLoading={saveSuggestionsLoading}
                                                                                            loadingMessage={"LOADING..."}
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                fontWeight: '600',
                                                                                                height: '100%'
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </>}



                                                                        {/* <div className='row mx-0'>
                                                                            <div className='col-12 px-0 my-3 d-flex justify-content-center align-items-center'>
                                                                                <span
                                                                                    className='text-center font-w600 fs-5 text-decoration-underline cursor-pointer text-hovered text-blue d-flex justify-content-center align-items-center'
                                                                                    onClick={() => { handleCreateProjectStep(1) }}
                                                                                >
                                                                                    {`Back`}
                                                                                </span>
                                                                            </div>
                                                                        </div> */}
                                                                    </div>


                                                                </div>
                                                            </div>
                                                        </div> :
                                                        createProjectStep === 3 ?
                                                            // Add list, notes and images for DIY project
                                                            <div className='col-md-6 d-flex justify-content-center align-items-center p-3 mb-5'>
                                                                <div className='row mx-0 w-100'>
                                                                    <div className='col-12 d-flex justify-content-center align-items-center flex-column'>

                                                                        <div className='d-flex justify-content-between w-100 align-items-center mb-2'>
                                                                            <div
                                                                                className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center'
                                                                                onClick={() => { handleCreateProjectStep(2) }}
                                                                            >
                                                                                <i class="bi bi-arrow-left-short pe-2"></i>
                                                                                <span>{"Back"}</span>
                                                                            </div>

                                                                            <div
                                                                                onClick={() => {
                                                                                    getChatHistoryFn();
                                                                                    handleCreateProjectStep(4);
                                                                                }} className='overlay-action-btn text-hovered py-1 px-2 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center text-decoration-underline text-primary'
                                                                            >
                                                                                <span>{"Chat with A.I."}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className='w-100' ref={divAIsuggestionsRef}>

                                                                            {localStorage.getItem('projectId') || true ?
                                                                                <>
                                                                                    <div className='d-flex mb-5'>
                                                                                        <div className='d-flex w-100 me-2'>


                                                                                            <div
                                                                                                className={`rounded-2 overflow-hidden position-relative d-flex flex-column justify-content-center align-items-center ${attachedImage0 !== null ? 'cursor-pointer overlay-action-btn' : ''} shadow me-4`}
                                                                                                style={{ width: '120px', height: '90px', background: 'gray' }}
                                                                                            >
                                                                                                {attachedImage0 !== null ?
                                                                                                    <img
                                                                                                        src={attachedImage0}
                                                                                                        className='rounded-2 documents-individual-box-img'
                                                                                                        alt=""
                                                                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                                        onClick={() => {
                                                                                                            handleOpenDoc();
                                                                                                            setImageAttachURL(attachedImage0);
                                                                                                        }}
                                                                                                    /> :
                                                                                                    <>
                                                                                                        <div
                                                                                                            className='w-100 h-100 d-flex justify-content-center align-items-center flex-column cursor-pointer'
                                                                                                            onClick={() => { handleOpenModalAddPhoto() }}
                                                                                                        >
                                                                                                            <span>
                                                                                                                <i className="bi bi-plus-lg fs-4 text-white"></i>
                                                                                                            </span>
                                                                                                            <span className='font-w600 fs-7 text-white'>
                                                                                                                {`Add photo`}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </>
                                                                                                }
                                                                                            </div>

                                                                                            <div className='w-100 mt-2 d-flex flex-column'>
                                                                                                <span className='text-black font-w600 fs-4'>
                                                                                                    {`Project: ${projectTitle ? projectTitle : ''}`}
                                                                                                </span>

                                                                                                {projectCreatedDate ?
                                                                                                    <span className='font-w500 fs-5'>
                                                                                                        {`Created on: ${new Intl.DateTimeFormat("en-US", {
                                                                                                            year: "numeric",
                                                                                                            month: "short",
                                                                                                            day: "numeric",
                                                                                                            hour: 'numeric',
                                                                                                            minute: 'numeric',
                                                                                                            hour12: true
                                                                                                        }).format(
                                                                                                            projectCreatedDate * 1000
                                                                                                        )}`}
                                                                                                    </span> : ''}
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='ms-2 mt-2'>
                                                                                            <OverlayTrigger
                                                                                                trigger="click"
                                                                                                placement="bottom"
                                                                                                overlay={popoverProjectctions}
                                                                                                rootClose={true}
                                                                                                show={showPopover}
                                                                                                onToggle={(isOpen) => setShowPopover(isOpen)}
                                                                                            >
                                                                                                <span className='fs-3 text-black cursor-pointer overlay-action-btn rounded-circle p-1 px-2 d-flex align-items-center justify-content-center'>
                                                                                                    <i class="bi bi-three-dots-vertical"></i>
                                                                                                </span>
                                                                                            </OverlayTrigger>
                                                                                        </div>
                                                                                    </div>
                                                                                </> :
                                                                                <div className='d-flex justify-content-center mb-5'>
                                                                                    <span className='text-black font-w600 fs-3 text-center'>{`Build Your Plan`}</span>
                                                                                </div>
                                                                            }

                                                                            <div className='d-flex justify-content-center mb-3'>
                                                                                <span className='font-w600 fs-5 text-center'>
                                                                                    {localStorage.getItem('projectId') ?
                                                                                        `Click on a project step to get more information and access to the tools` :
                                                                                        `Add Steps to the project plan plus use the Chilll tools to make the plan even better. You can entries later.`}
                                                                                </span>
                                                                            </div>




                                                                            {savedProjectSuggestionsLoading ? <div className='row mx-0'>
                                                                                {[1, 2, 3].map((element, i) => {
                                                                                    return (
                                                                                        <div key={i} className='col-12 p-3 rounded-3 border border-success border-2 mb-2'>
                                                                                            <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                            <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                            <SkeletonDivElement height={'20px'} width={'40%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div> :
                                                                                <>
                                                                                    {/* A.I. suggestions steps new flow */}
                                                                                    <div className='row mx-0 mb-3'>
                                                                                        <div
                                                                                            className='col-12 d-flex justify-content-center align-items-center position-relative p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                            style={{
                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                setIsSummaryExpanded(!isSummaryExpanded);
                                                                                            }}
                                                                                        >
                                                                                            <span className='fs-4 text-white font-w600'>{`Summary`}</span>

                                                                                            <span style={{ right: '10px' }} className='position-absolute fs-2 text-white font-w600'>
                                                                                                {isSummaryExpanded ? <i className='bi bi-caret-down-fill'></i> : <i className='bi bi-caret-right-fill'></i>}
                                                                                            </span>
                                                                                        </div>

                                                                                        {isSummaryExpanded && <div className='col-12 p-2'>
                                                                                            {summaryProjectSuggestionsArr.length > 0 ?
                                                                                                <>
                                                                                                    <div className='row mx-0'>
                                                                                                        {summaryProjectSuggestionsArr.map((element, i) => {
                                                                                                            return (
                                                                                                                <>
                                                                                                                    {isForEditSuggestion && particularProjectSuggestionObj?.project_suggestion_id_ids == element?.project_suggestion_id_ids ?
                                                                                                                        <React.Fragment key={i}> </React.Fragment> :
                                                                                                                        <>
                                                                                                                            <div
                                                                                                                                key={i}
                                                                                                                                className={`col-12 rounded-3 mb-2 text-black p-3 border border-primary border-3 fs-4 font-w600 position-relative d-flex`}
                                                                                                                                style={{
                                                                                                                                    // background: element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids ? '#a3cc90bf' : 'rgb(128 128 128 / 9%)' 
                                                                                                                                    // background: i < 3 ? '#ffa50061' : element?.step_completion_status_int ? '#a3cc90bf' : 'rgb(128 128 128 / 9%)'
                                                                                                                                    background: '#ffa50061',
                                                                                                                                }}
                                                                                                                                onClick={(e) => {
                                                                                                                                    // e.stopPropagation();
                                                                                                                                    e.preventDefault();
                                                                                                                                    // if (element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids) {
                                                                                                                                    //     setParticularProjectSuggestionObj({});
                                                                                                                                    // } else {
                                                                                                                                    //     setParticularProjectSuggestionObj(element);
                                                                                                                                    // }
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                {/* <span
                                                                                                                            className='position-absolute text-danger top-0 end-0 me-2 mt-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                                                            onClick={(e) => {
                                                                                                                                e.stopPropagation();
                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                handleOpenProjectSuggestionsModal();
                                                                                                                                setToggleForSavedProjectSuggestions(1);
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                        </span> */}

                                                                                                                                <div className='d-flex justify-content-center  pe-2'>

                                                                                                                                    <div className='d-flex justify-content-center mb-3 rounded-2' style={{ width: '60px', height: '45px', }}>
                                                                                                                                        <img
                                                                                                                                            src={element?.default_img}
                                                                                                                                            alt=""
                                                                                                                                            style={{ width: '80%', objectFit: 'contain' }}
                                                                                                                                        />
                                                                                                                                    </div>

                                                                                                                                </div>


                                                                                                                                {/* <div className='w-100'>
                                                                                                                            <span>{`Step ${i + 1} - ${element?.suggestion_description_chr}`}</span>
                                                                                                                        </div> */}

                                                                                                                                <div className='w-100'>
                                                                                                                                    <span>
                                                                                                                                        {`${element?.suggestion_description_chr}`
                                                                                                                                            .split("/n")
                                                                                                                                            .map((line, index) => (
                                                                                                                                                <React.Fragment key={index}>
                                                                                                                                                    {index === 0 ? line : <><br />{line}</>}
                                                                                                                                                </React.Fragment>))}
                                                                                                                                    </span>
                                                                                                                                </div>

                                                                                                                                <div className='ps-2'>
                                                                                                                                    <div className='d-flex justify-content-end align-items-center flex-column'>




                                                                                                                                        {/* <span
                                                                                                                                    className='mb-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        e?.preventDefault();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        setIsForEditSuggestion(true);
                                                                                                                                        setNewSuggestion(element?.suggestion_description_chr)
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className={`bi bi-pencil`} style={{ fontSize: '14px' }}></i>
                                                                                                                                </span>

                                                                                                                                <span
                                                                                                                                    className='text-danger bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        e?.preventDefault();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        handleOpenProjectSuggestionsModal();
                                                                                                                                        setToggleForSavedProjectSuggestions(1);
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                                </span> */}

                                                                                                                                        {(element.purchase_list_count || element.notes_count) && false ?
                                                                                                                                            <span
                                                                                                                                                className='mb-2 text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                                style={{ height: '25px', width: '25px' }}
                                                                                                                                                onClick={(e) => {
                                                                                                                                                    e.stopPropagation();
                                                                                                                                                    if (element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids) {
                                                                                                                                                        setParticularProjectSuggestionObj({});
                                                                                                                                                    } else {
                                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                                    }
                                                                                                                                                    // handleOpenProjectSuggestionsModal();
                                                                                                                                                    // setToggleForSavedProjectSuggestions(1);
                                                                                                                                                    // setIsForEditSuggestion(true);
                                                                                                                                                    // setNewSuggestion(element?.suggestion_description_chr)
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                {element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids ?
                                                                                                                                                    <i className={`bi bi-caret-up-fill`} style={{ fontSize: '14px' }}></i> :
                                                                                                                                                    <i className={`bi bi-caret-down-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                                                }
                                                                                                                                            </span> : ""}
                                                                                                                                    </div>
                                                                                                                                </div>


                                                                                                                            </div>


                                                                                                                        </>}
                                                                                                                </>
                                                                                                            )
                                                                                                        })}
                                                                                                    </div>
                                                                                                </> :
                                                                                                <>
                                                                                                    <div className='row mx-0'>
                                                                                                        {!isAdding && <div className='col-12 px-2 my-3 d-flex justify-content-center align-items-center flex-column'>
                                                                                                            <div className="mb-2">
                                                                                                                <img src={emptyListImg} alt="search" style={{ width: "120px" }} />
                                                                                                            </div>
                                                                                                            <span className='fs-5 text-center'>{``}</span>
                                                                                                        </div>}
                                                                                                    </div>
                                                                                                </>
                                                                                            }
                                                                                        </div>}
                                                                                    </div>

                                                                                    <div className='row mx-0 mb-2'>
                                                                                        <div
                                                                                            className='col-12 d-flex justify-content-center align-items-center position-relative p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                            style={{
                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                setIsPlanExpanded(!isPlanExpanded);
                                                                                            }}
                                                                                        >
                                                                                            <span className='fs-4 text-white font-w600'>{`The Plan`}</span>

                                                                                            <span style={{ right: '10px' }} className='position-absolute fs-2 text-white font-w600'>
                                                                                                {isPlanExpanded ? <i className='bi bi-caret-down-fill'></i> : <i className='bi bi-caret-right-fill'></i>}
                                                                                            </span>
                                                                                        </div>


                                                                                        {isPlanExpanded && <div className='col-12 p-2'>
                                                                                            {planProjectSuggestionsArr.length > 0 ?
                                                                                                <>
                                                                                                    <div className='row mx-0'>
                                                                                                        {planProjectSuggestionsArr.map((element, i) => {
                                                                                                            return (
                                                                                                                <>
                                                                                                                    {isForEditSuggestion && particularProjectSuggestionObj?.project_suggestion_id_ids == element?.project_suggestion_id_ids ?
                                                                                                                        <>
                                                                                                                            <div key={i} className="mt-3 w-100 d-flex">
                                                                                                                                <div className="w-100 me-2">

                                                                                                                                    <TextArea
                                                                                                                                        labelName={`Edit step`}
                                                                                                                                        placeholder={`Description`}
                                                                                                                                        value={newSuggestion}
                                                                                                                                        onChange={(e) => setNewSuggestion(e.target.value)}
                                                                                                                                        onBlur={() => { }}
                                                                                                                                        errorOccured={false}
                                                                                                                                        errorMessage={"Please enter step"}
                                                                                                                                    />

                                                                                                                                    {!newSuggestion && <small className='text-danger font-w600 '>{`Please enter step`}</small>}
                                                                                                                                </div>
                                                                                                                                <div className='d-flex flex-column'>
                                                                                                                                    <span
                                                                                                                                        className="mb-2 rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                                                        style={{
                                                                                                                                            height: "35px",
                                                                                                                                            width: "35px",
                                                                                                                                            color: "#1FBF75",
                                                                                                                                            border: "2px solid #1FBF75",
                                                                                                                                            pointerEvents: saveSuggestionsLoading ? 'none' : 'auto',
                                                                                                                                            opacity: saveSuggestionsLoading ? '0.5' : '1',
                                                                                                                                        }}
                                                                                                                                        onClick={() => {
                                                                                                                                            // handleAddSuggestion()
                                                                                                                                            saveIndividualProjectSuggestionsFn();
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {saveSuggestionsLoading ? <Spinner size='sm' /> : <i className={`bi bi-check2`} style={{ fontSize: "18px" }}></i>}
                                                                                                                                    </span>

                                                                                                                                    <span
                                                                                                                                        className="rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                                                        style={{ height: "35px", width: "35px", color: "red", border: "2px solid red" }}
                                                                                                                                        onClick={() => {
                                                                                                                                            setIsAdding(false);
                                                                                                                                            setNewSuggestion('');
                                                                                                                                            setIsForEditSuggestion(false);
                                                                                                                                            setParticularProjectSuggestionObj({});
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <i className={`bi bi-x`} style={{ fontSize: "18px" }}></i>
                                                                                                                                    </span>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </> :
                                                                                                                        <>
                                                                                                                            <div
                                                                                                                                key={i}
                                                                                                                                className={`col-12 rounded-3 mb-2 text-black p-3 border border-success  border-3 fs-4 font-w600 position-relative d-flex`}
                                                                                                                                style={{
                                                                                                                                    // background: element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids ? '#a3cc90bf' : 'rgb(128 128 128 / 9%)' 
                                                                                                                                    background: element?.step_completion_status_int ? '#a3cc90bf' : 'rgb(128 128 128 / 9%)'
                                                                                                                                }}
                                                                                                                                onClick={(e) => {
                                                                                                                                    // e.stopPropagation();
                                                                                                                                    e.preventDefault();
                                                                                                                                    // if (element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids) {
                                                                                                                                    //     setParticularProjectSuggestionObj({});
                                                                                                                                    // } else {
                                                                                                                                    //     setParticularProjectSuggestionObj(element);
                                                                                                                                    // }
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                {/* <span
                                                                                                                            className='position-absolute text-danger top-0 end-0 me-2 mt-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                                                            onClick={(e) => {
                                                                                                                                e.stopPropagation();
                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                handleOpenProjectSuggestionsModal();
                                                                                                                                setToggleForSavedProjectSuggestions(1);
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                        </span> */}

                                                                                                                                {/* <div className='d-flex justify-content-center  pe-2'>
                                                                                                                            {i <= 2 ?
                                                                                                                                <>
                                                                                                                                    <div className='d-flex justify-content-center mb-3 rounded-2' style={{ width: '60px', height: '45px', }}>
                                                                                                                                        <img
                                                                                                                                            src={i == 0 ? skillSummaryImg : i == 1 ? costTimeImg : i == 2 ? toolsImg : ''}
                                                                                                                                            alt=""
                                                                                                                                            style={{ width: '80%', objectFit: 'contain' }}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                </> : <></>
                                                                                                                            }
                                                                                                                        </div> */}

                                                                                                                                <div className='d-flex justify-content-center  pe-2'>
                                                                                                                                    {
                                                                                                                                        localStorage.getItem('projectId') ?
                                                                                                                                            <input
                                                                                                                                                type="checkbox"
                                                                                                                                                checked={element?.step_completion_status_int}
                                                                                                                                                className="form-check-input"
                                                                                                                                                id="customCheckBox4"
                                                                                                                                                onChange={(e) => {
                                                                                                                                                    e?.stopPropagation();
                                                                                                                                                    e?.preventDefault();
                                                                                                                                                    updateIndividualSuggestionsStatus(element);
                                                                                                                                                    setParticularProjectSuggestionObj(element);
                                                                                                                                                }}
                                                                                                                                            /> : ''
                                                                                                                                    }
                                                                                                                                </div>
                                                                                                                                {/* <div className='w-100'>
                                                                                                                            <span>{`Step ${i + 1} - ${element?.suggestion_description_chr}`}</span>
                                                                                                                        </div> */}

                                                                                                                                <div className='w-100'>
                                                                                                                                    <span>
                                                                                                                                        {`${`Step ${i + 1} - `}${element?.suggestion_description_chr}`}
                                                                                                                                    </span>
                                                                                                                                </div>

                                                                                                                                <div className='ps-2'>
                                                                                                                                    <div className='d-flex justify-content-end align-items-center flex-column'>

                                                                                                                                        <OverlayTrigger
                                                                                                                                            key={i}
                                                                                                                                            trigger="click"
                                                                                                                                            placement="bottom"
                                                                                                                                            // overlay={popover}
                                                                                                                                            overlay={popoverSuggestionStepActions(i)}
                                                                                                                                            rootClose={true}
                                                                                                                                            show={activePopoverShopping === i}
                                                                                                                                            onToggle={(show) => setActivePopoverShopping(show ? i : null)}
                                                                                                                                        >
                                                                                                                                            <span
                                                                                                                                                className='mb-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                                style={{ height: '30px', width: '30px' }}
                                                                                                                                                onClick={(e) => {
                                                                                                                                                    e.stopPropagation();
                                                                                                                                                    e?.preventDefault();

                                                                                                                                                    // setParticularProjectSuggestionObj(element);
                                                                                                                                                    // setIsForEditSuggestion(true);
                                                                                                                                                    // setNewSuggestion(element?.suggestion_description_chr)

                                                                                                                                                    handleMenuClickSuggestionStep(element, i);
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                <i className={`bi bi-three-dots-vertical`} style={{ fontSize: '18px' }}></i>
                                                                                                                                            </span>

                                                                                                                                        </OverlayTrigger>





                                                                                                                                        {/* <span
                                                                                                                                    className='mb-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        e?.preventDefault();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        setIsForEditSuggestion(true);
                                                                                                                                        setNewSuggestion(element?.suggestion_description_chr)
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className={`bi bi-pencil`} style={{ fontSize: '14px' }}></i>
                                                                                                                                </span>

                                                                                                                                <span
                                                                                                                                    className='text-danger bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        e?.preventDefault();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        handleOpenProjectSuggestionsModal();
                                                                                                                                        setToggleForSavedProjectSuggestions(1);
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                                </span> */}

                                                                                                                                        {(element.purchase_list_count || element.notes_count) && false ?
                                                                                                                                            <span
                                                                                                                                                className='mb-2 text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                                style={{ height: '25px', width: '25px' }}
                                                                                                                                                onClick={(e) => {
                                                                                                                                                    e.stopPropagation();
                                                                                                                                                    if (element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids) {
                                                                                                                                                        setParticularProjectSuggestionObj({});
                                                                                                                                                    } else {
                                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                                    }
                                                                                                                                                    // handleOpenProjectSuggestionsModal();
                                                                                                                                                    // setToggleForSavedProjectSuggestions(1);
                                                                                                                                                    // setIsForEditSuggestion(true);
                                                                                                                                                    // setNewSuggestion(element?.suggestion_description_chr)
                                                                                                                                                }}
                                                                                                                                            >
                                                                                                                                                {element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids ?
                                                                                                                                                    <i className={`bi bi-caret-up-fill`} style={{ fontSize: '14px' }}></i> :
                                                                                                                                                    <i className={`bi bi-caret-down-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                                                }
                                                                                                                                            </span> : ""}
                                                                                                                                    </div>
                                                                                                                                </div>


                                                                                                                            </div>

                                                                                                                            {true &&
                                                                                                                                <div className='row mx-0 mb-2'>
                                                                                                                                    <div className='col-12 d-flex justify-content-between px-2'>
                                                                                                                                        <div
                                                                                                                                            className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                            style={{ width: '50px', position: 'relative' }}
                                                                                                                                            onClick={(e) => {
                                                                                                                                                e.stopPropagation();
                                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                                handleOpenProjectSuggestionsModal();
                                                                                                                                                setToggleForSavedProjectSuggestions(2);

                                                                                                                                                if (element.purchase_list_count == 0) {
                                                                                                                                                    setToggleForShoppingListDIY(2);
                                                                                                                                                }

                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            {element.purchase_list_count ? <span style={{ position: 'absolute', top: '0', right: '0', fontSize: '9px', color: 'white', height: '14px', width: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%', background: 'grey' }}>{element.purchase_list_count}</span> : ""}
                                                                                                                                            <span className="">
                                                                                                                                                <MdChecklistRtl
                                                                                                                                                    style={{ width: "20px", height: "20px" }}
                                                                                                                                                />
                                                                                                                                            </span>
                                                                                                                                            <span className="mt-1 text-center font-w600 text-black">List</span>
                                                                                                                                        </div>

                                                                                                                                        <div
                                                                                                                                            className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                            style={{ width: '50px', position: 'relative' }}
                                                                                                                                            onClick={(e) => {
                                                                                                                                                e.stopPropagation();
                                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                                handleOpenProjectSuggestionsModal();
                                                                                                                                                setToggleForSavedProjectSuggestions(3);
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            <span className="" >
                                                                                                                                                {element.notes_count ? <span style={{ position: 'absolute', top: '0', right: '0', fontSize: '9px', color: 'white', height: '14px', width: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%', background: 'grey' }}>{element.notes_count}</span> : ''}
                                                                                                                                                <CgNotes
                                                                                                                                                    onClick={() => { }}
                                                                                                                                                    style={{ width: "20px", height: "20px" }}
                                                                                                                                                />
                                                                                                                                            </span>
                                                                                                                                            <span className="mt-1 text-center font-w600 text-black">Notes</span>
                                                                                                                                        </div>

                                                                                                                                        <div
                                                                                                                                            className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                            style={{
                                                                                                                                                width: '50px',
                                                                                                                                            }}
                                                                                                                                            onClick={(e) => {
                                                                                                                                                e.stopPropagation();
                                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                                setToggleForDrawing(true);
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            <span className="">
                                                                                                                                                <MdDraw
                                                                                                                                                    onClick={() => { }}
                                                                                                                                                    style={{ width: "20px", height: "20px" }}
                                                                                                                                                />
                                                                                                                                            </span>
                                                                                                                                            <span className="mt-1 text-center font-w600 text-black">Draw</span>
                                                                                                                                        </div>

                                                                                                                                        <div
                                                                                                                                            className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                            style={{ width: '50px', }}
                                                                                                                                            onClick={(e) => {
                                                                                                                                                e.stopPropagation();
                                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                                getCameraStream();
                                                                                                                                                setToggleForAddImage(true);
                                                                                                                                                setToggleForCameraActions(3);
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            <span className="">
                                                                                                                                                <IoIosQrScanner
                                                                                                                                                    onClick={() => { }}
                                                                                                                                                    style={{ width: "20px", height: "20px" }}
                                                                                                                                                />
                                                                                                                                            </span>
                                                                                                                                            <span className="mt-1 text-center font-w600 text-black">OCR</span>
                                                                                                                                        </div>

                                                                                                                                        <div
                                                                                                                                            className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                            style={{ width: '50px', }}
                                                                                                                                            onClick={(e) => {
                                                                                                                                                e.stopPropagation();
                                                                                                                                                handleOpenModalMeasuringInstruction();
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            <span className="">
                                                                                                                                                <TbRulerMeasure
                                                                                                                                                    onClick={() => { }}
                                                                                                                                                    style={{ width: "20px", height: "20px" }}
                                                                                                                                                />
                                                                                                                                            </span>
                                                                                                                                            <span className="mt-1 text-center font-w600 text-black">Measure</span>
                                                                                                                                        </div>
                                                                                                                                    </div>

                                                                                                                                    {element?.call_log_notes?.map((item, i) => {
                                                                                                                                        return (
                                                                                                                                            <>
                                                                                                                                                {item?.image_url &&
                                                                                                                                                    <div
                                                                                                                                                        key={i}
                                                                                                                                                        className='rounded-3 d-flex justify-content-center align-items-center m-2 border-hovered'
                                                                                                                                                        style={{ height: '55px', width: '55px', border: '1px solid black' }}
                                                                                                                                                    >
                                                                                                                                                        <img
                                                                                                                                                            src={item?.image_url}
                                                                                                                                                            alt=""
                                                                                                                                                            className='w-100 h-100 cursor-pointer rounded-3'
                                                                                                                                                            style={{ objectFit: 'cover' }}
                                                                                                                                                            onClick={() => {
                                                                                                                                                                handleOpenDoc();
                                                                                                                                                                setImageAttachURL(item?.image_url);
                                                                                                                                                                setNotesMessage(item?.note_chr);

                                                                                                                                                                setNoteObject(item);
                                                                                                                                                                setDiscussionVal(item?.note_chr);
                                                                                                                                                                setIsNoteEdit(true);

                                                                                                                                                            }}
                                                                                                                                                        />
                                                                                                                                                    </div>
                                                                                                                                                }
                                                                                                                                            </>
                                                                                                                                        )
                                                                                                                                    })}
                                                                                                                                </div>}
                                                                                                                        </>}
                                                                                                                </>
                                                                                                            )
                                                                                                        })}
                                                                                                    </div>
                                                                                                </> :
                                                                                                <>
                                                                                                    <div className='row mx-0'>
                                                                                                        {!isAdding && <div className='col-12 px-2 my-3 d-flex justify-content-center align-items-center flex-column'>
                                                                                                            <div className="mb-2">
                                                                                                                <img src={emptyListImg} alt="search" style={{ width: "120px" }} />
                                                                                                            </div>
                                                                                                            <span className='fs-5 text-center'>{`No steps found. Please add some steps`}</span>
                                                                                                        </div>}
                                                                                                    </div>
                                                                                                </>
                                                                                            }
                                                                                        </div>}
                                                                                    </div>


                                                                                    {savedProjectSuggestionsArr.length > 0 && false ?
                                                                                        <>
                                                                                            <div className='row mx-0'>
                                                                                                {savedProjectSuggestionsArr.map((element, i) => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            {isForEditSuggestion && particularProjectSuggestionObj?.project_suggestion_id_ids == element?.project_suggestion_id_ids ?
                                                                                                                <>
                                                                                                                    <div key={i} className="mt-3 w-100 d-flex">
                                                                                                                        <div className="w-100 me-2">

                                                                                                                            <TextArea
                                                                                                                                labelName={`Edit step`}
                                                                                                                                placeholder={`Description`}
                                                                                                                                value={newSuggestion}
                                                                                                                                onChange={(e) => setNewSuggestion(e.target.value)}
                                                                                                                                onBlur={() => { }}
                                                                                                                                errorOccured={false}
                                                                                                                                errorMessage={"Please enter step"}
                                                                                                                            />

                                                                                                                            {!newSuggestion && <small className='text-danger font-w600 '>{`Please enter step`}</small>}
                                                                                                                        </div>
                                                                                                                        <div className='d-flex flex-column'>
                                                                                                                            <span
                                                                                                                                className="mb-2 rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                                                style={{
                                                                                                                                    height: "35px",
                                                                                                                                    width: "35px",
                                                                                                                                    color: "#1FBF75",
                                                                                                                                    border: "2px solid #1FBF75",
                                                                                                                                    pointerEvents: saveSuggestionsLoading ? 'none' : 'auto',
                                                                                                                                    opacity: saveSuggestionsLoading ? '0.5' : '1',
                                                                                                                                }}
                                                                                                                                onClick={() => {
                                                                                                                                    // handleAddSuggestion()
                                                                                                                                    saveIndividualProjectSuggestionsFn();
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                {saveSuggestionsLoading ? <Spinner size='sm' /> : <i className={`bi bi-check2`} style={{ fontSize: "18px" }}></i>}
                                                                                                                            </span>

                                                                                                                            <span
                                                                                                                                className="rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                                                style={{ height: "35px", width: "35px", color: "red", border: "2px solid red" }}
                                                                                                                                onClick={() => {
                                                                                                                                    setIsAdding(false);
                                                                                                                                    setNewSuggestion('');
                                                                                                                                    setIsForEditSuggestion(false);
                                                                                                                                    setParticularProjectSuggestionObj({});
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                <i className={`bi bi-x`} style={{ fontSize: "18px" }}></i>
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </> :
                                                                                                                <>
                                                                                                                    <div
                                                                                                                        key={i}
                                                                                                                        className={`col-12 rounded-3 mb-2 text-black p-3 border ${i < 3 ? 'border-primary' : 'border-success'}  border-3 fs-4 font-w600 position-relative d-flex`}
                                                                                                                        style={{
                                                                                                                            // background: element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids ? '#a3cc90bf' : 'rgb(128 128 128 / 9%)' 
                                                                                                                            background: i < 3 ? '#ffa50061' : element?.step_completion_status_int ? '#a3cc90bf' : 'rgb(128 128 128 / 9%)'
                                                                                                                        }}
                                                                                                                        onClick={(e) => {
                                                                                                                            // e.stopPropagation();
                                                                                                                            e.preventDefault();
                                                                                                                            // if (element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids) {
                                                                                                                            //     setParticularProjectSuggestionObj({});
                                                                                                                            // } else {
                                                                                                                            //     setParticularProjectSuggestionObj(element);
                                                                                                                            // }
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {/* <span
                                                                                                                            className='position-absolute text-danger top-0 end-0 me-2 mt-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                                                            onClick={(e) => {
                                                                                                                                e.stopPropagation();
                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                handleOpenProjectSuggestionsModal();
                                                                                                                                setToggleForSavedProjectSuggestions(1);
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                        </span> */}

                                                                                                                        <div className='d-flex justify-content-center  pe-2'>
                                                                                                                            {i <= 2 ?
                                                                                                                                <>
                                                                                                                                    <div className='d-flex justify-content-center mb-3 rounded-2' style={{ width: '60px', height: '45px', }}>
                                                                                                                                        <img
                                                                                                                                            src={i == 0 ? skillSummaryImg : i == 1 ? costTimeImg : i == 2 ? toolsImg : ''}
                                                                                                                                            alt=""
                                                                                                                                            style={{ width: '80%', objectFit: 'contain' }}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                </> : <></>
                                                                                                                            }
                                                                                                                        </div>

                                                                                                                        <div className='d-flex justify-content-center  pe-2'>
                                                                                                                            {i > 2 ?
                                                                                                                                localStorage.getItem('projectId') ?
                                                                                                                                    <input
                                                                                                                                        type="checkbox"
                                                                                                                                        checked={element?.step_completion_status_int}
                                                                                                                                        className="form-check-input"
                                                                                                                                        id="customCheckBox4"
                                                                                                                                        onChange={(e) => {
                                                                                                                                            e?.stopPropagation();
                                                                                                                                            e?.preventDefault();
                                                                                                                                            updateIndividualSuggestionsStatus(element);
                                                                                                                                            setParticularProjectSuggestionObj(element);
                                                                                                                                        }}
                                                                                                                                    /> : '' : ''
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                        {/* <div className='w-100'>
                                                                                                                            <span>{`Step ${i + 1} - ${element?.suggestion_description_chr}`}</span>
                                                                                                                        </div> */}

                                                                                                                        <div className='w-100'>
                                                                                                                            <span>
                                                                                                                                {`${i > 2 ? `Step ${i - 2} - ` : ''}${element?.suggestion_description_chr}`
                                                                                                                                    .split("/n")
                                                                                                                                    .map((line, index) => (
                                                                                                                                        <React.Fragment key={index}>
                                                                                                                                            {index === 0 ? line : <><br />{line}</>}
                                                                                                                                        </React.Fragment>))}
                                                                                                                            </span>
                                                                                                                        </div>

                                                                                                                        <div className='ps-2'>
                                                                                                                            <div className='d-flex justify-content-end align-items-center flex-column'>
                                                                                                                                {i > 2 &&
                                                                                                                                    <OverlayTrigger
                                                                                                                                        key={i}
                                                                                                                                        trigger="click"
                                                                                                                                        placement="bottom"
                                                                                                                                        // overlay={popover}
                                                                                                                                        overlay={popoverSuggestionStepActions(i)}
                                                                                                                                        rootClose={true}
                                                                                                                                        show={activePopoverShopping === i}
                                                                                                                                        onToggle={(show) => setActivePopoverShopping(show ? i : null)}
                                                                                                                                    >
                                                                                                                                        <span
                                                                                                                                            className='mb-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                            style={{ height: '30px', width: '30px' }}
                                                                                                                                            onClick={(e) => {
                                                                                                                                                e.stopPropagation();
                                                                                                                                                e?.preventDefault();

                                                                                                                                                // setParticularProjectSuggestionObj(element);
                                                                                                                                                // setIsForEditSuggestion(true);
                                                                                                                                                // setNewSuggestion(element?.suggestion_description_chr)

                                                                                                                                                handleMenuClickSuggestionStep(element, i);
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            <i className={`bi bi-three-dots-vertical`} style={{ fontSize: '18px' }}></i>
                                                                                                                                        </span>

                                                                                                                                    </OverlayTrigger>}





                                                                                                                                {/* <span
                                                                                                                                    className='mb-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        e?.preventDefault();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        setIsForEditSuggestion(true);
                                                                                                                                        setNewSuggestion(element?.suggestion_description_chr)
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className={`bi bi-pencil`} style={{ fontSize: '14px' }}></i>
                                                                                                                                </span>

                                                                                                                                <span
                                                                                                                                    className='text-danger bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        e?.preventDefault();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        handleOpenProjectSuggestionsModal();
                                                                                                                                        setToggleForSavedProjectSuggestions(1);
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                                </span> */}

                                                                                                                                {(element.purchase_list_count || element.notes_count) && false ?
                                                                                                                                    <span
                                                                                                                                        className='mb-2 text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                        style={{ height: '25px', width: '25px' }}
                                                                                                                                        onClick={(e) => {
                                                                                                                                            e.stopPropagation();
                                                                                                                                            if (element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids) {
                                                                                                                                                setParticularProjectSuggestionObj({});
                                                                                                                                            } else {
                                                                                                                                                setParticularProjectSuggestionObj(element);
                                                                                                                                            }
                                                                                                                                            // handleOpenProjectSuggestionsModal();
                                                                                                                                            // setToggleForSavedProjectSuggestions(1);
                                                                                                                                            // setIsForEditSuggestion(true);
                                                                                                                                            // setNewSuggestion(element?.suggestion_description_chr)
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {element?.project_suggestion_id_ids === particularProjectSuggestionObj?.project_suggestion_id_ids ?
                                                                                                                                            <i className={`bi bi-caret-up-fill`} style={{ fontSize: '14px' }}></i> :
                                                                                                                                            <i className={`bi bi-caret-down-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                                                        }
                                                                                                                                    </span> : ""}
                                                                                                                            </div>
                                                                                                                        </div>


                                                                                                                    </div>

                                                                                                                    {(i > 2) &&
                                                                                                                        <div className='row mx-0 mb-2'>
                                                                                                                            <div className='col-12 d-flex justify-content-between px-2'>
                                                                                                                                <div
                                                                                                                                    className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                    style={{ width: '50px', position: 'relative' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        handleOpenProjectSuggestionsModal();
                                                                                                                                        setToggleForSavedProjectSuggestions(2);

                                                                                                                                        if (element.purchase_list_count == 0) {
                                                                                                                                            setToggleForShoppingListDIY(2);
                                                                                                                                        }

                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {element.purchase_list_count ? <span style={{ position: 'absolute', top: '0', right: '0', fontSize: '9px', color: 'white', height: '14px', width: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%', background: 'grey' }}>{element.purchase_list_count}</span> : ""}
                                                                                                                                    <span className="">
                                                                                                                                        <MdChecklistRtl
                                                                                                                                            style={{ width: "20px", height: "20px" }}
                                                                                                                                        />
                                                                                                                                    </span>
                                                                                                                                    <span className="mt-1 text-center font-w600 text-black">List</span>
                                                                                                                                </div>

                                                                                                                                <div
                                                                                                                                    className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                    style={{ width: '50px', position: 'relative' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        handleOpenProjectSuggestionsModal();
                                                                                                                                        setToggleForSavedProjectSuggestions(3);
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <span className="" >
                                                                                                                                        {element.notes_count ? <span style={{ position: 'absolute', top: '0', right: '0', fontSize: '9px', color: 'white', height: '14px', width: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50%', background: 'grey' }}>{element.notes_count}</span> : ''}
                                                                                                                                        <CgNotes
                                                                                                                                            onClick={() => { }}
                                                                                                                                            style={{ width: "20px", height: "20px" }}
                                                                                                                                        />
                                                                                                                                    </span>
                                                                                                                                    <span className="mt-1 text-center font-w600 text-black">Notes</span>
                                                                                                                                </div>

                                                                                                                                <div
                                                                                                                                    className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                    style={{
                                                                                                                                        width: '50px',
                                                                                                                                    }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        setToggleForDrawing(true);
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <span className="">
                                                                                                                                        <MdDraw
                                                                                                                                            onClick={() => { }}
                                                                                                                                            style={{ width: "20px", height: "20px" }}
                                                                                                                                        />
                                                                                                                                    </span>
                                                                                                                                    <span className="mt-1 text-center font-w600 text-black">Draw</span>
                                                                                                                                </div>

                                                                                                                                <div
                                                                                                                                    className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                    style={{ width: '50px', }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        setParticularProjectSuggestionObj(element);
                                                                                                                                        getCameraStream();
                                                                                                                                        setToggleForAddImage(true);
                                                                                                                                        setToggleForCameraActions(3);
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <span className="">
                                                                                                                                        <IoIosQrScanner
                                                                                                                                            onClick={() => { }}
                                                                                                                                            style={{ width: "20px", height: "20px" }}
                                                                                                                                        />
                                                                                                                                    </span>
                                                                                                                                    <span className="mt-1 text-center font-w600 text-black">OCR</span>
                                                                                                                                </div>

                                                                                                                                <div
                                                                                                                                    className='d-flex align-items-center justify-content-center flex-column p-2 cursor-pointer overlay-action-btn rounded-3'
                                                                                                                                    style={{ width: '50px', }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        handleOpenModalMeasuringInstruction();
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <span className="">
                                                                                                                                        <TbRulerMeasure
                                                                                                                                            onClick={() => { }}
                                                                                                                                            style={{ width: "20px", height: "20px" }}
                                                                                                                                        />
                                                                                                                                    </span>
                                                                                                                                    <span className="mt-1 text-center font-w600 text-black">Measure</span>
                                                                                                                                </div>
                                                                                                                            </div>

                                                                                                                            {element?.call_log_notes?.map((item, i) => {
                                                                                                                                return (
                                                                                                                                    <>
                                                                                                                                        {item?.image_url &&
                                                                                                                                            <div
                                                                                                                                                key={i}
                                                                                                                                                className='rounded-3 d-flex justify-content-center align-items-center m-2 border-hovered'
                                                                                                                                                style={{ height: '55px', width: '55px', border: '1px solid black' }}
                                                                                                                                            >
                                                                                                                                                <img
                                                                                                                                                    src={item?.image_url}
                                                                                                                                                    alt=""
                                                                                                                                                    className='w-100 h-100 cursor-pointer rounded-3'
                                                                                                                                                    style={{ objectFit: 'cover' }}
                                                                                                                                                    onClick={() => {
                                                                                                                                                        handleOpenDoc();
                                                                                                                                                        setImageAttachURL(item?.image_url);
                                                                                                                                                        setNotesMessage(item?.note_chr);

                                                                                                                                                        setNoteObject(item);
                                                                                                                                                        setDiscussionVal(item?.note_chr);
                                                                                                                                                        setIsNoteEdit(true);

                                                                                                                                                    }}
                                                                                                                                                />
                                                                                                                                            </div>
                                                                                                                                        }
                                                                                                                                    </>
                                                                                                                                )
                                                                                                                            })}
                                                                                                                        </div>}
                                                                                                                </>}
                                                                                                        </>
                                                                                                    )
                                                                                                })}
                                                                                            </div>
                                                                                        </> :
                                                                                        <>
                                                                                            <div className='row mx-0'>
                                                                                                {!isAdding && false && <div className='col-12 px-2 my-3 d-flex justify-content-center align-items-center flex-column'>
                                                                                                    <div className="mb-2">
                                                                                                        <img src={emptyListImg} alt="search" style={{ width: "120px" }} />
                                                                                                    </div>
                                                                                                    <span className='fs-5 text-center'>{`No steps found. Please add some steps`}</span>
                                                                                                </div>}
                                                                                            </div>
                                                                                        </>
                                                                                    }

                                                                                    {/* Add New Suggestion Section */}
                                                                                    {isAdding && (
                                                                                        <div className="my-3 w-100 d-flex">
                                                                                            <div className="w-100 me-2" ref={bottomRef}>

                                                                                                <TextArea
                                                                                                    labelName={`Add step`}
                                                                                                    placeholder={`Description`}
                                                                                                    value={newSuggestion}
                                                                                                    onChange={(e) => setNewSuggestion(e.target.value)}
                                                                                                    onBlur={() => { }}
                                                                                                    errorOccured={false}
                                                                                                    errorMessage={"Please enter step"}
                                                                                                />

                                                                                                {!newSuggestion && <small className='text-danger font-w600 '>{`Please enter step`}</small>}
                                                                                            </div>
                                                                                            <div className='d-flex flex-column'>
                                                                                                <span
                                                                                                    className="mb-2 rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                    style={{
                                                                                                        height: "35px",
                                                                                                        width: "35px",
                                                                                                        color: "#1FBF75",
                                                                                                        border: "2px solid #1FBF75",
                                                                                                        pointerEvents: saveSuggestionsLoading ? 'none' : 'auto',
                                                                                                        opacity: saveSuggestionsLoading ? '0.5' : '1',
                                                                                                    }}
                                                                                                    onClick={() => {
                                                                                                        // handleAddSuggestion()
                                                                                                        saveIndividualProjectSuggestionsFn();
                                                                                                    }}
                                                                                                >
                                                                                                    {saveSuggestionsLoading ? <Spinner size='sm' /> : <i className={`bi bi-check2`} style={{ fontSize: "18px" }}></i>}
                                                                                                </span>

                                                                                                <span
                                                                                                    className="rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                    style={{ height: "35px", width: "35px", color: "red", border: "2px solid red" }}
                                                                                                    onClick={() => {
                                                                                                        setIsAdding(false);
                                                                                                        setNewSuggestion('');
                                                                                                    }}
                                                                                                >
                                                                                                    <i className={`bi bi-x`} style={{ fontSize: "18px" }}></i>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>)
                                                                                    }

                                                                                    {widthAIsuggestionsContainer ?
                                                                                        <div
                                                                                            className='row mx-0 bg-white py-2'
                                                                                            style={{
                                                                                                position: 'fixed',
                                                                                                bottom: '0px',
                                                                                                width: widthAIsuggestionsContainer + 1,
                                                                                                zIndex: 5,
                                                                                            }}
                                                                                        >
                                                                                            <div className='col-6 px-0 mt-2 pe-2'>
                                                                                                <PrimaryButton
                                                                                                    buttonName={`ADD STEP`}
                                                                                                    onClick={() => {
                                                                                                        setIsAdding(true);
                                                                                                        setParticularProjectSuggestionObj({});
                                                                                                        setNewSuggestion('');
                                                                                                    }}
                                                                                                    style={{
                                                                                                        width: '100%',
                                                                                                        border: 'none',
                                                                                                        background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                        boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                        fontWeight: '600',
                                                                                                    }}
                                                                                                />
                                                                                            </div>

                                                                                            <div className='col-6 px-0 mt-2 ps-2'>
                                                                                                <PrimaryButton
                                                                                                    buttonName={`FINISH`}
                                                                                                    onClick={(e) => {
                                                                                                        // getProjectsFn();
                                                                                                        handleCreateDIYProject(e)
                                                                                                        // setProjectId('');
                                                                                                        // handleClearProjectStates();
                                                                                                        // navigate('/myDiyProject');
                                                                                                    }}
                                                                                                    isLoading={createUpdateProjectLoading}
                                                                                                    loadingMessage={"FINISH"}
                                                                                                    style={{
                                                                                                        width: '100%',
                                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                        fontWeight: '600',
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div> : ''
                                                                                    }
                                                                                </>}



                                                                            {/* <div className='row mx-0'>
                                                                                <div
                                                                                    className='col-12 px-0 d-flex justify-content-center align-items-center'
                                                                                    style={{ marginBottom: '70px', marginTop: '20px' }}
                                                                                >
                                                                                    <span
                                                                                        className='text-center font-w600 fs-5 text-decoration-underline cursor-pointer text-hovered text-blue d-flex justify-content-center align-items-center'
                                                                                        onClick={() => { handleCreateProjectStep(2) }}
                                                                                    >
                                                                                        {`Back`}
                                                                                    </span>
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            createProjectStep === 4 ?
                                                                // Chat the with Chilll AI bot
                                                                <>
                                                                    <div
                                                                        className='col-md-6 justify-content-center align-items-center p-3'
                                                                        style={{ marginBottom: '50px' }}
                                                                    >
                                                                        <div className='row mx-0 w-100'>
                                                                            <div className='col-12 d-flex justify-content-center align-items-center flex-column'>

                                                                                {widthAIsuggestionsContainer ?
                                                                                    <div
                                                                                        className='row mx-0 bg-white py-2 bg-transparent'
                                                                                        style={{
                                                                                            position: 'fixed',
                                                                                            top: '75px',
                                                                                            width: widthAIsuggestionsContainer + 1,
                                                                                            zIndex: 5,
                                                                                        }}
                                                                                    >
                                                                                        <div className='col-12 px-0 pt-3 d-flex bg-white'>
                                                                                            <div className='d-flex justify-content-between w-100 align-items-center mb-2'>
                                                                                                <div
                                                                                                    className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center'
                                                                                                    onClick={() => {
                                                                                                        handleCreateProjectStep(3);
                                                                                                        setProjectChatHistoryId('');
                                                                                                        setAiChatMessage('');
                                                                                                    }}
                                                                                                >
                                                                                                    <i class="bi bi-arrow-left-short pe-2"></i>
                                                                                                    <span>{"Back"}</span>
                                                                                                </div>

                                                                                                {chatHistoryArr.length > 0 && <div onClick={() => { handleOpenModalDeleteAIChatHistory(); }} className='overlay-action-btn py-1 px-2 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center text-danger'>
                                                                                                    <span>
                                                                                                        {/* <i class="bi bi-trash"></i> */}
                                                                                                    </span>
                                                                                                    <span className='text-decoration-underline'>{"Delete this session"}</span>
                                                                                                </div>}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div> : ''
                                                                                }

                                                                                {/* <div className='d-flex justify-content-between w-100 align-items-center mb-2'>
                                                                                    <div
                                                                                        className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center'
                                                                                        onClick={() => { handleCreateProjectStep(3) }}
                                                                                    >
                                                                                        <i class="bi bi-arrow-left-short pe-2"></i>
                                                                                        <span>{"Back"}</span>
                                                                                    </div>

                                                                                    {chatHistoryArr.length > 0 && <div onClick={() => { handleOpenModalDeleteAIChatHistory(); }} className='overlay-action-btn py-1 px-2 fs-5 font-w600 cursor-pointer rounded-1 mb-1 d-flex align-items-center text-danger'>
                                                                                        <span>
                                                                                        </span>
                                                                                        <span className='text-decoration-underline'>{"Delete this session"}</span>
                                                                                    </div>}
                                                                                </div> */}

                                                                                <div className='w-100 mt-5' ref={divAIsuggestionsRef}>


                                                                                    <div className='d-flex justify-content-center mb-3'>
                                                                                        <span className='text-black font-w600 fs-3 text-center'>{`Chilll Chat Bot`}</span>
                                                                                    </div>

                                                                                    {chatHistoryLoading ? <div className='row mx-0'>
                                                                                        {[1, 2, 3, 4].map((element, i) => {
                                                                                            return (
                                                                                                <div key={i} className='col-12 p-3 rounded-3 border border-2 mb-2'>
                                                                                                    <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                                    <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                                    <SkeletonDivElement height={'20px'} width={'40%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </div> :
                                                                                        <>
                                                                                            {/* A.I. suggestions steps new flow */}
                                                                                            <div className='row mx-0 mb-3'>

                                                                                                {<div className='col-12 p-2'>
                                                                                                    {chatHistoryArr.length > 0 ?
                                                                                                        <>
                                                                                                            <div className='row mx-0'>
                                                                                                                {chatHistoryArr.map((element, i) => {
                                                                                                                    return (
                                                                                                                        <>
                                                                                                                            <div
                                                                                                                                key={i}
                                                                                                                                className={`col-12 align-items-center col-12 d-flex flex-column ${i % 2 === 0 ? `justify-content-end` : `justify-content-start`}`}
                                                                                                                            >
                                                                                                                                {element?.user_query_chr &&
                                                                                                                                    <div className='d-flex justify-content-end align-items-center w-100'>
                                                                                                                                        <div
                                                                                                                                            className=' mb-2 text-black p-3 border border-3 fs-6 font-w600 position-relative d-flex align-items-center'
                                                                                                                                            style={{
                                                                                                                                                // background: i % 2 === 0 ? '#d3d3d3' : '#ffa50061',
                                                                                                                                                // maxWidth: i % 2 === 0 ? '80%' : '100%',
                                                                                                                                                background: '#d3d3d3',
                                                                                                                                                maxWidth: '80%',
                                                                                                                                                borderRadius: '15px 0px 15px 15px',
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            <div className='w-100'>
                                                                                                                                                <span>
                                                                                                                                                    {element?.user_query_chr}
                                                                                                                                                    {/* {`${element?.suggestion_description_chr}`
                                                                                                                                                    .split("/n")
                                                                                                                                                    .map((line, index) => (
                                                                                                                                                        <React.Fragment key={index}>
                                                                                                                                                            {index === 0 ? line : <><br />{line}</>}
                                                                                                                                                        </React.Fragment>))} */}
                                                                                                                                                </span>
                                                                                                                                            </div>

                                                                                                                                            {chatHistoryArr.length - 1 === i && !createUpdateChatLoading &&
                                                                                                                                                <span
                                                                                                                                                    className='ms-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn '
                                                                                                                                                    style={{ height: '30px', width: '37px', }}
                                                                                                                                                    onClick={(e) => {
                                                                                                                                                        e.stopPropagation();
                                                                                                                                                        e?.preventDefault();
                                                                                                                                                        setProjectChatHistoryId(element?.project_chat_history_id_ids)
                                                                                                                                                        setAiChatMessage(element?.user_query_chr)
                                                                                                                                                    }}
                                                                                                                                                >
                                                                                                                                                    <i className={`bi bi-pencil`} style={{ fontSize: '18px' }}></i>
                                                                                                                                                </span>
                                                                                                                                            }
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                }

                                                                                                                                {element?.ai_response_chr && <div className='d-flex justify-content-start align-items-center w-100'>
                                                                                                                                    <div
                                                                                                                                        className=' mb-2 text-black p-3 border border-primary border-3 fs-6 font-w400 position-relative d-flex w-100'
                                                                                                                                        style={{
                                                                                                                                            // background: i % 2 === 0 ? '#d3d3d3' : '#ffa50061',
                                                                                                                                            // maxWidth: i % 2 === 0 ? '80%' : '100%',
                                                                                                                                            background: '#ffa50061',
                                                                                                                                            maxWidth: '100%',
                                                                                                                                            borderRadius: '0px 15px 15px 15px',
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <div className='w-100'>
                                                                                                                                            {/* <span>
                                                                                                                                                {`${element?.ai_response_chr}`
                                                                                                                                                    .split("\n")
                                                                                                                                                    .map((line, index) => (
                                                                                                                                                        <React.Fragment key={index}>
                                                                                                                                                            {index === 0 ? line : <><br />{line}</>}
                                                                                                                                                        </React.Fragment>))}
                                                                                                                                            </span> */}
                                                                                                                                            <span>
                                                                                                                                                {`${element?.ai_response_chr}`
                                                                                                                                                    .split("\n")
                                                                                                                                                    .map((line, index) => {
                                                                                                                                                        const formattedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

                                                                                                                                                        return (
                                                                                                                                                            <React.Fragment key={index}>
                                                                                                                                                                {index === 0 ? (
                                                                                                                                                                    <span dangerouslySetInnerHTML={{ __html: formattedLine }} />
                                                                                                                                                                ) : (
                                                                                                                                                                    <>
                                                                                                                                                                        <br />
                                                                                                                                                                        <span dangerouslySetInnerHTML={{ __html: formattedLine }} />
                                                                                                                                                                    </>
                                                                                                                                                                )}
                                                                                                                                                            </React.Fragment>
                                                                                                                                                        );
                                                                                                                                                    })}
                                                                                                                                            </span>
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                </div>}






                                                                                                                            </div>

                                                                                                                        </>
                                                                                                                    )
                                                                                                                })}
                                                                                                            </div>
                                                                                                        </> :
                                                                                                        <>
                                                                                                            <div className='row mx-0'>
                                                                                                                {<div className='col-12 px-2 my-3 d-flex justify-content-center align-items-center flex-column'>
                                                                                                                    <div className="mb-2">
                                                                                                                        {/* <img src={emptyListImg} alt="search" style={{ width: "120px" }} /> */}
                                                                                                                        <i className="bi bi-chat-dots" style={{ fontSize: '120px' }}></i>

                                                                                                                    </div>
                                                                                                                    {/* <span className='fs-5 text-center'>{`No previous conversations found`}</span> */}

                                                                                                                    <span className='fs-5 text-center'>{`What can we help you with?`}</span>
                                                                                                                </div>}
                                                                                                            </div>
                                                                                                        </>
                                                                                                    }
                                                                                                </div>}
                                                                                                {createUpdateChatLoading && <div className='col-12 px-2 pb-3 d-flex align-items-center '>
                                                                                                    <span>{`Generating response`}</span>
                                                                                                    <span className='ms-2'>
                                                                                                        <Spinner animation='grow' size='sm' />
                                                                                                    </span>
                                                                                                </div>}
                                                                                            </div>







                                                                                            {widthAIsuggestionsContainer ?
                                                                                                <div
                                                                                                    className='row mx-0 bg-white py-2 bg-transparent'
                                                                                                    style={{
                                                                                                        position: 'fixed',
                                                                                                        bottom: '-8px',
                                                                                                        width: widthAIsuggestionsContainer + 1,
                                                                                                        zIndex: 5,
                                                                                                    }}
                                                                                                >
                                                                                                    {isScrollVisible &&
                                                                                                        <div className='col-12 px-0 mt-2 d-flex bg-transparent justify-content-center align-items-center'>
                                                                                                            <div
                                                                                                                className='d-flex justify-content-center align-items-center  bg-white mb-2 cursor-pointer'
                                                                                                                style={{ fontSize: '40px', borderRadius: '50%', width: '40px', height: '40px' }}
                                                                                                                onClick={() => {
                                                                                                                    setIsScrollVisible(false);
                                                                                                                    window.scrollTo({
                                                                                                                        top: document.documentElement.scrollHeight,
                                                                                                                        behavior: "smooth",
                                                                                                                    });
                                                                                                                }}
                                                                                                            >
                                                                                                                <i className="bi bi-arrow-down-circle  " ></i>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }

                                                                                                    <div className='col-12 px-0 pt-3 d-flex bg-white'>
                                                                                                        <div className='w-100'>
                                                                                                            <TextArea
                                                                                                                labelName={`Ask a question`}
                                                                                                                placeholder={`Enter your question`}
                                                                                                                value={aiChatMessage}
                                                                                                                onChange={(e) => setAiChatMessage(e.target.value)}
                                                                                                                onBlur={() => { }}
                                                                                                                errorOccured={false}
                                                                                                                errorMessage={"Please enter step"}
                                                                                                                rows='2'
                                                                                                            />
                                                                                                        </div>

                                                                                                        {projectChatHistoryId && !createUpdateChatLoading && <div className='align-items-center justify-content-center ms-3'>
                                                                                                            <span
                                                                                                                className='cursor-pointer d-flex align-items-center justify-content-center rounded-3'
                                                                                                                style={{
                                                                                                                    height: '54px',
                                                                                                                    width: '46px',
                                                                                                                    backgroundColor: '#80808073',
                                                                                                                    color: 'black',
                                                                                                                    fontSize: '32px',
                                                                                                                }}
                                                                                                                onClick={(e) => {
                                                                                                                    setAiChatMessage('');
                                                                                                                    setProjectChatHistoryId('');
                                                                                                                }}
                                                                                                            >
                                                                                                                <RiCloseFill />
                                                                                                            </span>
                                                                                                        </div>}

                                                                                                        <div className='align-items-center justify-content-center ms-3'>
                                                                                                            <span
                                                                                                                className='me-2 cursor-pointer d-flex align-items-center justify-content-center rounded-3'
                                                                                                                style={{
                                                                                                                    height: '54px',
                                                                                                                    width: '46px',
                                                                                                                    backgroundColor: '#80808073',
                                                                                                                    color: 'black',
                                                                                                                    pointerEvents: aiChatMessage === '' || createUpdateChatLoading ? 'none' : 'auto',
                                                                                                                    opacity: aiChatMessage === '' || createUpdateChatLoading ? '0.5' : '1',
                                                                                                                    fontSize: '25px',
                                                                                                                }}
                                                                                                                onClick={(e) => { createUpdateChatHistoryFn(e) }}
                                                                                                            >
                                                                                                                <IoSend />
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    {/* {projectChatHistoryId && !createUpdateChatLoading &&
                                                                                                        <div
                                                                                                            className='col-12 px-0 d-flex bg-transparent align-items-center'
                                                                                                            style={{ marginTop: '-1px' }}
                                                                                                        >
                                                                                                            <div
                                                                                                                className='d-flex align-items-center  bg-white pb-3 '
                                                                                                                style={{ width: '100%', }}
                                                                                                            >
                                                                                                                <span
                                                                                                                    className='px-3 py-2 cursor-pointer w-100 rounded-3 overlay-action-btn d-flex justify-content-center align-items-center text-black font-w600'
                                                                                                                    style={{ border: '1px solid #b3b3b3a6' }}
                                                                                                                    onClick={() => {
                                                                                                                        setAiChatMessage('');
                                                                                                                        setProjectChatHistoryId('');
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {`CANCEL`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    } */}
                                                                                                </div> : ''
                                                                                            }
                                                                                        </>}




                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                createProjectStep === 5 ?
                                                                    // Complete DIY project old code
                                                                    <>
                                                                        <div className='col-md-6 d-flex justify-content-center align-items-center p-3'>
                                                                            {/* Old code for showing the suggestions from AI model */}
                                                                            {
                                                                                <div className='w-100'>

                                                                                    <div className='d-flex justify-content-center mb-5'>
                                                                                        <span className='text-black font-w600 fs-3 text-center'>{`Project steps `}</span>
                                                                                    </div>

                                                                                    <div className='d-flex justify-content-center mb-3'>
                                                                                        <span className='font-w600 fs-5 text-center'>{`Click the ones you want to keep or click on edit icon to edit`}</span>
                                                                                    </div>

                                                                                    {/* {!isAdding && !getAIsuggestionsLoading && <div className={'d-flex justify-content-end align-items-center mb-3'}>
                                                                            <span
                                                                                className='font-w600 text-white fs-5 text-center px-3 py-2 cursor-pointer rounded-3'
                                                                                onClick={() => { setIsAdding(true) }}
                                                                                style={{
                                                                                    width: 'auto',
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    fontWeight: '600',
                                                                                }}
                                                                            >
                                                                                {`Add steps`}
                                                                            </span>
                                                                        </div>} */}

                                                                                    {getAIsuggestionsLoading ? <div className='row mx-0'>
                                                                                        {[1, 2, 3].map((element, i) => {
                                                                                            return (
                                                                                                <div key={i} className='col-12 p-3 rounded-3 border border-success border-2 mb-2'>
                                                                                                    <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                                    <SkeletonDivElement height={'20px'} width={'100%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                                    <SkeletonDivElement height={'20px'} width={'40%'} borderRadius={'6px'} marginBottom={'5px'} />
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </div> :
                                                                                        <>
                                                                                            {AIsuggestionsArr.length > 0 ?
                                                                                                <>
                                                                                                    <div className='row mx-0'>
                                                                                                        {AIsuggestionsArr.map((element, i) => {
                                                                                                            const isSelected = selectedItems.includes(element);
                                                                                                            return (
                                                                                                                <>
                                                                                                                    {editIndex === i ?
                                                                                                                        <>
                                                                                                                            <div key={i} className="mt-3 w-100 d-flex">

                                                                                                                                <div className='w-100 me-2'>
                                                                                                                                    <TextArea
                                                                                                                                        labelName={`Update suggestion`}
                                                                                                                                        placeholder={`Description`}
                                                                                                                                        value={editText}
                                                                                                                                        onChange={(e) => setEditText(e.target.value)}
                                                                                                                                        onBlur={() => { }}
                                                                                                                                        errorOccured={false}
                                                                                                                                        errorMessage={"Please enter"}
                                                                                                                                    />

                                                                                                                                    {!editText && <small className='text-danger font-w600 '>{`Please enter suggestion`}</small>}
                                                                                                                                </div>
                                                                                                                                <div>
                                                                                                                                    <span
                                                                                                                                        className='rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                        style={{ height: '35px', width: '35px', color: '#1FBF75', border: '2px solid #1FBF75' }}
                                                                                                                                        onClick={(e) => {
                                                                                                                                            e.stopPropagation();
                                                                                                                                            handleSaveEdit();
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <i className={`bi bi-check2`} style={{ fontSize: '18px' }}></i>
                                                                                                                                    </span>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </> :
                                                                                                                        <>
                                                                                                                            <div
                                                                                                                                key={i}
                                                                                                                                className={`col-12 rounded-3 mb-1 text-black p-3 border ${isSelected ? 'border-success' : ''} border-2 fs-4 font-w600 cursor-pointer position-relative border-hovered`}
                                                                                                                                style={{ background: isSelected ? "#a3cc90bf" : "transparent" }}
                                                                                                                                onClick={() => handleSelection(element)}
                                                                                                                            >
                                                                                                                                <span
                                                                                                                                    className='position-absolute top-0 end-0 me-2 mt-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                                                    onClick={(e) => {
                                                                                                                                        e.stopPropagation();
                                                                                                                                        handleEditClick(i);
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <i className={`bi bi-pencil`} style={{ fontSize: '14px' }}></i>
                                                                                                                                </span>
                                                                                                                                <span>{element}</span>
                                                                                                                            </div>
                                                                                                                        </>
                                                                                                                    }
                                                                                                                </>
                                                                                                            )
                                                                                                        })}
                                                                                                    </div>
                                                                                                </> :
                                                                                                <>
                                                                                                    {!isAdding && <div className='row mx-0'>
                                                                                                        <div className='col-12 px-2 my-3 d-flex justify-content-center align-items-center flex-column'>
                                                                                                            <div className="mb-2">
                                                                                                                <img src={emptyListImg} alt="search" style={{ width: "120px" }} />
                                                                                                            </div>

                                                                                                            <span className='fs-5 text-center me-2'>{`No suggestions found `}</span>
                                                                                                        </div>
                                                                                                    </div>}
                                                                                                </>}

                                                                                            {/* Add New Suggestion Section */}
                                                                                            {isAdding && (
                                                                                                <div className="mt-3 w-100 d-flex">
                                                                                                    <div className="w-100 me-2" ref={bottomRef}>

                                                                                                        <TextArea
                                                                                                            labelName={`Add suggestion`}
                                                                                                            placeholder={`Description`}
                                                                                                            value={newSuggestion}
                                                                                                            onChange={(e) => setNewSuggestion(e.target.value)}
                                                                                                            onBlur={() => { }}
                                                                                                            errorOccured={false}
                                                                                                            errorMessage={"Please enter suggestion"}
                                                                                                        />

                                                                                                        {!newSuggestion && <small className='text-danger font-w600 '>{`Please enter suggestion`}</small>}
                                                                                                    </div>
                                                                                                    <div className='d-flex flex-column'>
                                                                                                        <span
                                                                                                            className="mb-2 rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                            style={{ height: "35px", width: "35px", color: "#1FBF75", border: "2px solid #1FBF75" }}
                                                                                                            onClick={handleAddSuggestion}
                                                                                                        >
                                                                                                            <i className={`bi bi-check2`} style={{ fontSize: "18px" }}></i>
                                                                                                        </span>

                                                                                                        <span
                                                                                                            className="rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn"
                                                                                                            style={{ height: "35px", width: "35px", color: "red", border: "2px solid red" }}
                                                                                                            onClick={() => { setIsAdding(false) }}
                                                                                                        >
                                                                                                            <i className={`bi bi-x`} style={{ fontSize: "18px" }}></i>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>)}

                                                                                            {/* <div className='row mx-0 mb-3'>
                                                                                    <div
                                                                                        className='col-12 cursor-pointer rounded-3 text-black p-3 border border-success border-2 fs-4 font-w600 mb-2'
                                                                                        style={{ minHeight: '100px', background: '#fdd45f8a' }}
                                                                                        onClick={() => {
                                                                                            localStorage.setItem("DIYProjectId", projectId);
                                                                                            setToggleForCreateDIYServiceRequest(true);
                                                                                        }}
                                                                                    >
                                                                                        <span>{`Connect with a remote service pro who can help you through project`}</span>
                                                                                    </div>
                                                                                </div> */}

                                                                                            <div className='row mx-0 mt-5 mb-4'>
                                                                                                <div className='col-6 px-0 mt-2 pe-2'>
                                                                                                    <PrimaryButton
                                                                                                        buttonName={`ADD`}
                                                                                                        onClick={() => { setIsAdding(true) }}
                                                                                                        style={{
                                                                                                            width: '100%',
                                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    />
                                                                                                </div>

                                                                                                <div className='col-6 px-0 mt-2 ps-2'>
                                                                                                    <PrimaryButton
                                                                                                        buttonName={`NEXT`}
                                                                                                        onClick={(e) => {
                                                                                                            saveProjectSuggestionsFn(e)
                                                                                                            setNewSuggestion('');
                                                                                                            setIsAdding(false);
                                                                                                        }}
                                                                                                        isLoading={saveSuggestionsLoading}
                                                                                                        loadingMessage={"LOADING..."}
                                                                                                        style={{
                                                                                                            width: '100%',
                                                                                                            border: 'none',
                                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        </>}



                                                                                    <div className='row mx-0'>
                                                                                        <div className='col-12 px-0 my-3 d-flex justify-content-center align-items-center'>
                                                                                            <span
                                                                                                className='text-center font-w600 fs-5 text-decoration-underline cursor-pointer text-hovered text-blue d-flex justify-content-center align-items-center'
                                                                                                onClick={() => { handleCreateProjectStep(2) }}
                                                                                            >
                                                                                                {/* <i className='bi bi-arrow-left me-3'></i> */}
                                                                                                {`Back`}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }

                                                                        </div>
                                                                    </> : <></>
                                        }

                                        <div className='col-md-3'></div>

                                    </div>
                                </> :
                                // Add photos to DIY project and OCR
                                <>
                                    <div>
                                        {/* <span onClick={() => { setToggleForAddImage(false); stopCameraStream(); }}>{`Back`}</span> */}
                                        <div className='row mx-2 my-2'>
                                            <div className='col-12'>
                                                <span
                                                    onClick={() => {
                                                        setToggleForAddImage(false);
                                                        stopCameraStream();
                                                    }}
                                                    className="cursor-pointer px-3 py-2 text-black font-w600 overlay-action-btn rounded-3">
                                                    <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                                </span>
                                            </div>
                                        </div>


                                        <div className='row mx-0 my-3'>
                                            <div className='col-12 px-2 d-flex justify-content-center align-items-center'>
                                                <span className='text-black font-w600 fs-4 text-center'>{`Snap the image of device`}</span>
                                            </div>
                                        </div>

                                        {/* <div className='row mx-0 d-flex justify-content-center'>
                                    {cameraInitializedLoading && <>
                                        <Spinner size='xl' variant='primary' />
                                    </>}
                                </div> */}
                                        <div className='row mx-0' style={{ minHeight: '80dvh' }}>
                                            <div className='col-md-1'></div>
                                            <div
                                                className={`col-md-10 d-flex justify-content-center align-items-center overflow-hidden ${!imgSrc && 'bg-light'} position-relative`}
                                                style={{ height: '65dvh' }}
                                            >
                                                {!imgSrc && <>
                                                    {!isCameraAllowed &&
                                                        <div
                                                            className='d-flex flex-column position-absolute  justify-content-center align-items-center w-100'
                                                            style={{
                                                                top: "50%",
                                                                left: "50%",
                                                                transform: "translate(-50%, -50%)",
                                                                zIndex: "1",
                                                            }}
                                                        >
                                                            <span
                                                                className="fs-4 text-center text-black font-w600"
                                                            >
                                                                {"Camera access is blocked."}
                                                            </span>

                                                            <span
                                                                className=" fs-6 text-center font-w600"
                                                            >
                                                                {"Please enable camera access in your browser settings and refresh the page."}
                                                            </span>
                                                        </div>
                                                    }

                                                    <video
                                                        ref={videoRef}
                                                        autoPlay
                                                        playsInline
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                                                        }}
                                                    ></video>
                                                    {/* <canvas
                                                ref={canvasVideoRef}
                                                style={{ display: 'none' }} // Hide canvas element
                                            ></canvas> */}
                                                </>}


                                                {imgSrc && (
                                                    <div className='d-flex justify-content-center align-items-center' style={{}}>
                                                        <ImageCropper imgSrc={imgSrc} canvasRef={canvasRef} setCrop={setCrop} />
                                                    </div>
                                                )}


                                            </div>
                                            <div className='col-md-1'></div>

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0 my-2 d-flex justify-content-center align-items-center'>
                                                    {/* {!isPaused ? (
                                                <button
                                                    onClick={pauseAndCapture}
                                                    style={{
                                                        padding: '10px 20px',
                                                        backgroundColor: '#007bff',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Pause & Capture
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={resumeVideo}
                                                    style={{
                                                        padding: '10px 20px',
                                                        backgroundColor: '#28a745',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Resume Video
                                                </button>
                                            )} */}


                                                    {toggleForCameraActions === 1 ?
                                                        <>
                                                            {imgSrc ? <>
                                                                <PrimaryButton
                                                                    buttonName={"CONTINUE"}
                                                                    onClick={(e) => { handleContinue(e) }}
                                                                    isLoading={false}
                                                                    loadingMessage={"Saving..."}
                                                                    className={"me-3"}
                                                                    style={{
                                                                        width: 'auto',
                                                                        background: 'white',
                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                        color: 'black',
                                                                        fontWeight: '600',
                                                                    }}
                                                                />

                                                                <PrimaryButton
                                                                    buttonName={"RESET"}
                                                                    onClick={() => { setImgSrc(null); getCameraStream(); }}
                                                                    isLoading={false}
                                                                    loadingMessage={"Saving..."}
                                                                    className={"me-3"}
                                                                    style={{
                                                                        width: 'auto',
                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                        fontWeight: '600',
                                                                    }}
                                                                />

                                                            </> :
                                                                <>
                                                                    <div className='row mx-0'>
                                                                        <div
                                                                            className='col-12 '
                                                                            style={{
                                                                                pointerEvents: screenShotLoading ? "none" : "auto",
                                                                                opacity: screenShotLoading ? "0.5" : "1",
                                                                            }}
                                                                        >

                                                                        </div>
                                                                    </div>
                                                                    <PrimaryButton
                                                                        buttonName={"CAPTURE"}
                                                                        onClick={() => { capture() }}
                                                                        isLoading={screenShotLoading}
                                                                        loadingMessage={"LOADING..."}
                                                                        className={"me-3"}
                                                                        style={{
                                                                            width: 'auto',
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            fontWeight: '600',
                                                                        }}
                                                                    />

                                                                    {/* <PrimaryButton
                                                                        buttonName={"UPLOAD IMAGE"}
                                                                        onClick={() => { handleClickUploadPicture() }}
                                                                        isLoading={false}
                                                                        loadingMessage={"Saving..."}
                                                                        style={{
                                                                            width: 'auto',
                                                                            background: 'white',
                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            color: 'black',
                                                                            fontWeight: '600',
                                                                        }}
                                                                    />

                                                                    <input
                                                                        ref={uploadPicRef}
                                                                        onChange={(e) => {
                                                                            handleUploadPicture(e);
                                                                        }}
                                                                        on
                                                                        className="form-control"
                                                                        type="file"
                                                                        accept="image/*"
                                                                        hidden
                                                                    /> */}
                                                                </>}
                                                        </> :
                                                        toggleForCameraActions === 2 ? <>
                                                            <PrimaryButton
                                                                buttonName={"CAPTURE"}
                                                                onClick={() => { capture() }}
                                                                isLoading={screenShotLoading}
                                                                loadingMessage={"LOADING..."}
                                                                className={""}
                                                                style={{
                                                                    width: 'auto',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </> :
                                                            toggleForCameraActions === 3 ?
                                                                <>
                                                                    <>
                                                                        {imgSrc ? <>
                                                                            <PrimaryButton
                                                                                buttonName={"CONTINUE"}
                                                                                onClick={() => { handleCaptureOcrText() }}
                                                                                isLoading={ocrLoading}
                                                                                loadingMessage={"GETTING TEXT..."}
                                                                                className={"me-3"}
                                                                                style={{
                                                                                    width: 'auto',
                                                                                    background: 'white',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    color: 'black',
                                                                                    fontWeight: '600',
                                                                                }}
                                                                            />

                                                                            {!ocrLoading && <PrimaryButton
                                                                                buttonName={"RESET"}
                                                                                onClick={() => { setImgSrc(null); getCameraStream(); }}
                                                                                isLoading={false}
                                                                                loadingMessage={"Saving..."}
                                                                                className={""}
                                                                                style={{
                                                                                    width: 'auto',
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    fontWeight: '600',
                                                                                }}
                                                                            />}
                                                                        </> :
                                                                            <>

                                                                                <PrimaryButton
                                                                                    buttonName={"CAPTURE"}
                                                                                    onClick={() => { capture() }}
                                                                                    isLoading={screenShotLoading}
                                                                                    loadingMessage={"LOADING..."}
                                                                                    className={"me-3"}
                                                                                    style={{
                                                                                        width: 'auto',
                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                        fontWeight: '600',
                                                                                    }}
                                                                                />
                                                                            </>}
                                                                    </>
                                                                </> : <></>
                                                    }

                                                </div>
                                            </div>

                                            {/* {capturedImage && (
                                            <div className="text-center mt-3">
                                                <p>Captured Image:</p>
                                                <img
                                                    src={capturedImage}
                                                    alt="Captured"
                                                    style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '8px',
                                                    }}
                                                />
                                            </div>
                                        )} */}
                                        </div>
                                    </div>
                                </>}
                        </> :
                            // For capturing the drawing image
                            <>
                                <div className='row mx-2 my-2'>
                                    <div className='col-12'>
                                        <span
                                            onClick={() => {
                                                setToggleForDrawing(false);
                                                setCaptureImageFromDraw(null)
                                            }}
                                            className="cursor-pointer px-3 py-2 text-black font-w600 overlay-action-btn rounded-3">
                                            <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                        </span>
                                    </div>
                                </div>

                                <DrawingDemo
                                    useForDIY={true}
                                    setDrawingImageSaveLoading={setDrawingImageSaveLoading}
                                    drawingImageSaveLoading={drawingImageSaveLoading}
                                    handleScreenShot={(imgSend, imgShow) => {
                                        handleSaveDrawingImgNotes(imgSend);
                                        setCaptureImageFromDraw(imgShow);
                                    }}
                                />

                                {/* {captureImageFromDraw && (
                            <div className="text-center mt-3">
                                <p>Captured Image:</p>
                                <img
                                    src={captureImageFromDraw}
                                    alt="Captured"
                                    style={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                    }}
                                />
                            </div>
                        )} */}

                            </>}
                    </> :
                        // For creating DIY service request
                        <>
                            <div className='row mx-2 my-2'>
                                <div className='col-12'>
                                    <span
                                        onClick={() => {
                                            setToggleForCreateDIYServiceRequest(false);
                                            setCaptureImageFromDraw(null)

                                        }}
                                        className="cursor-pointer px-3 py-2 text-black font-w600 overlay-action-btn rounded-3">
                                        <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                    </span>
                                </div>
                            </div>

                            <Scan DIYProjectId={projectId} DIYProjectDescription={projectDescription} />
                        </>}

                </div>
            </div>


            {/* Modal for previewing the attached image preview */}
            {openDoc &&
                <ImagePreviewer
                    openDoc={openDoc}
                    handleCloseDoc={handleCloseDoc}
                    imageAttachURL={imageAttachURL}
                    notesMessage={discussionVal}

                    isNoteEdit={isNoteEdit}
                    onClick={handleUpdateProjectNotes}
                    buttonLoading={saveLoading}
                    setDiscussionVal={setDiscussionVal}
                />
            }

            {/* Modal for project suggestions operations */}
            <Modal
                className="fade"
                show={modalTriggerSavedProjectSuggestions}
                // onHide={handleClose}
                centered>
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">

                            <div className="row mx-0">
                                <div className="col-6 px-0 d-flex align-items-center justify-content-start fs-4 text-black">
                                    {
                                        // For shoping operation
                                        toggleForSavedProjectSuggestions === 2 ?
                                            <>
                                                {
                                                    toggleForShoppingListDIY !== 1 &&
                                                    <span
                                                        onClick={() => {
                                                            setToggleForShoppingListDIY(1)
                                                            handleCloseCreatePurchaseItem();
                                                            setIsShoppingItemEdit(false);
                                                        }}
                                                        className="cursor-pointer px-3 py-2 overlay-action-btn rounded-3">
                                                        <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                                    </span>
                                                }
                                            </> :
                                            toggleForSavedProjectSuggestions === 3 ?
                                                <>
                                                    {
                                                        (toggleForNotesDIY !== 1) && (createProjectStep !== 2) &&
                                                        <span
                                                            onClick={() => {
                                                                setToggleForNotesDIY(1)
                                                                handleClearNotesStates();

                                                            }}
                                                            className="cursor-pointer px-3 py-2 overlay-action-btn rounded-3">
                                                            <i className="bi bi-arrow-left me-2"></i> {`Back`}
                                                        </span>
                                                    }
                                                </> : <></>
                                    }
                                </div>

                                <div className="col-6 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseProjectSuggestionsModal()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            {/* Delete suggestion */}
                            {toggleForSavedProjectSuggestions === 1 ?
                                <>
                                    <div className="row mx-0 mb-3">
                                        <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                            <span className="">{"Delete suggestion"}</span>
                                        </div>
                                    </div>

                                    <div className="row mx-0 mt-3 pb-2">
                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                            <span className="fs-5">
                                                {"Are you sure you want to delete this suggestion?"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mx-0 text-black mt-2">
                                        <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                                            <PrimaryButton
                                                onClick={(e) => handleCloseProjectSuggestionsModal()}
                                                buttonName={"NO, GO BACK"}
                                                style={{
                                                    width: "100%",
                                                    backgroundColor: "white",
                                                    border: "1px solid grey",
                                                    color: "black",
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>


                                        <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                                            <PrimaryButton
                                                onClick={(e) => handleDeleteProjectSuggestionFn()}
                                                buttonName={"YES, DELETE IT"}
                                                loadingMessage={"DELETING..."}
                                                isLoading={deleteProjectSuggestionLoading}
                                                style={{
                                                    width: "100%",
                                                    background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                    boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                    border: '1px solid rgba(240, 72, 72, 1)',
                                                    fontWeight: '600',
                                                }}
                                            />

                                        </div>
                                    </div>
                                </> :
                                // Shpping lists here
                                toggleForSavedProjectSuggestions === 2 ?
                                    <>
                                        {/* Shopping list */}
                                        {toggleForShoppingListDIY === 1 ?
                                            <>
                                                <div className="row mx-0 mb-3">
                                                    <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                        <span className="">{"Shopping list for suggestion"}</span>
                                                    </div>
                                                </div>

                                                {/* <div className="row mx-0 mt-3 pb-2">
                                            <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                <span className="fs-5">
                                                    {"Are you sure you want to delete this suggestion?"}
                                                </span>
                                            </div>
                                        </div> */}



                                                {particularProjectSuggestionObj?.purchase_list?.length > 0 ?
                                                    <>
                                                        <div
                                                            className='w-100 overflow-auto'
                                                            style={{ maxHeight: '60dvh' }}
                                                        >
                                                            {particularProjectSuggestionObj?.purchase_list?.map((element, index) => {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className="row mt-4 pb-2 border-bottom"
                                                                        style={{
                                                                            // pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                                            // opacity: purchaseLoading ? '0.5' : '1',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="col-12 p-4 d-flex bg-light rounded-2"
                                                                            onClick={(e) => {
                                                                                e?.preventDefault();
                                                                                // handleViewPurchaseItemDesktop(element, 5);
                                                                            }}
                                                                        >

                                                                            <div className="w-100">
                                                                                <div className="row mx-0">
                                                                                    <div className="col-6 d-flex justify-content-start align-items-center">
                                                                                        <span className="">
                                                                                            <span className='pe-2'>{index + 1}.</span>
                                                                                            <span className="text-black font-w600">{element?.item_name_chr}</span>
                                                                                        </span>
                                                                                    </div>

                                                                                    <div className="col-6 d-flex justify-content-end align-items-center">
                                                                                        {element?.quantity_int && element?.estimated_price_float ?
                                                                                            <span className='text-black font-w600 me-2'>
                                                                                                {element?.quantity_int} X{" "}
                                                                                                {USDollar.format(
                                                                                                    element?.estimated_price_float /
                                                                                                    element?.quantity_int
                                                                                                )}
                                                                                            </span> : <></>}

                                                                                        <span
                                                                                            className='me-2 bg-white text-black rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                setIsShoppingItemEdit(true);
                                                                                                handleUpdatePurchaseList(element, e);
                                                                                            }}
                                                                                        >
                                                                                            <i className={`bi bi-pencil`} style={{ fontSize: '14px' }}></i>
                                                                                        </span>

                                                                                        <span
                                                                                            className='text-danger me-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                            style={{ height: '25px', width: '25px' }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                handleViewPurchaseItemDesktop(element, 3);
                                                                                            }}
                                                                                        >
                                                                                            <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                        </span>
                                                                                        {/* <span
                                                                                className="fs-7 text-black font-w600"
                                                                                style={{}}>
                                                                                {element?.quantity_int} X{" "}
                                                                                {USDollar.format(
                                                                                    element?.estimated_price_float /
                                                                                    element?.quantity_int
                                                                                )}{" "}
                                                                                &nbsp; &nbsp;{" "}
                                                                                <OverlayTrigger
                                                                                    key={index}
                                                                                    trigger="click"
                                                                                    placement="bottom"
                                                                                    // overlay={popover}
                                                                                    overlay={popoverShoppingActions(
                                                                                        index
                                                                                    )}
                                                                                    rootClose={true}
                                                                                    show={
                                                                                        activePopoverShopping === index
                                                                                    }
                                                                                    onToggle={(show) =>
                                                                                        setActivePopoverShopping(
                                                                                            show ? index : null
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <span style={{}}>
                                                                                        <LuMoreVertical
                                                                                            className="cursor-pointer text-black"
                                                                                            onClick={(e) => {
                                                                                                e?.preventDefault();
                                                                                                e.stopPropagation();
                                                                                                handleMenuClickShopping(
                                                                                                    element,
                                                                                                    index
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            </span> */}


                                                                                    </div>
                                                                                </div>

                                                                                <div className="row mx-0  mt-2">
                                                                                    <span className="">
                                                                                        {element?.description_chr}
                                                                                    </span>
                                                                                </div>

                                                                                {element?.purchase_link_chr != "" && (
                                                                                    <div className="row mx-0  mt-2" >
                                                                                        <div className="col-12 d-flex justify-content-start align-items-center">
                                                                                            {urlPattern.test(element?.purchase_link_chr) ?
                                                                                                <>
                                                                                                    <div className="d-flex align-items-center">
                                                                                                        <span className="text-black font-w600 me-2">{`Website: `}</span>
                                                                                                        <a
                                                                                                            className="text-black text-hovered text-decoration-underline"
                                                                                                            href={
                                                                                                                element?.purchase_link_chr
                                                                                                            }
                                                                                                            target="_blank"
                                                                                                            rel="noreferrer"
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                            }}
                                                                                                        >
                                                                                                            <span
                                                                                                                className="fs-7 cursor-pointer text-truncate d-flex"
                                                                                                                // style={{ maxWidth: `calc(${shoppingItemLinkWidth}px - 80px)` }}
                                                                                                                style={{ maxWidth: `180px` }}
                                                                                                            // onClick={() => {
                                                                                                            //   navigator.clipboard.writeText(
                                                                                                            //     `${element?.purchase_link_chr}`
                                                                                                            //   );
                                                                                                            //   copyToClipboard();
                                                                                                            // }}
                                                                                                            >
                                                                                                                {`${element?.purchase_link_chr}`}
                                                                                                                {/* <FaArrowRightLong />{" "} */}
                                                                                                            </span>
                                                                                                        </a>
                                                                                                        <span >{`...`}</span>
                                                                                                    </div>
                                                                                                </> :
                                                                                                <div>
                                                                                                    <span className="text-black font-w600 me-2">{`Location: `}</span>
                                                                                                    <span
                                                                                                        className="fs-7 text-black"
                                                                                                    >
                                                                                                        {element?.purchase_link_chr}
                                                                                                    </span>
                                                                                                </div>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                                {/* {
                                                                        <div className="row mx-0  mt-2">
                                                                            <div className={`col-12 d-flex fs-7 font-w600 `}>
                                                                                <div className="d-flex align-items-center justify-content-between w-100">
                                                                                    <div
                                                                                        className="me-4 d-flex align-items-center"
                                                                                        style={{
                                                                                            // pointerEvents: purchaseLoading ? 'none' : 'auto',
                                                                                            // opacity: purchaseLoading ? '0.5' : '1'
                                                                                        }}
                                                                                    >
                                                                                        <span
                                                                                            className="me-2"
                                                                                        >
                                                                                            {purchaseLoading && (element?.item_id_ids === shoppingItemId) ?
                                                                                                <Spinner animation="border" size="sm" /> :
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={element?.is_purchased_ysn}
                                                                                                    className="form-check-input"
                                                                                                    id="customCheckBox4"
                                                                                                    onChange={(e) => {
                                                                                                        e?.preventDefault();
                                                                                                        e.stopPropagation();

                                                                                                        handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                                                                        setShoppingItemId(element?.item_id_ids)
                                                                                                    }}
                                                                                                    onClick={(e) => {
                                                                                                        e?.preventDefault();
                                                                                                        e.stopPropagation();

                                                                                                        handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                                                                        setShoppingItemId(element?.item_id_ids)
                                                                                                    }}
                                                                                                />
                                                                                            }
                                                                                        </span>
                                                                                        <span
                                                                                            className="pt-1 cursor-pointer text-hovered"
                                                                                            onClick={(e) => {
                                                                                                e?.preventDefault();
                                                                                                e?.stopPropagation();

                                                                                                handleMarkPurchaseItem(element, element?.is_purchased_ysn ? 0 : 1)
                                                                                                setShoppingItemId(element?.item_id_ids)
                                                                                            }}
                                                                                        >
                                                                                            {`Item Acquired`}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    } */}

                                                                                <div className="row mx-0  mt-2">
                                                                                    <div className='col-12 px-0 d-flex justify-content-end'>
                                                                                        {element?.is_purchased_ysn ?
                                                                                            <span className='font-w600 text-success'>{`Purchased`}</span> :
                                                                                            <span className='font-w600'>{`Not purchased yet`}</span>
                                                                                        }
                                                                                    </div>
                                                                                </div>


                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </> :
                                                    <>
                                                        <div className="mb-3 mt-4 d-flex justify-content-center align-items-center flex-column">
                                                            <div className="mb-2">
                                                                <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                                            </div>
                                                            <span>
                                                                {`No items added yet`}
                                                            </span>
                                                        </div>
                                                    </>
                                                }

                                                <div className="row mx-0 mt-2">
                                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                        <PrimaryButton
                                                            buttonName={`ADD SHOPPING ITEM`}
                                                            onClick={() => { setToggleForShoppingListDIY(2) }}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* <div className="row mx-0 text-black mt-2">
                                            <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                                                <PrimaryButton
                                                    onClick={(e) => handleCloseProjectSuggestionsModal()}
                                                    buttonName={"NO, GO BACK"}
                                                    style={{
                                                        width: "100%",
                                                        backgroundColor: "white",
                                                        border: "1px solid grey",
                                                        color: "black",
                                                        fontWeight: '600',
                                                    }}
                                                />
                                            </div>


                                            <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                                                <PrimaryButton
                                                    onClick={(e) => handleDeleteProjectSuggestionFn()}
                                                    buttonName={"YES, DELETE IT"}
                                                    loadingMessage={"DELETING..."}
                                                    isLoading={deleteProjectSuggestionLoading}
                                                    style={{
                                                        width: "100%",
                                                        backgroundColor: "red",
                                                        border: "none",
                                                        fontWeight: '600',
                                                    }}
                                                />

                                            </div>
                                        </div> */}
                                            </> :
                                            // Add Edit shopping list
                                            toggleForShoppingListDIY === 2 ?
                                                <>
                                                    <div className="row mx-0 mb-3">
                                                        <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                            <span className="">
                                                                {isShoppingItemEdit ? "Edit shopping item" : "Add shopping item"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* <div className="row mx-0 mt-3 pb-2">
                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                            <span className="fs-5">
                                                {"Are you sure you want to delete this suggestion?"}
                                            </span>
                                        </div>
                                    </div> */}
                                                    <form
                                                        onSubmit={(e) => {
                                                            if (!isShoppingItemEdit) {
                                                                handleSubmitPurchase(e);
                                                            } else {
                                                                handleUpdatePurchase(e);
                                                            }
                                                        }}
                                                    >
                                                        <div className="px-3 my-2 mt-3">
                                                            <InputField
                                                                labelName={"Item name"}
                                                                placeholderName={"Item name"}
                                                                value={itemName}
                                                                onChange={handleItemName}
                                                                onBlur={handleItemNameBlurCheck}
                                                                isRequired={true}
                                                                errorOccured={itemNameErr}
                                                                errorMeesage={"Please add item name"}
                                                            />
                                                            <div className="row mx-0 justify-content-between">
                                                                <div className="col-md-6 px-0 pe-md-2">
                                                                    <InputField
                                                                        labelName={"Quantity"}
                                                                        placeholderName={"Quantity"}
                                                                        value={`${quantity}`}
                                                                        onChange={handleQuantity}
                                                                        onBlur={() => { }}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6 px-0  ps-md-2">
                                                                    <InputField
                                                                        labelName={"Item cost ($)"}
                                                                        placeholderName={"Cost Per Item"}
                                                                        value={totalEstimatedCost}
                                                                        onChange={handleTotalEstimatedCost}
                                                                        onBlur={() => { }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <InputField
                                                                labelName={"Website or Location"}
                                                                placeholderName={"Website or Location"}
                                                                value={purchaseLink}
                                                                onChange={handlePurchaseLink}
                                                                onBlur={() => { }}
                                                            />
                                                            <TextArea
                                                                labelName={"Item description"}
                                                                placeholder={"Item description"}
                                                                value={itemDescription}
                                                                onChange={handleDescription}
                                                                onBlur={() => { }}
                                                            // onBlur={handleDescriptionBlurCheck}
                                                            // errorOccured={itemDescriptionErr}
                                                            // errorMessage={'Please add description'}
                                                            />

                                                            <div className="row mx-0 mt-2">
                                                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                                    <PrimaryButton
                                                                        buttonName={"SAVE"}
                                                                        onClick={(e) => {
                                                                            if (!isShoppingItemEdit) {
                                                                                handleSubmitPurchase(e);
                                                                            } else {
                                                                                handleUpdatePurchase(e);
                                                                            }
                                                                        }}
                                                                        isLoading={purchaseLoading}
                                                                        loadingMessage={"LOADING..."}
                                                                        style={{
                                                                            width: '100%',
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </form>


                                                    {/* <div className="row mx-0 mt-2">
                                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                            <PrimaryButton
                                                                buttonName={`ADD SHOPPING ITEM`}
                                                                onClick={() => { setToggleForShoppingListDIY(2) }}
                                                                style={{
                                                                    width: '100%',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </div>
                                                    </div> */}


                                                </> :
                                                // Delete shopping list
                                                toggleForShoppingListDIY === 3 ?
                                                    <>
                                                        <div className="row mx-0 mb-4">
                                                            <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                                <span className="">
                                                                    {"Are you sure to delete shopping item"}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                        <span className="fs-5">
                                            {"Are you sure you want to delete this suggestion?"}
                                        </span>
                                    </div>
                                </div> */}

                                                        <>
                                                            <div className="row mx-0 text-black lh-lg">
                                                                <div className="col-6 px-0 font-w600">
                                                                    <span>{"Item Name"}</span>
                                                                </div>
                                                                <div className="col-6 px-0">
                                                                    <span>{itemName}</span>
                                                                </div>
                                                            </div>

                                                            {quantity && (
                                                                <div className="row mx-0 text-black lh-lg">
                                                                    <div className="col-6 px-0 font-w600">
                                                                        <span>{"Quantity"}</span>
                                                                    </div>
                                                                    <div className="col-6 px-0">
                                                                        <span>{quantity}</span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {totalEstimatedCost && (
                                                                <div className="row mx-0 text-black lh-lg">
                                                                    <div className="col-6 px-0 font-w600">
                                                                        <span>{"Total Estimated Cost"}</span>
                                                                    </div>
                                                                    <div className="col-6 px-0">
                                                                        <span>{`$ ${totalEstimatedCost.toFixed(2)}`}</span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {itemDescription && (
                                                                <div className="row mx-0 text-black lh-lg">
                                                                    <div className="col-6 px-0 font-w600">
                                                                        <span>{"Item Description"}</span>
                                                                    </div>
                                                                    <div className="col-6 px-0">
                                                                        <span>{itemDescription}</span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {purchaseLink && (
                                                                <div className="row mx-0 text-black lh-lg">
                                                                    <div className="col-6 px-0 font-w600">
                                                                        {urlPattern.test(purchaseLink) ?
                                                                            <span>{"Website"}</span> :
                                                                            <span>{"Location"}</span>
                                                                        }

                                                                    </div>
                                                                    <div className="col-6 px-0 overflow-hidden">
                                                                        {urlPattern.test(purchaseLink) ?
                                                                            <a
                                                                                className="text-black text-hovered text-decoration-underline"
                                                                                href={purchaseLink}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                                style={{ wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word' }}
                                                                            >
                                                                                <span>{purchaseLink}</span>
                                                                            </a> :
                                                                            <span>{purchaseLink}</span>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="col-12 font-w600 mt-3">

                                                                <PrimaryButton
                                                                    onClick={(e) => handleDeletePurchaseList('', e)}
                                                                    buttonName={"YES, DELETE IT"}
                                                                    loadingMessage={"DELETING..."}
                                                                    isLoading={purchaseLoading}
                                                                    style={{
                                                                        width: "100%",
                                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                        border: '1px solid rgba(240, 72, 72, 1)',
                                                                        fontWeight: '600',
                                                                    }}
                                                                />

                                                            </div>




                                                        </>

                                                        {/* <div className="row mx-0 mt-2">
                                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                        <PrimaryButton
                                                            buttonName={`ADD SHOPPING ITEM`}
                                                            onClick={() => { setToggleForShoppingListDIY(2) }}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>
                                                </div> */}


                                                    </> :
                                                    <></>
                                        }
                                    </> :
                                    // Notes here
                                    toggleForSavedProjectSuggestions === 3 ?
                                        <>
                                            {/* Notes list */}
                                            {toggleForNotesDIY === 1 ?
                                                <>
                                                    <div className="row mx-0 mb-3">
                                                        <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                            <span className="">{"Notes"}</span>
                                                        </div>
                                                    </div>

                                                    {/* <div className="row mx-0 mt-3 pb-2">
                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                            <span className="fs-5">
                                                {"Are you sure you want to delete this suggestion?"}
                                            </span>
                                        </div>
                                    </div> */}



                                                    {particularProjectSuggestionObj?.call_log_notes?.length > 0 ?
                                                        <>
                                                            <div
                                                                className='w-100 overflow-auto'
                                                                style={{ maxHeight: '60dvh' }}
                                                            >
                                                                {particularProjectSuggestionObj?.call_log_notes?.map((element, index) => {
                                                                    return (
                                                                        <>
                                                                            <div key={index} className='row  fs-6 border-bottom p-4 rounded-3 rounded-3 bg-light mb-2'>
                                                                                <div className='col-12 px-0 d-flex'>

                                                                                    <div className='pe-3 d-flex justify-content-center'>
                                                                                        <div>
                                                                                            <div className='rounded-2 shadow-lg'>
                                                                                                <div
                                                                                                    className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                                    style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                                                                >
                                                                                                    {element?.preferred_profile_picture_url ?
                                                                                                        <img src={element?.preferred_profile_picture_url} alt="Avatar" className="rounded-2" style={{ height: '40px', width: '40px' }} /> :
                                                                                                        <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className='w-100'>
                                                                                        <div className='row mx-0 mb-1'>
                                                                                            <div className='col-9 px-0  font-w500 '>
                                                                                                {/* <span className='text-black pe-2'>{`${element?.created_by_name}`}</span> */}
                                                                                                <div className='d-flex flex-column'>
                                                                                                    <span className='fs-7 text-black font-w600'>
                                                                                                        {/* {`${formatUnixTimestamp(element?.created_date_dtm)}`} */}
                                                                                                        {new Intl.DateTimeFormat("en-US", {
                                                                                                            year: "numeric",
                                                                                                            month: "short",
                                                                                                            day: "numeric",
                                                                                                            hour: 'numeric',
                                                                                                            minute: 'numeric',
                                                                                                            hour12: true
                                                                                                        }).format(
                                                                                                            element?.created_date_dtm * 1000
                                                                                                        )}
                                                                                                    </span>

                                                                                                    {element?.note_type_chr !== "Notes" && <span className='fs-7'>
                                                                                                        <strong>{`Source: `}</strong> {`${element?.note_type_chr || ''}`}
                                                                                                    </span>}
                                                                                                </div>

                                                                                            </div>

                                                                                            <div className='col-3 px-0 d-flex justify-content-end'>
                                                                                                <span
                                                                                                    className='text-danger me-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                    style={{ height: '25px', width: '25px' }}
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        setNoteObject(element);
                                                                                                        setToggleForNotesDIY(3);
                                                                                                    }}
                                                                                                >
                                                                                                    <i className={`bi bi-trash3-fill`} style={{ fontSize: '14px' }}></i>
                                                                                                </span>

                                                                                                {/* <span className=' text-black'>
                                                                                                    <OverlayTrigger
                                                                                                        key={index}
                                                                                                        trigger="click"
                                                                                                        placement="bottom"
                                                                                                        // overlay={popover}
                                                                                                        overlay={popoverNoteActions(index)}
                                                                                                        rootClose={true}
                                                                                                        show={activePopoverNotes === index}
                                                                                                        onToggle={(show) =>
                                                                                                            setActivePopoverNotes(
                                                                                                                show ? index : null
                                                                                                            )
                                                                                                        }>
                                                                                                        <i
                                                                                                            onClick={() => handleMenuClickNotes(element, index)}
                                                                                                            className="bi bi-three-dots-vertical cursor-pointer text-hovered"
                                                                                                        ></i>
                                                                                                    </OverlayTrigger>
                                                                                                </span> */}
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='row mx-0 mb-1'>
                                                                                            <div className='col-12 px-0 d-flex justify-content-start font-w500 flex-column'>

                                                                                                <span className=''>
                                                                                                    {`${element?.note_chr || ''}`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className='row mx-0 mb-1'>
                                                                                            <div
                                                                                                className='col-12 px-0 d-flex '
                                                                                                style={{ overflow: 'auto', }}
                                                                                            >
                                                                                                {element?.attachment_url?.map((elem, ind) => {
                                                                                                    return (
                                                                                                        <span className='call-notes-individual-img-download-span' key={index}>

                                                                                                            <img
                                                                                                                className='call-notes-individual-img-download'
                                                                                                                src={elem}
                                                                                                                alt='Error'
                                                                                                                title='Download'
                                                                                                                onClick={() => {
                                                                                                                    handleOpenDoc();
                                                                                                                    setImageAttachURL(elem);
                                                                                                                    setNotesMessage(element?.note_chr);
                                                                                                                }}
                                                                                                                style={{ cursor: 'pointer' }}
                                                                                                            />

                                                                                                        </span>
                                                                                                    )
                                                                                                })}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })}
                                                            </div>
                                                        </> :
                                                        <>
                                                            <div className="mb-3 mt-4 d-flex justify-content-center align-items-center flex-column">
                                                                <div className="mb-2">
                                                                    <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                                                </div>
                                                                <span>
                                                                    {`No notes added yet`}
                                                                </span>
                                                            </div>
                                                        </>
                                                    }

                                                    <div className="row mx-0 mt-2">
                                                        <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                            <PrimaryButton
                                                                buttonName={`ADD NOTE`}
                                                                onClick={() => { setToggleForNotesDIY(2) }}
                                                                style={{
                                                                    width: '100%',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* <div className="row mx-0 text-black mt-2">
                                        <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                                            <PrimaryButton
                                                onClick={(e) => handleCloseProjectSuggestionsModal()}
                                                buttonName={"NO, GO BACK"}
                                                style={{
                                                    width: "100%",
                                                    backgroundColor: "white",
                                                    border: "1px solid grey",
                                                    color: "black",
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>


                                        <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                                            <PrimaryButton
                                                onClick={(e) => handleDeleteProjectSuggestionFn()}
                                                buttonName={"YES, DELETE IT"}
                                                loadingMessage={"DELETING..."}
                                                isLoading={deleteProjectSuggestionLoading}
                                                style={{
                                                    width: "100%",
                                                    backgroundColor: "red",
                                                    border: "none",
                                                    fontWeight: '600',
                                                }}
                                            />

                                        </div>
                                    </div> */}
                                                </> :
                                                // Add Edit shopping list
                                                toggleForNotesDIY === 2 ?
                                                    <>
                                                        <div className="row mx-0 mb-3">
                                                            <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                                <span className="">
                                                                    {"Add note"}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                        <span className="fs-5">
                                            {"Are you sure you want to delete this suggestion?"}
                                        </span>
                                    </div>
                                </div> */}
                                                        <form
                                                            onSubmit={(e) => {

                                                            }}
                                                        >
                                                            <div className="px-3 my-2 mt-3">
                                                                <div className=''>

                                                                    <div className='row mx-0 mt-1 '>

                                                                        {/* <div className='col-1 pe-2 d-flex justify-content-center pt-3 cursor-pointer text-hovered'>
                                                                            <div className="tooltipCustom">
                                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Attachemts"}</span>
                                                                                <i onClick={() => handleAttach()} className='bi bi-paperclip fs-3'></i>
                                                                            </div>
                                                                            <input
                                                                                accept="image/*"
                                                                                type="file"
                                                                                multiple
                                                                                style={{ display: "none" }}
                                                                                ref={hiddenFileInput}
                                                                                onChange={(e) => {
                                                                                    inputFileTarget(e);
                                                                                }}
                                                                            />
                                                                        </div> */}

                                                                        <div className='col-12 pt-1'>
                                                                            {/* <InputField
                                                                                labelName={`Message`}
                                                                                value={discussionVal}
                                                                                onChange={discussionOnChange}
                                                                                onBlur={() => { }}
                                                                            // errorOccured={itemDescriptionErr}
                                                                            // errorMessage={'Please add description'}
                                                                            /> */}

                                                                            <TextArea
                                                                                labelName={"Message"}
                                                                                placeholder={"Message"}
                                                                                value={discussionVal}
                                                                                onChange={discussionOnChange}
                                                                                onBlur={() => { }}
                                                                            // onBlur={handleDescriptionBlurCheck}
                                                                            // errorOccured={itemDescriptionErr}
                                                                            // errorMessage={'Please add description'}
                                                                            />
                                                                        </div>

                                                                    </div>

                                                                    <div className='row mx-0 mb-2'>
                                                                        <div className='col-12 px-0'>
                                                                            <span
                                                                                className='font-w600 cursor-pointer text-hovered'
                                                                                onClick={() => handleAttach()}
                                                                            >
                                                                                {`Attachments`}
                                                                            </span>

                                                                            <input
                                                                                accept="image/*"
                                                                                type="file"
                                                                                multiple
                                                                                style={{ display: "none" }}
                                                                                ref={hiddenFileInput}
                                                                                onChange={(e) => {
                                                                                    inputFileTarget(e);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className='row mx-0 mb-2'>
                                                                        <div className='col-12 px-0'>
                                                                            <div className='text-danger'>
                                                                                <span>{selectedFileLimit}</span>
                                                                            </div>

                                                                            <div className='attachment-img-preview-bar justify-content-start mb-3'>
                                                                                {selectedFile?.map((previewFile, index) => {
                                                                                    return (
                                                                                        <span key={index} className='attachment-img-preview-span'>
                                                                                            <i onClick={() => deleteUpload(index)} class="bi bi-x-circle attachment-img-preview-delete-icon"></i>
                                                                                            <img
                                                                                                style={{ width: '40px', height: '50px', borderRadius: '5px' }}
                                                                                                src={previewFile ? URL.createObjectURL(previewFile) : null}
                                                                                                alt='Error'
                                                                                            />
                                                                                        </span>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className='row mx-0'>
                                                                        <div
                                                                            className='col-12'
                                                                            style={{
                                                                                pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                                                opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                                                            }}
                                                                        >

                                                                            <PrimaryButton
                                                                                buttonName={`SAVE`}
                                                                                onClick={() => { handleSaveDiscussion() }}
                                                                                loadingMessage={"SAVING..."}
                                                                                isLoading={saveLoading}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                {/* <div className="row mx-0 mt-2">
                                                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                                        <PrimaryButton
                                                                            buttonName={"SUBMIT"}
                                                                            onClick={(e) => {

                                                                            }}
                                                                            isLoading={purchaseLoading}
                                                                            loadingMessage={"LOADING..."}
                                                                            style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div> */}

                                                            </div>
                                                        </form>


                                                        {/* <div className="row mx-0 mt-2">
                                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                        <PrimaryButton
                                                            buttonName={`ADD SHOPPING ITEM`}
                                                            onClick={() => { setToggleForShoppingListDIY(2) }}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>
                                                </div> */}


                                                    </> :
                                                    // Delete shopping list
                                                    toggleForNotesDIY === 3 ?
                                                        <>
                                                            <div className="row mx-0 mb-4">
                                                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                                    <span className="">
                                                                        {"Delete note"}
                                                                    </span>
                                                                </div>
                                                            </div>



                                                            <div className="row mx-0 mt-3 pb-2">
                                                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                                    <span className="fs-5">
                                                                        {"Are you sure you want to delete this note?"}
                                                                    </span>
                                                                </div>
                                                            </div>


                                                            <div className="col-12 font-w600 mt-3">

                                                                <PrimaryButton
                                                                    onClick={(e) => handleDeleteNote(noteObject, e)}
                                                                    buttonName={"YES, DELETE IT"}
                                                                    loadingMessage={"Deleting..."}
                                                                    isLoading={saveLoading}
                                                                    style={{
                                                                        width: "100%",
                                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                        border: '1px solid rgba(240, 72, 72, 1)',
                                                                    }}
                                                                />

                                                            </div>

                                                        </> :
                                                        <></>
                                            }
                                        </> : <></>

                            }



                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for project notes operations */}
            <Modal
                className="fade"
                show={modalTriggerProjectNotes}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseProjectNotesModal()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <>
                                {toggleForProjectNotes === 1 ? <>
                                    <div className="row mx-0 mb-3">
                                        <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                            <span className="">
                                                {"Add note"}
                                            </span>
                                        </div>
                                    </div>

                                    {/* <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                        <span className="fs-5">
                                            {"Are you sure you want to delete this suggestion?"}
                                        </span>
                                    </div>
                                </div> */}
                                    <form
                                        onSubmit={(e) => {
                                            if (Object.keys(noteObject).length > 0) {
                                                handleUpdateProjectNotes(e);
                                            } else {
                                                handleSaveProjectNotes(e);
                                            }
                                        }}
                                    >
                                        <div className="px-3 my-2 mt-3">
                                            <div className=''>

                                                <div className='row mx-0 mt-1 '>


                                                    <div className='col-12 pt-1'>
                                                        {/* <InputField
                                                                                labelName={`Message`}
                                                                                value={discussionVal}
                                                                                onChange={discussionOnChange}
                                                                                onBlur={() => { }}
                                                                            // errorOccured={itemDescriptionErr}
                                                                            // errorMessage={'Please add description'}
                                                                            /> */}

                                                        <TextArea
                                                            labelName={"Note"}
                                                            placeholder={"Note"}
                                                            value={discussionVal}
                                                            onChange={discussionOnChange}
                                                            onBlur={() => { }}
                                                        // onBlur={handleDescriptionBlurCheck}
                                                        // errorOccured={itemDescriptionErr}
                                                        // errorMessage={'Please add description'}
                                                        />
                                                    </div>

                                                </div>

                                                <div className='row mx-0 mb-2'>
                                                    <div className='col-12 px-0'>
                                                        <span
                                                            className='font-w600 cursor-pointer text-hovered'
                                                            onClick={() => handleAttach()}
                                                        >
                                                            {`Attachments`}
                                                        </span>

                                                        <input
                                                            accept="image/*"
                                                            type="file"
                                                            multiple
                                                            style={{ display: "none" }}
                                                            ref={hiddenFileInput}
                                                            onChange={(e) => {
                                                                inputFileTarget(e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='row mx-0 mb-2'>
                                                    <div className='col-12 px-0'>
                                                        <div className='text-danger'>
                                                            <span>{selectedFileLimit}</span>
                                                        </div>

                                                        <div className='attachment-img-preview-bar justify-content-start mb-3'>
                                                            {selectedFile?.map((previewFile, index) => {
                                                                return (
                                                                    <span key={index} className='attachment-img-preview-span'>
                                                                        <i onClick={() => deleteUpload(index)} class="bi bi-x-circle attachment-img-preview-delete-icon"></i>
                                                                        <img
                                                                            style={{ width: '40px', height: '50px', borderRadius: '5px' }}
                                                                            src={previewFile ? URL.createObjectURL(previewFile) : null}
                                                                            alt='Error'
                                                                        />
                                                                    </span>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mx-0'>
                                                    <div
                                                        className='col-12'
                                                        style={{
                                                            pointerEvents: (selectedFile.length > 0 || discussionVal !== "") ? 'auto' : 'none',
                                                            opacity: (selectedFile.length > 0 || discussionVal !== "") ? '1' : '0.5',
                                                        }}
                                                    >

                                                        <PrimaryButton
                                                            buttonName={`SAVE`}
                                                            onClick={(e) => {
                                                                if (Object.keys(noteObject).length > 0) {
                                                                    handleUpdateProjectNotes(e);
                                                                } else {
                                                                    handleSaveProjectNotes(e);
                                                                }
                                                            }}
                                                            loadingMessage={"SAVING..."}
                                                            isLoading={saveLoading}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                            {/* <div className="row mx-0 mt-2">
                                                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                                        <PrimaryButton
                                                                            buttonName={"SUBMIT"}
                                                                            onClick={(e) => {

                                                                            }}
                                                                            isLoading={purchaseLoading}
                                                                            loadingMessage={"LOADING..."}
                                                                            style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div> */}

                                        </div>
                                    </form>


                                    {/* <div className="row mx-0 mt-2">
                                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                        <PrimaryButton
                                                            buttonName={`ADD SHOPPING ITEM`}
                                                            onClick={() => { setToggleForShoppingListDIY(2) }}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>
                                                </div> */}


                                </> :
                                    toggleForProjectNotes === 2 ?
                                        <>
                                            <div className="row mx-0 mb-3">
                                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                    <span className="text-center">{"Note"}</span>
                                                </div>
                                            </div>

                                            <div className="row mx-0 mt-3 pb-2">
                                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                    <span className="fs-5 text-center">
                                                        {noteObject?.note_chr}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="row mx-0 text-black mt-2">
                                                <div className="col-12 font-w600 mb-2">
                                                    <PrimaryButton
                                                        onClick={(e) => handleCloseProjectNotesModal()}
                                                        buttonName={"CLOSE"}
                                                        style={{
                                                            width: "100%",
                                                            backgroundColor: "white",
                                                            border: "1px solid grey",
                                                            color: "black",
                                                            fontWeight: '600',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </> : <></>
                                }
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for project operations */}
            <Modal
                className="fade"
                show={modalTriggerProjects}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseProjectsModal()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            {/* Delete project */}
                            <>
                                <div className="row mx-0 mb-3">
                                    <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                        <span className="">{"Delete project"}</span>
                                    </div>
                                </div>

                                <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                        <span className="fs-5">
                                            {"Are you sure you want to delete this project?"}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 text-black mt-2">
                                    <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                                        <PrimaryButton
                                            onClick={(e) => handleCloseProjectsModal()}
                                            buttonName={"NO, GO BACK"}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: "1px solid grey",
                                                color: "black",
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>


                                    <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                                        <PrimaryButton
                                            onClick={(e) => handleDeleteProjectDeatilFn()}
                                            buttonName={"YES, DELETE IT"}
                                            loadingMessage={"DELETING..."}
                                            isLoading={deleteProjectLoading}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                border: '1px solid rgba(240, 72, 72, 1)',
                                                fontWeight: '600',
                                            }}
                                        />

                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for Add project photo */}
            <Modal
                className="fade"
                show={modalTriggerForAddPhoto}
                // onHide={handleClose}
                centered
                size='sm'
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseModalAddPhoto()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <>
                                <div className="row mx-0 mb-3">
                                    <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                        <span className="">{"Select from"}</span>
                                    </div>
                                </div>

                                <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                        <span className="fs-5 text-center">
                                            {"Select how you want to add photo"}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 text-black mt-2">
                                    <div className="col-6 pe-2 font-w600 mb-2">
                                        <PrimaryButton
                                            onClick={(e) => {
                                                handleClickUploadPicture();
                                                // handleCloseModalAddPhoto();
                                            }}
                                            buttonName={"Gallery"}
                                            isLoading={imgUploadLoading}
                                            loadingMessage={'Loading...'}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: "1px solid grey",
                                                color: "black",
                                                fontWeight: '600',
                                            }}
                                        />

                                        <input
                                            ref={uploadPicRef}
                                            onChange={(e) => {
                                                handleUploadPicture(e);
                                            }}
                                            on
                                            className="form-control"
                                            type="file"
                                            accept="image/*"
                                            hidden
                                        />
                                    </div>


                                    <div className="col-6 ps-2 font-w600 mb-2">

                                        <PrimaryButton
                                            onClick={(e) => {
                                                getCameraStream();
                                                setToggleForAddImage(true);
                                                setToggleForCameraActions(1);

                                                handleCloseModalAddPhoto();
                                            }}
                                            isLoading={imgUploadLoading}
                                            loadingMessage={'Camera'}
                                            buttonName={"Camera"}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: "1px solid grey",
                                                color: "black",
                                                fontWeight: '600',
                                            }}
                                        />


                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal to take confirmation for calling AI suggestions */}
            <Modal
                className="fade"
                show={modalTriggerForCallingAISuggestions}
                // onHide={handleClose}
                centered
                size='sm'
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseModalCallingAISuggestions()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <>
                                {/* <div className="row mx-0 mb-3">
                                    <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                        <span className="">{"Once you change the description, the AI suggestions will be updated. Are you sure you want to proceed?"}</span>
                                    </div>
                                </div> */}

                                <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                        <span className="fs-5 text-center">
                                            {"Once you change the description, the previously saved AI suggestions will be deleted. Are you sure you want to proceed?"}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 text-black mt-3">
                                    <div className="col-6 pe-2 font-w600 mb-2">
                                        <PrimaryButton
                                            onClick={(e) => {
                                                handleCloseModalCallingAISuggestions();
                                            }}
                                            buttonName={"CANCEL"}
                                            isLoading={false}
                                            loadingMessage={'Loading...'}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: "1px solid grey",
                                                color: "black",
                                                fontWeight: '600',
                                            }}
                                        />

                                    </div>


                                    <div className="col-6 ps-2 font-w600 mb-2">

                                        <PrimaryButton
                                            onClick={(e) => {
                                                handleCloseModalCallingAISuggestions();
                                                setConfirmationForAIcall(false);
                                                bulkDeleteProjectStepsFn();
                                            }}
                                            isLoading={false}
                                            loadingMessage={'Loading...'}
                                            buttonName={"CONFIRM"}
                                            style={{
                                                width: '100%',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                fontWeight: '600',
                                            }}
                                        />

                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for save image in notes */}
            <Modal
                size="lg"
                className="fade"
                show={modalTriggerForSaveImageToNotes}
                // onHide={handleClose}
                centered
            >
                <div className="row p-3" style={{ maxHeight: '580px' }}>
                    <div className="col-6 d-flex justify-content-center ">
                        <div
                            className="col-12 px-0"
                            ref={checkHW}
                            style={{ background: "#AAAAAA", position: "relative" }}
                        >
                            {isLoadingImg &&
                                <div
                                    className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                                    style={{
                                        maxWidth: `${imgMaxWidth}px`,
                                        maxHeight: `${imgMaxHeight}px`,
                                        minWidth: `${imgMaxWidth}px`,
                                        minHeight: `${imgMaxHeight}px`,
                                        width: "100%",
                                        height: "100%",
                                    }}
                                >
                                    <Spinner animation="border" size="lg" style={{}} />
                                </div>
                            }

                            <div
                                className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                            >
                                <img
                                    alt=""
                                    className=""
                                    src={imageForOCR}
                                    onLoad={handleImageLoaded}
                                    onError={handleImageError}
                                    style={{
                                        maxWidth: `${imgMaxWidth}px`,
                                        maxHeight: `${imgMaxHeight}px`,
                                        minWidth: `${imgMaxWidth}px`,
                                        minHeight: `${imgMaxHeight}px`,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        transition: 'transform 0.25s ease',
                                        transformOrigin: 'center',
                                        display: isLoadingImg ? 'none' : 'block'
                                    }}
                                />
                            </div>

                            <span
                                style={{ position: "absolute", top: "6px", left: "6px" }}>
                                <span
                                    className="fs-7 px-2 py-1 w-100"
                                    style={{
                                        color: "grey",
                                        background: "white",
                                        borderRadius: "20px",
                                    }}>
                                    Screenshot{" "}
                                </span>
                            </span>
                        </div>
                    </div>

                    <div className="col-6">
                        <div
                            className=" px-0 h-100"
                            style={{ display: "flex", flexDirection: "column" }}>
                            <div className="py-2 px-3">
                                <div className="m-0 row">
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                        <span className="">
                                            <i className="bi bi-x-lg cursor-pointer" onClick={handleCloseModalForSaveImageToNotes}></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="mx-0 row ">
                                    <span className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                        {`Scanned text`}
                                    </span>
                                </div>
                                <div className="mx-0 row mt-3">
                                    <span className=" fs-6 px-0 text-center text-gray text-center">
                                        Text is capured and click on save to notes button to save it to your notes.
                                    </span>
                                </div>
                            </div>
                            <div
                                className="row mx-0 mt-2"
                                style={{ flex: "1", alignItems: "end" }}>
                                <div className="row px-3" style={{ minHeight: "220px" }}>
                                    <div className="col-12 px-0 fs-7  mb-2">
                                        <div className="row m-1">
                                            <div className="row mx-0">
                                                <div className="col-6 d-flex justify-content-start align-items-center fs-7"></div>
                                                <div className="col-6 d-flex justify-content-end align-items-center fs-7"></div>
                                            </div>
                                            <div className="row mx-0">
                                                <div
                                                    className="col-12 d-flex justify-content-start align-items-center fs-6 pt-3"
                                                >
                                                    <div className="col-12 px-0 text-center  ">



                                                        <div>
                                                            <TextArea
                                                                onChange={(e) => setOcrText(e.target.value)}
                                                                value={ocrText}
                                                                labelName={"Text capture"}
                                                                errorMessage={"Please enter note here"}
                                                                errorOccured={false}
                                                            />
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row px-3">
                                    <PrimaryButton
                                        buttonName={"SAVE TO NOTES"}
                                        isLoading={ocrLoading}
                                        loadingMessage={"SAVING TO SUGGESTIONS NOTE..."}
                                        style={{
                                            border: 'none',
                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                        }}
                                        onClick={handleSaveOCRtextToNotes}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Measuring instruction modal */}
            <Modal
                className="fade"
                show={modalTriggerForMeasuringInstruction}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseModalMeasuringInstruction()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="text-center">{"Chilll alert"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-2">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-5 text-center">
                                        {"Measuring feature is avaible on mobile devices. Please download Chilll app from playstore or appstore to use this feature."}
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-12 font-w600 mb-2">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseModalMeasuringInstruction()}
                                        buttonName={"CLOSE"}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            border: "1px solid grey",
                                            color: "black",
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for the showing the terms for the AI suggestions */}
            <Modal
                className="fade"
                show={modalTriggerAIterms}
                onHide={() => setModalTriggerAIterms(false)}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => setModalTriggerAIterms(false)}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="text-center">{"Terms & Conditions"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-2">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-5 text-center">
                                        {"The project steps generated by this application are created using artificial intelligence and are intended for informational and guidance purposes only. While we strive to provide accurate and helpful suggestions, the generated steps may not be complete, precise, or suitable for your specific project. Users should review, modify, and verify the steps before implementation. Chilll DIY Solo and its affiliates are not responsible for any errors, omissions, or issues resulting from reliance on AI-generated project steps. Always use your judgment and consult a professional when necessary."}
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-12 font-w600 mb-2">
                                    <PrimaryButton
                                        onClick={(e) => setModalTriggerAIterms(false)}
                                        buttonName={"CLOSE"}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            border: "1px solid grey",
                                            color: "black",
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal for Deleting the AI chat history*/}
            <Modal
                className="fade"
                show={modalTriggerForDeleteAIChatHistory}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => handleCloseModalDeleteAIChatHistory()}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            {/* Delete project */}
                            <>
                                <div className="row mx-0 mb-3">
                                    <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                        <span className="">{"Delete chat history"}</span>
                                    </div>
                                </div>

                                <div className="row mx-0 mt-3 pb-2">
                                    <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                        <span className="fs-5">
                                            {"Are you sure you want to delete this session?"}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 text-black mt-2">
                                    <div className="col-sm-6 pe-sm-2 font-w600 mb-2">
                                        <PrimaryButton
                                            onClick={(e) => handleCloseModalDeleteAIChatHistory()}
                                            buttonName={"NO, GO BACK"}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: "1px solid grey",
                                                color: "black",
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>


                                    <div className="col-sm-6 ps-sm-2 font-w600 mb-2">

                                        <PrimaryButton
                                            onClick={(e) => handleDeleteAIChatHistoryFn()}
                                            buttonName={"YES, DELETE IT"}
                                            loadingMessage={"DELETING..."}
                                            isLoading={deleteAIChatHistoryLoading}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                border: '1px solid rgba(240, 72, 72, 1)',
                                                fontWeight: '600',
                                            }}
                                        />

                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responseMsg} />}
        </>
    )
}

export default DIYproject